
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("fzDaA", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $16kNn = parcelRequire("16kNn");

// This property enables the intersection observer to be run once the
// HTML element being observed is within `X` px of the target container it is
// being compared to. Since the default container is the `document`, we set this
// up to check once a Smart Link is within `X` px from the bottom of the viewport.
const $fb41cb56e8ed3651$var$ROOT_MARGIN_VERTICAL = '360px';
const $fb41cb56e8ed3651$var$useIntersectionObserver = ({ onIntersecting: onIntersectingCallback, onIntersection: onIntersectionCallback })=>{
    const ref = (0, $cozmU.useRef)(null);
    const onIntersectingCallbackRef = (0, $cozmU.useRef)(onIntersectingCallback);
    const onIntersectionCallbackRef = (0, $cozmU.useRef)(onIntersectionCallback);
    (0, $cozmU.useEffect)(()=>{
        onIntersectingCallbackRef.current = onIntersectingCallback;
        onIntersectionCallbackRef.current = onIntersectionCallback;
    }, [
        onIntersectingCallback,
        onIntersectionCallback
    ]);
    const onIntersection = (0, $cozmU.useCallback)((entries, observer)=>{
        const isIntersecting = entries.some((entry)=>entry.isIntersecting);
        onIntersectionCallbackRef.current?.(isIntersecting);
        if (isIntersecting) {
            onIntersectingCallbackRef.current?.();
            observer.disconnect();
        }
    }, []);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $16kNn.isIntersectionObserverSupported)() || !ref.current) return;
        const intersectionObserver = new IntersectionObserver(onIntersection, {
            rootMargin: `${$fb41cb56e8ed3651$var$ROOT_MARGIN_VERTICAL} 0px ${$fb41cb56e8ed3651$var$ROOT_MARGIN_VERTICAL} 0px`
        });
        intersectionObserver.observe(ref.current);
        return ()=>intersectionObserver.disconnect();
    }, [
        ref,
        onIntersection
    ]);
    return ref;
};
var $fb41cb56e8ed3651$export$2e2bcd8739ae039 = $fb41cb56e8ed3651$var$useIntersectionObserver;
module.exports["default"] = $fb41cb56e8ed3651$export$2e2bcd8739ae039;

});

parcelRegister("4xRBl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $6Vsq4 = parcelRequire("6Vsq4");


var $1smAh = parcelRequire("1smAh");


var $4abK1 = parcelRequire("4abK1");

function $cfe56479f167f818$export$c721b83ca330cb86({ appearance: appearance, children: children, id: id, ui: ui, url: url = '' }) {
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const { getByUrl: getByUrl } = (0, $1smAh.useSmartLinkAnalyticsUtils)();
    const getAnalyticsProps = (0, $cozmU.useCallback)(()=>{
        const isFlexibleUi = (0, $4abK1.isFlexibleUiCard)(children, ui);
        const display = isFlexibleUi ? 'flexible' : appearance;
        return {
            display: display,
            id: id
        };
    }, [
        appearance,
        children,
        id,
        ui
    ]);
    const statusRef = (0, $cozmU.useRef)();
    const analyticsPropsRef = (0, $cozmU.useRef)(null);
    const hasIntersectedRef = (0, $cozmU.useRef)(false);
    const hasFiredSeenRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        analyticsPropsRef.current = getAnalyticsProps();
    }, [
        getAnalyticsProps
    ]);
    const maybeFireSeenEvent = (0, $cozmU.useCallback)(()=>{
        if (!hasFiredSeenRef.current && hasIntersectedRef.current && statusRef.current === 'unauthorized') {
            const payload = getByUrl(url, analyticsPropsRef.current);
            fireEvent('ui.smartLink.seen', payload?.attributes);
            hasFiredSeenRef.current = true;
        }
    }, [
        fireEvent,
        getByUrl,
        url
    ]);
    const onIntersecting = (0, $cozmU.useCallback)(()=>{
        if (hasIntersectedRef.current) return;
        hasIntersectedRef.current = true;
        maybeFireSeenEvent();
    }, [
        maybeFireSeenEvent
    ]);
    const onStatusSettled = (0, $cozmU.useCallback)((status)=>{
        statusRef.current = status;
        maybeFireSeenEvent();
    }, [
        maybeFireSeenEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            onIntersecting: onIntersecting,
            onStatusSettled: onStatusSettled
        }), [
        onIntersecting,
        onStatusSettled
    ]);
}
module.exports["useSmartLinkSeenEvent"] = $cfe56479f167f818$export$c721b83ca330cb86;

});

parcelRegister("lL0wb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $3bb02ff4d0bc6181$var$CardLoaderWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ appearance: appearance, children: children }, ref)=>{
    const Component = appearance === 'inline' ? 'span' : 'div';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
        className: "loader-wrapper",
        ref: ref
    }, children));
});
var $3bb02ff4d0bc6181$export$2e2bcd8739ae039 = $3bb02ff4d0bc6181$var$CardLoaderWrapper;
module.exports["default"] = $3bb02ff4d0bc6181$export$2e2bcd8739ae039;

});

parcelRegister("59u5K", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $8OcYi = parcelRequire("8OcYi");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $fqVYq = parcelRequire("fqVYq");


var $6Vsq4 = parcelRequire("6Vsq4");


var $4yYAm = parcelRequire("4yYAm");





var $cMyWi = parcelRequire("cMyWi");





var $iUTeb = parcelRequire("iUTeb");




const $4cb46df851842e38$export$5d10838c1e539409 = ()=>{
    const context = (0, $cMyWi.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};



var $9ojsk = parcelRequire("9ojsk");


var $9H66G = parcelRequire("9H66G");

function $13cbf7ecf495c2ea$export$9f4e486b1dc3e700(id, url, appearance) {
    const state = (0, $9H66G.useSmartCardState)(url);
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel } = (0, $cMyWi.useSmartLinkContext)();
    const actions = (0, $iUTeb.useSmartCardActions)(id, url);
    const config = (0, $4cb46df851842e38$export$5d10838c1e539409)();
    const renderers = (0, $9ojsk.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $cozmU.useState)(null);
    // Register the current card with appearance hint for optimized ORS response.
    const register = ()=>{
        actions.register((0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization') ? appearance : undefined).catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $cozmU.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        isPreviewRestricted: (0, $iDrrr.fg)('preview_panel_unit_check') ? isPreviewRestricted : undefined,
        openPreviewPanel: openPreviewPanel
    };
}



var $jdqmT = parcelRequire("jdqmT");


var $2Q7sv = parcelRequire("2Q7sv");


var $dz9dk = parcelRequire("dz9dk");


var $hsgLh = parcelRequire("hsgLh");


var $16kNn = parcelRequire("16kNn");

const $5b32e42d109a17bd$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};



var $l1f3f = parcelRequire("l1f3f");


var $1smAh = parcelRequire("1smAh");


var $5C2uB = parcelRequire("5C2uB");


var $4abK1 = parcelRequire("4abK1");


var $98Qqv = parcelRequire("98Qqv");





var $b8pma = parcelRequire("b8pma");







const $e8b011f03e2ed95f$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $cMyWi.useSmartLinkContext)();
    return (0, $cozmU.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};


const $97c57299ded7b56e$export$a019611f39785186 = (shouldControlDataExport = false, response)=>Boolean(shouldControlDataExport && response?.meta?.supportedFeature?.includes('ExportBlocked'));



var $ghw3R = parcelRequire("ghw3R");


var $h1uyX = parcelRequire("h1uyX");





var $lMGh1 = parcelRequire("lMGh1");


var $dM7c5 = parcelRequire("dM7c5");


var $cZnAt = parcelRequire("cZnAt");





var $kSwu1 = parcelRequire("kSwu1");







const $0456bba425094b84$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $4yYAm.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).try_again),
        testId: 'smart-action-try-again'
    });


/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $hekY6 = parcelRequire("hekY6");


var $a3Cph = parcelRequire("a3Cph");


var $bVAqi = parcelRequire("bVAqi");


var $3qg1D = parcelRequire("3qg1D");

var $hSS22 = parcelRequire("hSS22");

var $voDgt = parcelRequire("voDgt");

var $jdA6O = parcelRequire("jdA6O");





var $eeqm3 = parcelRequire("eeqm3");




const $791079cdeeb65697$var$baseTopMetadata = [
    {
        name: (0, $4yYAm.ElementName).ModifiedOn
    },
    {
        name: (0, $4yYAm.ElementName).AttachmentCount
    },
    {
        name: (0, $4yYAm.ElementName).SubscriberCount
    },
    {
        name: (0, $4yYAm.ElementName).VoteCount
    },
    {
        name: (0, $4yYAm.ElementName).DueOn
    },
    {
        name: (0, $4yYAm.ElementName).ReadTime
    }
];
const $791079cdeeb65697$var$baseBottomMetaData = [
    {
        name: (0, $4yYAm.ElementName).ReactCount
    },
    {
        name: (0, $4yYAm.ElementName).CommentCount
    },
    {
        name: (0, $4yYAm.ElementName).ViewCount
    },
    {
        name: (0, $4yYAm.ElementName).Priority
    },
    {
        name: (0, $4yYAm.ElementName).SubTasksProgress
    },
    {
        name: (0, $4yYAm.ElementName).ChecklistProgress
    }
];
const $791079cdeeb65697$export$f87d357259b3b7c8 = (cardDetails)=>{
    const extensionKey = (0, $2Q7sv.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails?.data;
    const defaultTitleMetadata = [
        {
            name: (0, $4yYAm.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $4yYAm.ElementName).AuthorGroup
        },
        {
            name: (0, $4yYAm.ElementName).CreatedBy
        },
        ...$791079cdeeb65697$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $791079cdeeb65697$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $4yYAm.ElementName).LatestCommit
                    },
                    {
                        name: (0, $4yYAm.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $4yYAm.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $eeqm3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $4yYAm.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $4yYAm.ElementName).OwnedBy
                    },
                    ...$791079cdeeb65697$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $4yYAm.ElementName).AppliedToComponentsCount
                    },
                    ...$791079cdeeb65697$var$baseBottomMetaData
                ]
            };
        case 'integration-passionfruit-object-provider':
        case 'mercury-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $eeqm3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $4yYAm.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $4yYAm.ElementName).OwnedBy
                    },
                    ...$791079cdeeb65697$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $4yYAm.ElementName).AppliedToComponentsCount
                    },
                    ...$791079cdeeb65697$var$baseBottomMetaData
                ]
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $eeqm3.extractOwnedBy)(data) ? [
                    {
                        name: (0, $4yYAm.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $4yYAm.ElementName).OwnedBy
                    },
                    ...$791079cdeeb65697$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = data['@type']?.includes('atlassian:Task') ?? false;
            const isJiraPlan = data['atlassian:ownedBy'] ? true : false;
            let topMetadata = [
                {
                    name: (0, $4yYAm.ElementName).AuthorGroup
                },
                {
                    name: (0, $4yYAm.ElementName).CreatedBy
                },
                {
                    name: (0, $4yYAm.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $4yYAm.ElementName).AssignedToGroup
                },
                {
                    name: (0, $4yYAm.ElementName).AssignedTo
                },
                {
                    name: (0, $4yYAm.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan) topMetadata = [
                {
                    name: (0, $4yYAm.ElementName).OwnedByGroup
                },
                {
                    name: (0, $4yYAm.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $4yYAm.ElementName).StoryPoints
                    },
                    {
                        name: (0, $4yYAm.ElementName).Priority
                    },
                    {
                        name: (0, $4yYAm.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $4yYAm.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $4yYAm.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $4yYAm.ElementName).ReactCount
                    },
                    {
                        name: (0, $4yYAm.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $4yYAm.ElementName).CollaboratorGroup
                    },
                    ...$791079cdeeb65697$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        case 'legion-object-provider':
        case 'people-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $4yYAm.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $4yYAm.ElementName).TeamMemberCount
                    },
                    {
                        name: (0, $4yYAm.ElementName).UserAttributes
                    },
                    ...$791079cdeeb65697$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $791079cdeeb65697$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true
};
const $791079cdeeb65697$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $4yYAm.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $4yYAm.SmartLinkSize).Large
};
const $791079cdeeb65697$export$9671929f11bd4ad8 = {
    placement: (0, $4yYAm.MediaPlacement).Right,
    ignoreContainerPadding: true
};


const $e296049f8e718ff9$var$customBlockStyles = null;
const $e296049f8e718ff9$var$titleBlockCss = null;
const $e296049f8e718ff9$var$footerBlockCss = null;
const $e296049f8e718ff9$var$footerBlockSafariStyles = null;
const $e296049f8e718ff9$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url, CompetitorPrompt: CompetitorPrompt })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $cozmU.useMemo)(()=>(0, $a3Cph.browser)(), []);
    return /*#__PURE__*/ $cozmU.createElement((0, $bVAqi.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $791079cdeeb65697$export$22ebf74c8bee4708),
        url: url
    }, /*#__PURE__*/ $cozmU.createElement((0, $jdA6O.default), {
        ...(0, $791079cdeeb65697$export$45bdb4108909a713),
        hideIcon: !!title,
        text: title,
        CompetitorPrompt: CompetitorPrompt,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _2C9dkJ7GSX _0c6yoiM7Tp"
        ])
    }), /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        className: (0, $hekY6.default)([
            "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLchRC _4xdlr0FlnN _0wzsVTdnbC _1xYrcmy7kJ"
        ])
    }, children), showPreview && /*#__PURE__*/ $cozmU.createElement((0, $voDgt.default), (0, $791079cdeeb65697$export$9671929f11bd4ad8)), /*#__PURE__*/ $cozmU.createElement((0, $hSS22.default), {
        actions: actions,
        testId: "smart-block-card-footer",
        className: (0, $hekY6.default)([
            "_0jFU0V9DVM _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLz9WS _4xdlr0FlnN",
            safari && "_0jFU0VN91d"
        ])
    }));
};
var $e296049f8e718ff9$export$2e2bcd8739ae039 = $e296049f8e718ff9$var$UnresolvedView;


/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $772dc4e1baeec1f1$var$flexibleBlockCardStyle = null;
const $772dc4e1baeec1f1$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                "_3rPG7s8fU6 _48rQAxOeNX"
            ])
        }, /*#__PURE__*/ $cozmU.createElement(FlexibleBlockCardView, props));
    };


/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $ef07791dc4abcf0a$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $cozmU.useMemo)(()=>props.onAuthorize ? [
            (0, $0456bba425094b84$export$c527d977b53f7537)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e296049f8e718ff9$export$2e2bcd8739ae039), {
        ...props,
        actions: actions,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
        label: "errored-warning-icon",
        color: "var(--ds-icon-warning, #E06C00)",
        testId: `${testId}-warning-icon`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cZnAt.default), {
        maxLines: 3,
        message: {
            descriptor: (0, $dM7c5.messages).could_not_load_link
        }
    }));
};
const $ef07791dc4abcf0a$var$_default_1 = (0, $772dc4e1baeec1f1$export$36ce1a3a446661ab)($ef07791dc4abcf0a$var$ErroredView);
var $ef07791dc4abcf0a$export$2e2bcd8739ae039 = $ef07791dc4abcf0a$var$_default_1;


/* ForbiddenView.tsx generated by @compiled/babel-plugin v2.0.0 */ 












var $4efpo = parcelRequire("4efpo");


var $hHrlI = parcelRequire("hHrlI");


var $leSBv = parcelRequire("leSBv");


var $gCfXH = parcelRequire("gCfXH");







const $393972733951d863$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $dM7c5.messages)) return (0, $dM7c5.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};



var $8p295 = parcelRequire("8p295");
















const $27b19f6e931b03a4$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $4yYAm.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dM7c5.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });




const $4f2a8e9f717802a0$var$textStyles = null; /**
                          * This view represent a Block Card with the 'Forbidden' status.
                          * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
                          *
                          * @see SmartLinkStatus
                          * @see FlexibleCardProps
                          */ 
const $4f2a8e9f717802a0$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const intl = (0, $kSwu1.useIntl)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState?.details;
    const cardMetadata = details?.meta ?? (0, $8p295.getForbiddenJsonLd)().meta;
    const provider = (0, $hHrlI.extractSmartLinkProvider)(details);
    const providerName = provider?.text || '';
    const messageContext = (0, $cozmU.useMemo)(()=>{
        const hostname = /*#__PURE__*/ $cozmU.createElement("b", null, (0, $gCfXH.default)(url));
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $cozmU.useMemo)(()=>{
        return (0, $leSBv.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $cozmU.useMemo)(()=>{
        const descriptor = (0, $393972733951d863$export$d14c2a6dee946f52)((0, $dM7c5.messages).invalid_permissions, requestAccessContext?.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext?.titleMessageKey
    ]);
    const actions = (0, $cozmU.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $27b19f6e931b03a4$export$59f8830fb5467e35)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $27b19f6e931b03a4$export$59f8830fb5467e35)(action.promise, callToActionMessageKey, messageContext, requestAccessContext?.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $e296049f8e718ff9$export$2e2bcd8739ae039), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
        label: "forbidden-lock-icon",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: `${testId}-lock-icon`
    }), /*#__PURE__*/ $cozmU.createElement((0, $cZnAt.default), {
        maxLines: 3,
        message: {
            descriptor: (0, $393972733951d863$export$d14c2a6dee946f52)((0, $dM7c5.messages).invalid_permissions_description, requestAccessContext?.descriptiveMessageKey),
            values: messageContext
        },
        className: (0, $hekY6.default)([
            "_1UtDYzy7kJ"
        ])
    }));
};
const $4f2a8e9f717802a0$var$_default_1 = (0, $772dc4e1baeec1f1$export$36ce1a3a446661ab)($4f2a8e9f717802a0$var$ForbiddenView);
var $4f2a8e9f717802a0$export$2e2bcd8739ae039 = $4f2a8e9f717802a0$var$_default_1;


/* NotFoundView.tsx generated by @compiled/babel-plugin v2.0.0 */ 






















const $190fb10d746b139d$var$textStyles = null; /**
                          * This view represents a Block Card with a 'Not_Found' status.
                          *
                          * @see SmartLinkStatus
                          * @see FlexibleCardProps
                          */ 
const $190fb10d746b139d$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { cardState: { details: details } } = props;
    const product = (0, $cozmU.useMemo)(()=>{
        const provider = (0, $hHrlI.extractSmartLinkProvider)(details);
        return provider?.text ?? '';
    }, [
        details
    ]);
    const title = (0, $cozmU.useMemo)(()=>intl.formatMessage((0, $dM7c5.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $cozmU.useMemo)(()=>({
            descriptor: (0, $dM7c5.messages).not_found_description
        }), []);
    return /*#__PURE__*/ $cozmU.createElement((0, $e296049f8e718ff9$export$2e2bcd8739ae039), {
        ...props,
        testId: testId,
        title: title
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
        label: "not-found-lock-icon",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: `${testId}-lock-icon`
    }), /*#__PURE__*/ $cozmU.createElement((0, $cZnAt.default), {
        message: description,
        testId: `${testId}-message`,
        maxLines: 3,
        className: (0, $hekY6.default)([
            "_1UtDYzy7kJ"
        ])
    }));
};
const $190fb10d746b139d$var$_default_1 = (0, $772dc4e1baeec1f1$export$36ce1a3a446661ab)($190fb10d746b139d$var$NotFoundView);
var $190fb10d746b139d$export$2e2bcd8739ae039 = $190fb10d746b139d$var$_default_1;


/* ResolvedView.tsx generated by @compiled/babel-plugin v2.0.0 */ 















var $irGZZ = parcelRequire("irGZZ");








var $aflIU = parcelRequire("aflIU");








var $8QLAc = parcelRequire("8QLAc");

const $4faa9ead3d7b0ad3$var$ELIGIBLE_EXTENSION_KEYS = new Set([
    'slack-object-provider',
    'google-object-provider',
    'onedrive-object-provider',
    'github-object-provider',
    'ms-teams-object-provider',
    'gitlab-object-provider',
    'salesforce-object-provider'
]);
/**
 * Returns whether the rovo actions are enabled for the current user and link context.
 *
 * All eligibility criteria are consolidated here:
 * 1. Rovo chat must be enabled for the tenant.
 * 2. The consumer must have opted in via actionOptions.rovoChatAction.optIn.
 * 3. The link must support the RovoActions feature.
 * 4. The extension key must be one of the supported options.
 *
 * The extension key is derived from the card store via the resolved URL,
 * so callers don't need to thread it as a prop.
 */ const $4faa9ead3d7b0ad3$var$useBlockCardRovoAction = (url, actionOptions)=>{
    const { rovoOptions: rovoConfig, product: product } = (0, $8QLAc.default)();
    const isRovoChatEnabled = (0, $aflIU.getIsRovoChatEnabled)(rovoConfig);
    const cardState = (0, $9H66G.useSmartCardState)(url ?? '');
    const extensionKey = (0, $2Q7sv.getExtensionKey)(cardState.details);
    const isRovoChatActionOptedIn = actionOptions?.rovoChatAction?.optIn ?? false;
    return (0, $cozmU.useMemo)(()=>{
        if (!isRovoChatEnabled || !url || !isRovoChatActionOptedIn) return false;
        if (extensionKey && !$4faa9ead3d7b0ad3$var$ELIGIBLE_EXTENSION_KEYS.has(extensionKey)) return false;
        return !!product && product === 'CONFLUENCE';
    }, [
        isRovoChatEnabled,
        extensionKey,
        url,
        isRovoChatActionOptedIn,
        product
    ]);
};
var $4faa9ead3d7b0ad3$export$2e2bcd8739ae039 = $4faa9ead3d7b0ad3$var$useBlockCardRovoAction;






var $edVsK = parcelRequire("edVsK");





var $aKJEB = parcelRequire("aKJEB");

var $i1503 = parcelRequire("i1503");



var $es2gJ = parcelRequire("es2gJ");





const $4ca1983200af5b1b$var$titleBlockCss = null;
const $4ca1983200af5b1b$var$footerBlockCssOld = null;
const $4ca1983200af5b1b$var$footerBlockCss = null;
const $4ca1983200af5b1b$var$footerExtraSpacingCss = null;
const $4ca1983200af5b1b$var$footerBlockSafariStyles = null; /**
                                       * This view represents a Block card that has an 'Resolved' status.
                                       * @see SmartLinkStatus
                                       * @see FlexibleCardProps
                                       */ 
const $4ca1983200af5b1b$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $cozmU.useState)(false);
    const extensionKey = (0, $2Q7sv.getExtensionKey)(cardState.details);
    const is3PRovoBlockRovoActionEnabled = (0, $4faa9ead3d7b0ad3$export$2e2bcd8739ae039)(url, actionOptions);
    const rovoConfig = (0, $8QLAc.default)(); // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $cozmU.useMemo)(()=>(0, $a3Cph.browser)(), []);
    (0, $cozmU.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $791079cdeeb65697$export$f87d357259b3b7c8)(cardState.details);
    const prompts = (0, $cozmU.useMemo)(()=>{
        if (is3PRovoBlockRovoActionEnabled) {
            const defaultPrompts = [
                (0, $edVsK.RovoChatPromptKey).KEY_HIGHLIGHTS
            ];
            const linkType = cardState.details?.data?.['@type'];
            if (extensionKey === 'slack-object-provider') return [
                (0, $edVsK.RovoChatPromptKey).FIND_OPEN_QUESTIONS,
                ...defaultPrompts
            ];
            if (extensionKey === 'google-object-provider' && linkType?.includes('schema:PresentationDigitalDocument')) return [
                (0, $edVsK.RovoChatPromptKey).IDENTIFY_KEY_POINTS,
                ...defaultPrompts
            ];
            if (extensionKey === 'google-object-provider' && linkType?.includes('schema:SpreadsheetDigitalDocument')) return [
                (0, $edVsK.RovoChatPromptKey).IDENTIFY_KEY_TRENDS,
                ...defaultPrompts
            ];
            return [
                (0, $edVsK.RovoChatPromptKey).SUMMARIZE_LINK,
                ...defaultPrompts
            ];
        }
        return [];
    }, [
        cardState?.details?.data,
        extensionKey,
        is3PRovoBlockRovoActionEnabled
    ]);
    const footerActions = (0, $cozmU.useMemo)(()=>{
        const showRovoResolvedView = cardState?.status === 'resolved' && cardState.details && (0, $irGZZ.default)({
            response: cardState.details,
            rovoConfig: rovoConfig,
            actionOptions: actionOptions
        }) !== undefined;
        return showRovoResolvedView && is3PRovoBlockRovoActionEnabled ? [
            {
                name: (0, $4yYAm.ActionName).RovoChatAction,
                prompts: prompts,
                iconSize: 'small',
                cardAppearance: (0, $4yYAm.CardDisplay).Block
            },
            {
                name: (0, $4yYAm.ActionName).FollowAction,
                iconSize: 'small'
            },
            {
                name: (0, $4yYAm.ActionName).DownloadAction,
                iconSize: 'small'
            }
        ] : [
            {
                name: (0, $4yYAm.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $4yYAm.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $4yYAm.ActionName).DownloadAction,
                hideIcon: true
            }
        ];
    }, [
        prompts,
        is3PRovoBlockRovoActionEnabled,
        cardState,
        rovoConfig,
        actionOptions
    ]);
    const uiOptions = (0, $791079cdeeb65697$export$22ebf74c8bee4708);
    uiOptions.enableSnippetRenderer = true;
    uiOptions.hideLoadingSkeleton = hideIconLoadingSkeleton;
    return /*#__PURE__*/ $cozmU.createElement((0, $bVAqi.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: uiOptions,
        url: url
    }, /*#__PURE__*/ $cozmU.createElement((0, $jdA6O.default), {
        ...(0, $791079cdeeb65697$export$45bdb4108909a713),
        metadata: titleMetadata,
        subtitle: [
            {
                name: (0, $4yYAm.ElementName).Location
            }
        ],
        metadataPosition: (0, $4yYAm.SmartLinkPosition).Top,
        CompetitorPrompt: CompetitorPrompt,
        url: url,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        className: (0, $hekY6.default)([
            "_2mHwu82ADO _2C9dkJ7GSX _0c6yoiM7Tp"
        ])
    }), /*#__PURE__*/ $cozmU.createElement((0, $i1503.default), {
        primary: topMetadata,
        maxLines: 1
    }), /*#__PURE__*/ $cozmU.createElement((0, $es2gJ.default), null), /*#__PURE__*/ $cozmU.createElement((0, $i1503.default), {
        primary: bottomMetadata,
        maxLines: 1
    }), !isPreviewBlockErrored ? /*#__PURE__*/ $cozmU.createElement((0, $voDgt.default), {
        ...(0, $791079cdeeb65697$export$9671929f11bd4ad8),
        onError: ()=>{
            setIsPreviewBlockErrored(true);
        }
    }) : null, /*#__PURE__*/ $cozmU.createElement((0, $aKJEB.default), {
        actions: footerActions,
        isPreviewBlockErrored: isPreviewBlockErrored,
        className: (0, $hekY6.default)([
            (0, $iDrrr.fg)('navx-5343-sl-action-block-styling-fixes') ? "_0jFU0VfFOW _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLz9WS _4xdlr0FlnN" : "_0jFU0V9DVM _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLz9WS _4xdlr0FlnN",
            safari && "_0jFU0VN91d",
            (0, $iDrrr.fg)('platform_navx_block_card_footer_spacing') && "_3138422ADO"
        ])
    }));
};
const $4ca1983200af5b1b$var$_default_1 = (0, $772dc4e1baeec1f1$export$36ce1a3a446661ab)($4ca1983200af5b1b$var$ResolvedView);
var $4ca1983200af5b1b$export$2e2bcd8739ae039 = $4ca1983200af5b1b$var$_default_1;


/* UnauthorisedView.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $6cFsl = parcelRequire("6cFsl");


var $gBjHb = parcelRequire("gBjHb");








var $rECdA = parcelRequire("rECdA");


var $iMnC5 = parcelRequire("iMnC5");











var $9PA4G = parcelRequire("9PA4G");











var $fLtAn = parcelRequire("fLtAn");


var $8Mlyd = parcelRequire("8Mlyd");










const $9fb3090db1207824$var$NOT_ENABLED_RESULT = {
    connectedPct: undefined,
    isEnabled: false,
    isLoading: false
};
/**
 * Cache-first social proof hook.
 *
 * On mount:
 * 1. Reads localStorage synchronously via `getProviderPctMapSync`.
 *    - If data exists (warm cache): sets `providerPctMap` immediately, `isLoading = false`.
 *    - If no data (cold cache): leaves `providerPctMap` undefined, `isLoading = false`.
 * 2. Always kicks off an async fetch (fire-and-forget) via `getProviderPctMap` to populate
 *    localStorage for next page load. Does NOT update state with the async result.
 *
 * This means:
 * - First page visit (cold): no social proof rendered, no experiment exposure fired.
 *   Background fetch populates localStorage for next time.
 * - Second page visit (warm): social proof renders immediately from localStorage.
 *   Background refresh keeps localStorage fresh.
 *
 * Callers decide separately (e.g. via Statsig experiment) whether to surface the data.
 */ const $9fb3090db1207824$var$useSocialProof = (extensionKey, isKillswitchOn = false, baseUriWithNoTrailingSlash = '')=>{
    const isEnabled = isKillswitchOn;
    const [snapshot] = (0, $cozmU.useState)(()=>{
        if (!isEnabled) return {
            cloudId: undefined,
            providerPctMap: null
        };
        const cloudId = (0, $fLtAn.getCurrentSiteCloudIdSync)(baseUriWithNoTrailingSlash);
        return {
            cloudId: cloudId,
            providerPctMap: (0, $8Mlyd.getProviderPctMapSync)(cloudId, (0, $8Mlyd.SOCIAL_PROOF_TRAIT_NAME))
        };
    });
    // Fire-and-forget: warm caches for future mounts only. Never update this mount's treatment UI.
    (0, $cozmU.useEffect)(()=>{
        if (!isEnabled) return;
        (0, $fLtAn.getCurrentSiteCloudId)(baseUriWithNoTrailingSlash).then((cloudId)=>{
            (0, $8Mlyd.getProviderPctMap)(cloudId, (0, $8Mlyd.SOCIAL_PROOF_TRAIT_NAME));
        });
    }, [
        baseUriWithNoTrailingSlash,
        isEnabled
    ]);
    return (0, $cozmU.useMemo)(()=>{
        if (!isEnabled) return $9fb3090db1207824$var$NOT_ENABLED_RESULT;
        return {
            connectedPct: extensionKey && snapshot.providerPctMap ? snapshot.providerPctMap[extensionKey] : undefined,
            isEnabled: Boolean(snapshot.cloudId && snapshot.providerPctMap),
            isLoading: false
        };
    }, [
        extensionKey,
        isEnabled,
        snapshot
    ]);
};
var $9fb3090db1207824$export$2e2bcd8739ae039 = $9fb3090db1207824$var$useSocialProof;


const $593a61648c304682$export$4d1c9f059e1da2cc = 'social_proof_3p_unauth_block_exp';
const $593a61648c304682$export$9f0628890f2ea4ef = 'platform_sl_3p_preauth_social_proof_inline_cta';
const $593a61648c304682$export$e85fe820223563f3 = 30;
const $593a61648c304682$export$adbe2edcab243434 = (connectedPct)=>{
    if (connectedPct === undefined) return undefined;
    return connectedPct >= $593a61648c304682$export$e85fe820223563f3 ? 'not-low' : 'low';
};
const $593a61648c304682$var$getSocialProofExperimentMetadata = ({ extensionKey: extensionKey, baseUriWithNoTrailingSlash: baseUriWithNoTrailingSlash = '' })=>{
    if (!extensionKey) return {
        isEligible: false
    };
    const cloudId = (0, $fLtAn.getCurrentSiteCloudIdSync)(baseUriWithNoTrailingSlash);
    const providerPctMap = (0, $8Mlyd.getProviderPctMapSync)(cloudId, (0, $8Mlyd.SOCIAL_PROOF_TRAIT_NAME));
    const tier = $593a61648c304682$export$adbe2edcab243434(providerPctMap?.[extensionKey]);
    return {
        isEligible: tier !== undefined,
        ...tier ? {
            tier: tier
        } : {}
    };
};
const $593a61648c304682$export$49fab64ef7e3aab7 = (params)=>({
        [$593a61648c304682$export$4d1c9f059e1da2cc]: $593a61648c304682$var$getSocialProofExperimentMetadata(params)
    });
const $593a61648c304682$export$e53e13aaa7d7b805 = (params)=>({
        [$593a61648c304682$export$9f0628890f2ea4ef]: $593a61648c304682$var$getSocialProofExperimentMetadata(params)
    });
/**
 * Returns enrollment and treatment state for the social proof unauth block card experiment.
 *
 * Delegates data-fetching to `useSocialProof` (Sasha's shared service layer),
 * which handles cloudId resolution, TAP trait fetch, localStorage caching,
 * request deduping, and sync reads.
 *
 * This hook adds the experiment/cohort layer on top:
 * - Only fires exposure (via editorExperiment) when data has loaded.
 * - Derives `tier` and `isTreatment` for rendering decisions.
 *
 * Expected to be called only inside the fg-enabled branch (via componentWithFG).
 *
 * @param extensionKey - The extensionKey of the current 3P provider (e.g. 'google-object-provider').
 */ const $593a61648c304682$var$useSocialProofExperiment = (extensionKey, baseUriWithNoTrailingSlash = '')=>{
    const { connectedPct: connectedPct, isEnabled: isEnabled, isLoading: isLoading } = (0, $9fb3090db1207824$export$2e2bcd8739ae039)(extensionKey, true, baseUriWithNoTrailingSlash);
    return (0, $cozmU.useMemo)(()=>{
        const hasSocialProofData = connectedPct !== undefined;
        // Only fire exposure when data has loaded (prevents exposure inflation)
        const isTreatment = isEnabled && !isLoading && hasSocialProofData ? (0, $ieeJu.expValEquals)($593a61648c304682$export$4d1c9f059e1da2cc, 'isEnabled', true) : false;
        const tier = $593a61648c304682$export$adbe2edcab243434(connectedPct) ?? 'low';
        return {
            isTreatment: isTreatment,
            tier: tier,
            connectedPct: connectedPct,
            isLoading: isLoading
        };
    }, [
        isEnabled,
        isLoading,
        connectedPct
    ]);
};
var $593a61648c304682$export$2e2bcd8739ae039 = $593a61648c304682$var$useSocialProofExperiment;



var $4bvRC = parcelRequire("4bvRC");





var $3M4EV = parcelRequire("3M4EV");





var $knKT4 = parcelRequire("knKT4");


var $1xR0T = parcelRequire("1xR0T");


var $hsIfr = parcelRequire("hsIfr");

var $fIakH = parcelRequire("fIakH");













const $01cbdaa835a1c102$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $4yYAm.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dM7c5.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).connect_link_account_card),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });


var $bdf26fd7fe2af7ac$exports = {};
$bdf26fd7fe2af7ac$exports = new URL("general@2x.8b524499.png", import.meta.url).toString();











var $4aRua = parcelRequire("4aRua");




// TODO: remove when social-proof-3p-unauth-block-fg is cleaned up
const $2d2d86d582e5927f$var$SocialProofMessage = ({ tier: tier, connectedPct: connectedPct, providerName: providerName, testId: testId = 'smart-block-social-proof-message' })=>{
    const message = tier === 'not-low' ? (0, $dM7c5.messages).pre_auth_block_social_proof_not_low : (0, $dM7c5.messages).pre_auth_block_social_proof_low;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...message,
        values: {
            percentage: connectedPct ?? 0,
            provider: providerName,
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                    as: "strong",
                    weight: "bold"
                }, chunks)
        }
    }));
};
var $2d2d86d582e5927f$export$2e2bcd8739ae039 = $2d2d86d582e5927f$var$SocialProofMessage;




const $de399e6481e0a2d0$var$contentStyles = null;
const $de399e6481e0a2d0$var$contentAdditionalStyles = null;
const $de399e6481e0a2d0$var$newTitleBlockStyles = null;
const $de399e6481e0a2d0$var$intermediumGapStyles = null;
const $de399e6481e0a2d0$var$titleBlockStyles = null;
const $de399e6481e0a2d0$var$previewBlockStyle = null;
const $de399e6481e0a2d0$var$previewBlockStyleWithOverlap = null;
const $de399e6481e0a2d0$var$linkIconStyles = null;
const $de399e6481e0a2d0$var$containerStyles = null;
const $de399e6481e0a2d0$var$previewBlockImageStyle = null;
const $de399e6481e0a2d0$var$styles = {
    titleBoxCard: "_3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT _39xV02N91d"
};
const $de399e6481e0a2d0$var$getBetterTitle = (url)=>{
    // List of regexps to extract human-readable titles from URLs
    // Each regex should have a capture group for the title at index 1
    const titleExtractors = [
        // Dropbox: https://www.dropbox.com/scl/fi/scebraopvx4bni0sechq9/Atlas23_D1_A_0014.jpg?rlkey=... -> Atlas23_D1_A_0014.jpg
        /^https:\/\/www\.dropbox\.com\/scl\/fi\/[^\/]+\/([^\/\?]+)/,
        // Dropbox: https://www.dropbox.com/home/Teamwork%20Ecosystem?preview=xsociety00.dat -> Teamwork Ecosystem
        /^https:\/\/www\.dropbox\.com\/home\/([^\/\?]+)/,
        // Dropbox: https://www.dropbox.com/home?preview=Insomnia-All_2019-03-14.json -> Insomnia-All_2019-03-14.json
        /^https:\/\/www\.dropbox\.com\/home\?(?:.*?&)?preview=([^&#]+)/,
        // Dropbox: https://www.dropbox.com/preview/AI%20Contest -> AI Contest
        /^https:\/\/www\.dropbox\.com\/preview\/([^&?]+)/,
        // Dropbox: https://www.dropbox.com/s/votiehk00g4opif/xsociety00.dat?dl=0 -> xsociety00.dat
        /^https:\/\/www\.dropbox\.com\/(?:s|sh|sc|t)\/[^\/]+\/([^\/\?]+)/,
        // Figma: https://www.figma.com/slides/vW47To0dYPnT7jlrJdUd7h/Universal-Create-in-TwC?node-id=... -> Universal-Create-in-TwC
        // Also supports: /file/, /design/, /board/, /proto/
        /^https:\/\/(?:[\w.-]+\.)?figma\.com\/(?:design|board|file|proto|slides)\/[0-9a-zA-Z]{22,128}\/([^\/\?]+)/,
        // OneDrive: https://1drv.ms/w/s!ABC123DEF456/Project_Plan.docx?e=abcdEF -> Project_Plan.docx
        /^https:\/\/1drv\.ms\/[a-z]+\/s![^\/]+\/([^\/\?]+)/,
        // Miro: https://miro.com/app/board/uXjVOPnT123=/my-board-name/ -> my-board-name
        /^https:\/\/miro\.com\/app\/board\/[^\/]+\/([^\/\?]+)\/?/
    ]; // Try each extractor pattern
    for (const pattern of titleExtractors){
        const match = url.match(pattern);
        if (match) {
            const extracted = decodeURIComponent(match[1]);
            if (extracted) return extracted;
        }
    }
    try {
        const { pathname: pathname, search: search } = new URL(url);
        if (pathname.length > 1) return pathname.substring(1);
        if (search) return search;
         // Fall back to the full URL when there is no useful path/search to display,
        // so the title (and the underlying link) always has accessible text.
        return url;
    } catch  {
        return url;
    }
};
const $de399e6481e0a2d0$var$UnauthorisedBlock = ({ actions: actions, children: children, url: url, CompetitorPrompt: CompetitorPrompt, testId: testId })=>{
    const { ui: ui, data: data } = (0, $9PA4G.useFlexibleCardContext)() ?? {
        ui: undefined,
        data: undefined
    };
    const hasActions = actions && actions.length > 0;
    const actionGroup = hasActions ? /*#__PURE__*/ $cozmU.createElement((0, $3M4EV.default), {
        size: (0, $4yYAm.SmartLinkSize).Large,
        items: actions
    }) : null;
    const competitorPrompt = CompetitorPrompt && data?.url ? /*#__PURE__*/ $cozmU.createElement(CompetitorPrompt, {
        sourceUrl: data?.url,
        linkType: 'card'
    }) : null;
    const title = /*#__PURE__*/ $cozmU.createElement((0, $fIakH.default), {
        hideTooltip: false,
        maxLines: 1,
        theme: ui?.theme,
        text: $de399e6481e0a2d0$var$getBetterTitle(url),
        className: (0, $hekY6.default)([
            "_1kk5Tk7GSX _1UtDYzM7Tp"
        ])
    });
    const { position: position } = (0, $791079cdeeb65697$export$45bdb4108909a713);
    let overrideUrl = data?.preview?.url ?? (0, (/*@__PURE__*/$parcel$interopDefault($bdf26fd7fe2af7ac$exports)));
    return /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), {
        ...(0, $791079cdeeb65697$export$45bdb4108909a713),
        testId: `${testId}-errored-view`,
        className: (0, $hekY6.default)([
            "_0u2WMmrU95 _3n40gWrqxC"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        direction: (0, $4yYAm.SmartLinkDirection).Vertical,
        width: (0, $4yYAm.SmartLinkWidth).Flexible,
        size: (0, $4yYAm.SmartLinkSize).Medium,
        className: (0, $hekY6.default)([
            "_2mHwu88HPE"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $3qg1D.default), null, /*#__PURE__*/ $cozmU.createElement((0, $hsIfr.default), {
        position: position,
        size: (0, $4yYAm.SmartLinkSize).Medium,
        isTiledIcon: true,
        className: (0, $hekY6.default)([
            "_267wa5YbGa"
        ])
    }), /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        direction: (0, $4yYAm.SmartLinkDirection).Vertical,
        width: (0, $4yYAm.SmartLinkWidth).Flexible,
        size: (0, $4yYAm.SmartLinkSize).Large,
        className: (0, $hekY6.default)([
            "_2mHwu8dnbC"
        ])
    }, competitorPrompt ? /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $de399e6481e0a2d0$var$styles.titleBoxCard
    }, title, competitorPrompt) : title, /*#__PURE__*/ $cozmU.createElement((0, $knKT4.default), {
        size: (0, $4yYAm.SmartLinkSize).Medium,
        direction: (0, $4yYAm.SmartLinkDirection).Horizontal
    }, (0, $1xR0T.renderElementItems)([
        {
            name: (0, $4yYAm.ElementName).HostName
        }
    ])))), children, actionGroup), hasActions ? /*#__PURE__*/ $cozmU.createElement("div", {
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _39xV02srRs _4xdlr0FlnN _3hrKbBYbGa",
            "_39xV02ToBl"
        ])
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        style: {
            backgroundImage: `url(${overrideUrl})`
        },
        className: (0, $hekY6.default)([
            "_1mT5xdWVPG _2IhTondnbC _4ApkO2dnbC _0Bm75GdnbC _0jFU0VN91d _39xV02srRs _3OqcjTgIor _1DJ2rV715P _2z4m57UZDI"
        ])
    })) : null);
}; /**
    * This view represents a Block card that has an 'Unauthorized' status .
    * It should have a "Connect" button that will allow a user to connect their account and view the block card.
    *
    * @see SmartLinkStatus
    * @see FlexibleCardProps
    */ 
const $de399e6481e0a2d0$var$UnauthorisedViewFrame = ({ content: content, providerName: providerName, testId: testId, ...props })=>{
    const { onAuthorize: onAuthorize } = props;
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleAuthorize = (0, $cozmU.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const actions = (0, $cozmU.useMemo)(()=>onAuthorize ? [
            (0, $01cbdaa835a1c102$export$34cef2b72294bd84)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ $cozmU.createElement((0, $bVAqi.default), {
        appearance: "block",
        onAuthorize: onAuthorize,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $791079cdeeb65697$export$22ebf74c8bee4708),
        ...props
    }, /*#__PURE__*/ $cozmU.createElement($de399e6481e0a2d0$var$UnauthorisedBlock, {
        actions: actions,
        cardState: props.cardState,
        CompetitorPrompt: props.CompetitorPrompt,
        testId: testId,
        url: props.url
    }, /*#__PURE__*/ $cozmU.createElement("div", {
        "data-testid": `${testId}-content`,
        className: (0, $hekY6.default)([
            "_2sNsIgmnOE _1UtDYzy7kJ _3138422ADO",
            actions.length > 0 && "_4bt5LAnQyn _2WAcuGnQyn _1DCdHi5zaO _1EqgXlN91d _1ANEUSLRg7 _39HuIbz8Lp"
        ])
    }, content)));
};
const $de399e6481e0a2d0$var$UnauthorisedViewBase = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const providerName = (0, $hHrlI.extractSmartLinkProvider)(cardState.details)?.text;
    const isProductIntegrationSupported = (0, $2Q7sv.hasAuthScopeOverrides)(cardState.details);
    const content = (0, $cozmU.useMemo)(()=>onAuthorize ? /*#__PURE__*/ $cozmU.createElement((0, $4bvRC.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dM7c5.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    return /*#__PURE__*/ $cozmU.createElement($de399e6481e0a2d0$var$UnauthorisedViewFrame, {
        ...props,
        content: content,
        providerName: providerName,
        testId: testId
    });
}; /**
    * Experiment wrapper: fires social proof exposure and renders social proof UI when FG is on.
    * TODO: remove when social-proof-3p-unauth-block-fg is cleaned up
    */ 
const $de399e6481e0a2d0$var$UnauthorisedViewWithExperiment = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    const extensionKey = props.cardState?.details?.meta?.key;
    (0, $6cFsl.di)((0, $593a61648c304682$export$2e2bcd8739ae039));
    const providerName = (0, $hHrlI.extractSmartLinkProvider)(props.cardState.details)?.text;
    const { connections: connections } = (0, $cMyWi.useSmartLinkContext)();
    const { isTreatment: isTreatment, tier: tier, connectedPct: connectedPct } = (0, $593a61648c304682$export$2e2bcd8739ae039)(providerName ? extensionKey : undefined, connections.client.baseUrlOverride);
    const socialProofExperimentMeta = (0, $593a61648c304682$export$49fab64ef7e3aab7)({
        extensionKey: extensionKey,
        baseUriWithNoTrailingSlash: connections.client.baseUrlOverride
    });
    const analyticsContextData = {
        attributes: {
            experiment: 'social_proof_3p_unauth_block_exp',
            cohort: isTreatment ? 'treatment' : 'control',
            tier: tier,
            experimentMeta: socialProofExperimentMeta
        }
    };
    if (!isTreatment || !providerName) {
        const fallbackView = /*#__PURE__*/ $cozmU.createElement($de399e6481e0a2d0$var$UnauthorisedViewBase, {
            ...props,
            testId: testId
        });
        return connectedPct !== undefined ? /*#__PURE__*/ $cozmU.createElement((0, $gBjHb.default), {
            data: analyticsContextData
        }, fallbackView) : fallbackView;
    }
    return /*#__PURE__*/ $cozmU.createElement((0, $gBjHb.default), {
        data: analyticsContextData
    }, /*#__PURE__*/ $cozmU.createElement($de399e6481e0a2d0$var$UnauthorisedViewFrame, {
        ...props,
        content: /*#__PURE__*/ $cozmU.createElement((0, $2d2d86d582e5927f$export$2e2bcd8739ae039), {
            tier: tier,
            connectedPct: connectedPct,
            providerName: providerName
        }),
        providerName: providerName,
        testId: testId
    }));
};
const $de399e6481e0a2d0$var$UnauthorisedViewWithoutExperiment = (props)=>{
    return /*#__PURE__*/ $cozmU.createElement($de399e6481e0a2d0$var$UnauthorisedViewBase, props);
};
const $de399e6481e0a2d0$var$UnauthorisedView = (0, $rECdA.componentWithFG)('social-proof-3p-unauth-block-fg', $de399e6481e0a2d0$var$UnauthorisedViewWithExperiment, $de399e6481e0a2d0$var$UnauthorisedViewWithoutExperiment);
const $de399e6481e0a2d0$var$_default_1 = (0, $772dc4e1baeec1f1$export$36ce1a3a446661ab)($de399e6481e0a2d0$var$UnauthorisedView);
var $de399e6481e0a2d0$export$2e2bcd8739ae039 = $de399e6481e0a2d0$var$_default_1;


const $958d842453deb70e$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "smart-card-block-card"
    }), children);
const $958d842453deb70e$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, handleFrameAuxClick: handleFrameAuxClick, handleFrameContextMenu: handleFrameContextMenu, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $ghw3R.handleClickCommon)(event, handleFrameClick),
        onAuxClick: handleFrameAuxClick,
        onContextMenu: handleFrameContextMenu,
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        CompetitorPrompt: CompetitorPrompt,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $e8b011f03e2ed95f$export$f93c47f1b2b3f55b)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($958d842453deb70e$var$UFOLoadHoldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ca1983200af5b1b$export$2e2bcd8739ae039), {
                ...blockCardProps,
                testId: "smart-block-resolving-view"
            }));
        case 'resolved':
            if ((0, $97c57299ded7b56e$export$a019611f39785186)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $de399e6481e0a2d0$export$2e2bcd8739ae039), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ca1983200af5b1b$export$2e2bcd8739ae039), blockCardProps);
        case 'unauthorized':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $de399e6481e0a2d0$export$2e2bcd8739ae039), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4f2a8e9f717802a0$export$2e2bcd8739ae039), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $190fb10d746b139d$export$2e2bcd8739ae039), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h1uyX.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ef07791dc4abcf0a$export$2e2bcd8739ae039), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};

















var $7YvXl = parcelRequire("7YvXl");

var $3ewaO = parcelRequire("3ewaO");

var $4FdKz = parcelRequire("4FdKz");





var $g0csk = parcelRequire("g0csk");

var $2A177 = parcelRequire("2A177");

var $7FNdz = parcelRequire("7FNdz");

var $2GG3F = parcelRequire("2GG3F");

var $kAdyG = parcelRequire("kAdyG");





var $2Pj3a = parcelRequire("2Pj3a");




function $d6cc6e0d201b986b$export$8dcb07487061d3c1(jsonLd) {
    const provider = (0, $2A177.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $2Pj3a.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $2GG3F.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $7FNdz.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}
function $d6cc6e0d201b986b$export$6ec4b6b24dec9156(response) {
    if ((0, $kAdyG.isEntityPresent)(response)) return (0, $g0csk.extractEntityProvider)(response);
    return $d6cc6e0d201b986b$export$8dcb07487061d3c1(response?.data || (0, $8p295.getEmptyJsonLd)());
}



var $1qrkW = parcelRequire("1qrkW");


var $a3jaM = parcelRequire("a3jaM");

const $f2176b8b78b3d5c8$export$d6cf81ca6e68bcc3 = (response, _platform, iframeUrlType)=>{
    const meta = response?.meta;
    const jsonLd = response?.data || (0, $8p295.getEmptyJsonLd)();
    return {
        link: (0, $3ewaO.extractSmartLinkUrl)(response) || '',
        title: (0, $7YvXl.extractSmartLinkTitle)(response),
        context: (0, $d6cc6e0d201b986b$export$6ec4b6b24dec9156)(response),
        preview: (0, $8OcYi.extractSmartLinkEmbed)(response, iframeUrlType),
        isTrusted: (0, $a3jaM.extractIsTrusted)(meta),
        isSupportTheming: (0, $1qrkW.extractIsSupportTheming)(meta),
        type: (0, $4FdKz.extractType)(jsonLd)
    };
};



var $kku4L = parcelRequire("kku4L");














var $3Xkfu = parcelRequire("3Xkfu");














var $fBqzD = parcelRequire("fBqzD");




var $jqhMF = parcelRequire("jqhMF");




var $iMQz5 = parcelRequire("iMQz5");


var $3CYX0 = parcelRequire("3CYX0");


var $39Mwn = parcelRequire("39Mwn");


var $gITbz = parcelRequire("gITbz");


var $a5G9M = parcelRequire("a5G9M");








var $8mPrX = parcelRequire("8mPrX");

const $7b0fffa5fa3ec27e$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};






var $kkFbH = parcelRequire("kkFbH");


var $c1Kdq = parcelRequire("c1Kdq");











const $4f896bdd2d7540cd$var$getBlogIconWrapped = ()=>(parcelRequire("lYcSC")).default;

const $4f896bdd2d7540cd$var$getDocumentIcon = ()=>(parcelRequire("2jRrx")).default;

const $4f896bdd2d7540cd$var$getFileIcon = ()=>(parcelRequire("ipz0N")).default;

const $4f896bdd2d7540cd$var$getLiveDocumentIconWrapped = ()=>(parcelRequire("66hVV")).default;

const $4f896bdd2d7540cd$var$getPresentationIcon = ()=>(parcelRequire("f49me")).default;

const $4f896bdd2d7540cd$var$getSpreadsheetIcon = ()=>(parcelRequire("jBJvN")).default;
const $4f896bdd2d7540cd$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $4f896bdd2d7540cd$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $4f896bdd2d7540cd$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $2Pj3a.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $4f896bdd2d7540cd$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $16kNn.getIconForFileType)(opts.fileFormat, (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined);
};
const $4f896bdd2d7540cd$var$documentLabel = (opts, label)=>{
    // NAVX-4354 can be inlined during cleanup.
    if (!opts.showIconLabel) return '';
    return (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? label : opts.title || label;
};
const $4f896bdd2d7540cd$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            {
                // Intentionally keep this icon on a synchronous require()-based path.
                // This icon must be present in SSR markup so hydration does not cause a
                // visible empty-state-then-pop-in transition for Smart Links.
                const BlogIconWrapped = $4f896bdd2d7540cd$var$getBlogIconWrapped();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BlogIconWrapped, {
                    label: $4f896bdd2d7540cd$var$documentLabel(opts, 'blog'),
                    testId: "blog-icon"
                });
            }
        case 'schema:DigitalDocument':
            return $4f896bdd2d7540cd$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            {
                const DocumentIcon = $4f896bdd2d7540cd$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: $4f896bdd2d7540cd$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
        case 'schema:PresentationDigitalDocument':
            {
                const PresentationIcon = $4f896bdd2d7540cd$var$getPresentationIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(PresentationIcon, {
                    label: $4f896bdd2d7540cd$var$documentLabel(opts, 'presentation'),
                    testId: "presentation-icon"
                });
            }
        case 'schema:SpreadsheetDigitalDocument':
            {
                const SpreadsheetIcon = $4f896bdd2d7540cd$var$getSpreadsheetIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SpreadsheetIcon, {
                    label: $4f896bdd2d7540cd$var$documentLabel(opts, 'spreadsheet'),
                    testId: "spreadsheet-icon"
                });
            }
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kkFbH))), {
                color: "currentColor",
                label: $4f896bdd2d7540cd$var$documentLabel(opts, 'template'),
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            {
                const DocumentIcon = $4f896bdd2d7540cd$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(DocumentIcon, {
                    label: $4f896bdd2d7540cd$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $4f896bdd2d7540cd$var$digitalDocumentToIcon = (opts)=>{
    if (opts.provider?.id && (0, $c1Kdq.isConfluenceGenerator)(opts.provider.id)) {
        // Intentionally keep this icon on a synchronous require()-based path.
        // This icon must be present in SSR markup so hydration does not cause a
        // visible empty-state-then-pop-in transition for Smart Links.
        const LiveDocumentIconWrapped = $4f896bdd2d7540cd$var$getLiveDocumentIconWrapped();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LiveDocumentIconWrapped, {
            label: $4f896bdd2d7540cd$var$documentLabel(opts, 'live document'),
            testId: "live-doc-icon"
        });
    } else {
        const FileIcon = $4f896bdd2d7540cd$var$getFileIcon();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(FileIcon, {
            label: $4f896bdd2d7540cd$var$documentLabel(opts, 'file'),
            testId: "file-icon"
        });
    }
};






var $fHe6f = parcelRequire("fHe6f");


var $ahlZa = parcelRequire("ahlZa");


var $6MsAF = parcelRequire("6MsAF");


var $38zdI = parcelRequire("38zdI");


var $cVpj0 = parcelRequire("cVpj0");


var $bvjEB = parcelRequire("bvjEB");


var $jMFOf = parcelRequire("jMFOf");





var $S7fVP = parcelRequire("S7fVP");





var $y3W88 = parcelRequire("y3W88");

const $25b9a77feae19a2e$var$TaskIcon = (0, $a5G9M.default);
const $25b9a77feae19a2e$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const legacyTaskLabel = opts.title || 'task';
    const getLabel = (semantic)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? semantic : legacyTaskLabel;
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($25b9a77feae19a2e$var$TaskIcon, {
        label: getLabel('Task'),
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $y3W88.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $y3W88.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                    label: getLabel('Task'),
                    testId: "jira-task-icon"
                });
            case 0, $y3W88.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jMFOf.default), {
                    label: getLabel('Sub-task'),
                    testId: "jira-subtask-icon"
                });
            case 0, $y3W88.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bvjEB.default), {
                    label: getLabel('Story'),
                    testId: "jira-story-icon"
                });
            case 0, $y3W88.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fHe6f.default), {
                    label: getLabel('Bug'),
                    testId: "jira-bug-icon"
                });
            case 0, $y3W88.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6MsAF.default), {
                    label: getLabel('Epic'),
                    testId: "jira-epic-icon"
                });
            case 0, $y3W88.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38zdI.default), {
                    label: getLabel('Incident'),
                    testId: "jira-incident-icon"
                });
            case 0, $y3W88.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $S7fVP.default), {
                    label: getLabel('Service request'),
                    testId: "jira-service-request-icon"
                });
            case 0, $y3W88.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ahlZa.default), {
                    label: getLabel('Change'),
                    testId: "jira-change-icon"
                });
            case 0, $y3W88.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cVpj0.default), {
                    label: getLabel('Problem'),
                    testId: "jira-problem-icon"
                });
            case 0, $y3W88.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};






var $i9AjY = parcelRequire("i9AjY");

const $c6cb06b5744ce8d5$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        ...(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? {} : {
            title: (0, $jqhMF.extractTitle)(jsonLd)
        },
        provider: (0, $2A177.extractProvider)(jsonLd),
        fileFormat: (0, $7b0fffa5fa3ec27e$export$f2d65f02f6888b60)(jsonLd),
        taskType: (0, $8mPrX.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $2GG3F.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $i9AjY.extractorPriorityMap)[b] - (0, $i9AjY.extractorPriorityMap)[a])[0];
        return $c6cb06b5744ce8d5$var$extractIconByType(highestPriorityType, opts);
    } else return $c6cb06b5744ce8d5$var$extractIconByType(type, opts);
};
function $c6cb06b5744ce8d5$var$typeToIcon(type, opts) {
    const getLabel = (title)=>(0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? title : opts.title || title;
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $39Mwn.default), {
                label: getLabel('commit'),
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
                label: getLabel('project'),
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gITbz.default), {
                label: getLabel('pull request'),
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMQz5.default), {
                label: getLabel('reference'),
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3CYX0.default), {
                label: getLabel('repository'),
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a5G9M.default), {
                label: getLabel('goal'),
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $25b9a77feae19a2e$export$321256ed044e3100)(opts);
        default:
            return undefined;
    }
}
function $c6cb06b5744ce8d5$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $c6cb06b5744ce8d5$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $16kNn.getIconForFileType)(opts.fileFormat, (0, $iDrrr.fg)('platform_navx_smart_link_icon_label_a11y') ? opts.showIconLabel : undefined) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $2Pj3a.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $c6cb06b5744ce8d5$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $4f896bdd2d7540cd$export$25c24c7f577936d3)(type, opts);
        default:
            return $c6cb06b5744ce8d5$var$standardisedExtractIcon(type, opts);
    }
};



var $2Mkmh = parcelRequire("2Mkmh");






const $9e4a95fa3dc128fa$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $i9AjY.extractorPriorityMap)[b] - (0, $i9AjY.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return "var(--ds-text-danger, #AE2E24)";
            default:
                return undefined;
        }
    }
};


const $a46204b9e466e80e$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $a46204b9e466e80e$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $a46204b9e466e80e$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers?.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};





const $77f5ac99c8e12626$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $2A177.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $y3W88.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $y3W88.JIRA_GENERATOR_ID)) {
            if ((0, $iDrrr.fg)('platform_navx_jira_issue_type_icon_label_a11y')) {
                const icon = (0, $c6cb06b5744ce8d5$export$64bdf1f5e49e8626)(jsonLd, 'type', showIconLabel);
                if (provider.id === (0, $y3W88.JIRA_GENERATOR_ID) && typeof icon === 'string') {
                    const taskTypeLabel = (0, $8mPrX.extractTaskType)(jsonLd)?.name?.trim();
                    if (taskTypeLabel) return [
                        icon,
                        taskTypeLabel
                    ];
                }
                return icon;
            }
            return (0, $c6cb06b5744ce8d5$export$64bdf1f5e49e8626)(jsonLd, 'type', showIconLabel);
        }
    }
    return (0, $c6cb06b5744ce8d5$export$64bdf1f5e49e8626)(jsonLd, 'provider', showIconLabel);
};
/**
 * Should be moved to the smart link-extractor when jsonld is deprecated
 */ const $77f5ac99c8e12626$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $kAdyG.isEntityPresent)(response)) {
        if ((0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon')) {
            const entityIcon = (0, $kku4L.extractEntityIcon)(response);
            if (entityIcon) return [
                entityIcon.url,
                entityIcon.label
            ];
        }
        const provider = (0, $g0csk.extractEntityProvider)(response);
        if (provider) return provider.icon;
    }
    return $77f5ac99c8e12626$var$extractInlineIcon(response?.data || (0, $8p295.getEmptyJsonLd)(), showLabel);
};
const $77f5ac99c8e12626$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = response?.data || (0, $8p295.getEmptyJsonLd)();
    return {
        link: (0, $3ewaO.extractSmartLinkUrl)(response),
        title: (0, $7YvXl.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        icon: (0, $ieeJu.expValEquals)('confluence_1p_and_3p_connection_byline_experiment', 'isEnabled', true) ? (0, $3Xkfu.extractSmartLinkInlineIcon)(response, showLabel) : $77f5ac99c8e12626$var$extractSmartLinkInlineIcon(response, showLabel),
        // As we migrate to support more entities we can incorporate these fields
        lozenge: (0, $2Mkmh.extractLozenge)(jsonLd),
        titleTextColor: (0, $9e4a95fa3dc128fa$export$a2afc198e9dada1)(jsonLd),
        titlePrefix: (0, $a46204b9e466e80e$export$58d9bc37318dfb32)(jsonLd, renderers, 'inline'),
        type: (0, $4FdKz.extractType)(jsonLd)
    };
};












var $1Zwrg = parcelRequire("1Zwrg");

/* ErroredView.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $ad7Ou = parcelRequire("ad7Ou");


var $24dy7 = parcelRequire("24dy7");




var $1l0kj = parcelRequire("1l0kj");




/* ErrorFrame.tsx generated by @compiled/babel-plugin v2.0.0 */ 





const $43f9b1cf28b9cc98$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($43f9b1cf28b9cc98$export$f862a410248f4f00, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($43f9b1cf28b9cc98$export$7b360cd785b6c366, props);
const $43f9b1cf28b9cc98$var$sharedBaseFrameStyles = null;
const $43f9b1cf28b9cc98$var$sharedFrameStyles = null;
const $43f9b1cf28b9cc98$var$expandedFrameHoverStyles = null;
const $43f9b1cf28b9cc98$var$expandedFrameFluidHeightTrueStyles = null;
const $43f9b1cf28b9cc98$var$expandedFrameFluidHeightFalseStyles = null;
const $43f9b1cf28b9cc98$var$expandedFrameSelectedStyles = null;
const $43f9b1cf28b9cc98$var$expandedFrameNotSelectedStyles = null;
const $43f9b1cf28b9cc98$var$expandedFrameStyles = null;
const $43f9b1cf28b9cc98$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_39xV02N91d _3iDTPbQ4SZ",
            "_1EqgXl8yGE _0KLXruqi9L",
            isHoverable && "_1eOmH6o126 _0ReiIH7zJH",
            isFluidHeight ? "_4kiQYAdnbC" : "_4kiQYAv6H3",
            isSelected ? "_0bjKvDzXzM _3vBAKHrzt2 _3hxITi6wH8 _2V7sgO2M4S" : "_0bjKvDcjp5 _3vBAKHjOvk _3hxITi6wH8 _2V7sgO2M4S",
            "_4bt5LAnQyn _2WAcuGnQyn _37wbyuI7V3 _2OUyjtzwhj",
            className
        ]),
        "data-trello-do-not-use-override": testId
    }, children);
};
const $43f9b1cf28b9cc98$var$compactFrameHoverStyles = null;
const $43f9b1cf28b9cc98$var$compactFrameInheritDimensionsTrueStyles = null;
const $43f9b1cf28b9cc98$var$compactFrameInheritDimensionsFalseStyles = null;
const $43f9b1cf28b9cc98$var$compactFrameAlignStyles = null;
const $43f9b1cf28b9cc98$var$compactFrameStyles = null;
const $43f9b1cf28b9cc98$var$compactFrameNotSelectedStyles = null;
const $43f9b1cf28b9cc98$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_39xV02N91d _3iDTPbQ4SZ",
            "_1EqgXl8yGE _0KLXruqi9L",
            isHoverable && "_1eOmH6KcZT",
            isSelected && "_0bjKvDzXzM _3vBAKHrzt2 _3hxITi6wH8 _2V7sgO2M4S",
            !isSelected && "_0bjKvDcjp5",
            "_37wbyuDIqT _0hPCNLDIqT _0KLXruDMqu",
            inheritDimensions ? "_0jFU0VN91d" : "_0jFU0VUF4f",
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _39xV02N91d",
            className
        ])
    }, children);
};


const $1402c290c2a79a1a$var$styles = {
    boxStyles: "_2Zuz6Q1Y8M _1Znuxb1Y8M"
};
const $1402c290c2a79a1a$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ $cozmU.createElement((0, $43f9b1cf28b9cc98$export$b89a827e9254211a), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error-icon"
    }), /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
        xcss: $1402c290c2a79a1a$var$styles.boxStyles
    }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), null, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).could_not_load_link))), /*#__PURE__*/ $cozmU.createElement((0, $ad7Ou.default), {
        testId: "err-view-retry",
        spacing: "compact",
        onClick: onRetry
    }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).try_again)));















/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $I7hWB = parcelRequire("I7hWB");


var $kTb7m = parcelRequire("kTb7m");





var $856OS = parcelRequire("856OS");

/* ImageIcon.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $6Eovk = parcelRequire("6Eovk");


var $aFr4e = parcelRequire("aFr4e");

const $c56aa820dbfc924e$var$styles = {
    roundedImage: "_0bjKvDS5Zs"
};
const $c56aa820dbfc924e$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $cozmU.useState)(false); // If url changes, reset state
    (0, $cozmU.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    const handleError = (0, $cozmU.useCallback)(()=>{
        setHasImageErrored(true);
    }, []); // TODO: do we need this?
    if (!src) return defaultIcon || null;
    if (hasImageErrored) return defaultIcon;
    const LoadedImageComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aFr4e.Image // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    ), {
        className: (0, $hekY6.default)([
            appearance === 'round' && $c56aa820dbfc924e$var$styles.roundedImage,
            "smart-link-icon"
        ]),
        src: src,
        alt: alt,
        size: size,
        title: title,
        ...hideLoadingSkeleton ? {
            onError: handleError
        } : undefined
    });
    if (hideLoadingSkeleton) return LoadedImageComponent;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Eovk.default), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};


const $ffabb40f353fd16d$var$containerStyles = null;
const $ffabb40f353fd16d$var$contentStyles = null;
const $ffabb40f353fd16d$var$imageStyles = null;
const $ffabb40f353fd16d$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, testId: testId, text: text, title: title, url: url })=>{
    const icon = (0, $cozmU.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(iconUrlOrElement)) return iconUrlOrElement;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c56aa820dbfc924e$export$4a122bafaa48b23d), {
            src: typeof iconUrlOrElement === 'string' ? iconUrlOrElement : undefined,
            default: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: "icon",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        iconUrlOrElement
    ]);
    const image = (0, $cozmU.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $hekY6.default)([
                "_0jFU0Vv6H3 _39xV02WD6W _00EA0egIor _1PLshBXWGq"
            ])
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "data-testid": imageTestId,
            className: (0, $hekY6.default)([
                "_0jFU0Vv6H3 _39xV02WD6W _00EA0egIor _1PLshBXWGq"
            ])
        }, imageUrlOrElement);
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $856OS.ExpandedFrame // Scroll bar must be shown for unresolved views to display the connect account button
    ), {
        allowScrollBar: true,
        setOverflow: true,
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": `${testId}-unresolved-container`,
        className: (0, $hekY6.default)([
            "_3iDTPbgBM8 _0jFU0VOLYo"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_313842IZbP _0adFHsIZbP _1DCdHiIZbP _2XsHFMIZbP _2mHwu8kG2W _3iDTPbQ4SZ _0aFT5vbt8w _37wbyuDIqT _2fwxA5DIqT _0hPCNLDIqT _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _1EqgXlHakr"
        ])
    }, image, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "large",
        testId: `${testId}-unresolved-title`
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        align: "center",
        testId: `${testId}-unresolved-description`
    }, description), button)));
};
var $ffabb40f353fd16d$export$2e2bcd8739ae039 = $ffabb40f353fd16d$var$UnresolvedView;





const $bd7aa1482f10082c$export$f51768a4e7ff128 = ()=>{
    const gradientId = (0, $cozmU.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: gradientId,
        gradientUnits: "userSpaceOnUse",
        x1: "49.4199",
        x2: "122.662",
        y1: "59.7673",
        y2: "59.7673"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0",
        stopColor: "#0065ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: ".2188",
        stopColor: "#0b6cff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: ".5999",
        stopColor: "#2780ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#4c9aff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
        fill: `url(#${gradientId})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
        fill: "#de350b"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
        fill: "#ff5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
        fill: "#ff7452"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
        fill: "#ff5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
        fill: "#de350b"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
        fill: "#344563"
    }));
};


const $0932ea1b8e978982$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $cozmU.useMemo)(()=>{
        const product = context?.text ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, hostname)
        };
    }, [
        hostname,
        context?.text
    ]);
    /**
   * if there is a request access context, but no action to perform, do not show any button.
   * By default, a "Try another account" button shows, but with request access context, we don't
   * want to encourage users to try another account, if their request is already pending, etc.
   */ const button = (0, $cozmU.useMemo)(()=>{
        const onEmbedCardClick = action?.promise ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
            testId: `button-${action?.id || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $393972733951d863$export$d14c2a6dee946f52)((0, $dM7c5.messages).try_another_account, callToActionMessageKey),
            values: values
        }));
    }, [
        accessType,
        action?.id,
        action?.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ffabb40f353fd16d$export$2e2bcd8739ae039), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bd7aa1482f10082c$export$f51768a4e7ff128), null),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $393972733951d863$export$d14c2a6dee946f52)((0, $dM7c5.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $393972733951d863$export$d14c2a6dee946f52)((0, $dM7c5.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $0932ea1b8e978982$export$2e2bcd8739ae039 = $0932ea1b8e978982$var$ForbiddenView;



















const $0fbd1516733958fd$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "linear-gradient",
        x1: "1316.98",
        y1: "230.66",
        x2: "1396.36",
        y2: "230.66",
        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0",
        stopColor: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#6c798f"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "linear-gradient-2",
        x1: "170.3",
        y1: "897.49",
        x2: "365.15",
        y2: "897.49",
        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0",
        stopColor: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.69",
        stopColor: "#fff",
        stopOpacity: "0.1"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("title", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        defaultMessage: "Search error",
        id: "smart-card.not-found-svg.title"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        id: "Objects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#cfd4db",
        d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        id: "_Path_",
        "data-name": "<Path>",
        fill: "url(#linear-gradient)",
        d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#091e42",
        opacity: 0.1,
        d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#344563",
        d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        id: "_Clipping_Path_",
        "data-name": "<Clipping Path>",
        fill: "#deebff",
        d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        id: "_Path_2",
        "data-name": "<Path>",
        fill: "#b2d4ff",
        d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#cce0ff",
        d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "url(#linear-gradient-2)",
        d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("polygon", {
        id: "_Path_3",
        "data-name": "<Path>",
        fill: "#5e6c84",
        points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#ffc400",
        d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "#ffc400",
        d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#344563",
        d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#5e6c84",
        d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#5e6c84",
        d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
    }))));


const $2ca454ac27b3dd0b$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $cozmU.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ffabb40f353fd16d$export$2e2bcd8739ae039), {
        ...unresolvedViewProps,
        icon: icon,
        image: image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0fbd1516733958fd$export$80542c1714a314c8), null),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $393972733951d863$export$d14c2a6dee946f52)((0, $dM7c5.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $393972733951d863$export$d14c2a6dee946f52)((0, $dM7c5.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $2ca454ac27b3dd0b$export$2e2bcd8739ae039 = $2ca454ac27b3dd0b$var$NotFoundView;


/* ResolvedView.tsx generated by @compiled/babel-plugin v2.0.0 */ 






var $4wH3g = parcelRequire("4wH3g");











var $IQ4Dz = parcelRequire("IQ4Dz");




















var $anBbz = parcelRequire("anBbz");










const $9741347bf457b85f$var$EMBED_ROVO_ACTIONS_FOOTER_ELIGIBLE_EXTENSION_KEYS = new Set([
    'google-object-provider',
    'onedrive-object-provider',
    'github-object-provider',
    'gitlab-object-provider'
]);
const $9741347bf457b85f$var$isEligibleEmbedRovoActionsFooterExtensionKey = (extensionKey)=>extensionKey !== undefined && $9741347bf457b85f$var$EMBED_ROVO_ACTIONS_FOOTER_ELIGIBLE_EXTENSION_KEYS.has(extensionKey);
const $9741347bf457b85f$export$76c8c65be40d033d = 'platform_sl_3p_auth_rovo_embed_footer_exp';
const $9741347bf457b85f$var$NOT_ENABLED_RESULT = {
    isEnabled: false
};
const $9741347bf457b85f$export$f52bc2858cff4634 = (product)=>{
    return product === 'CONFLUENCE' && (0, $iDrrr.fg)('platform_sl_3p_auth_rovo_embed_footer_kill_switch') && (0, $ieeJu.expValEquals)($9741347bf457b85f$export$76c8c65be40d033d, 'isEnabled', true);
};
const $9741347bf457b85f$var$isEmbedRovoActionsFooterKillSwitchEnabled = (product)=>{
    return product === 'CONFLUENCE' && (0, $iDrrr.fg)('platform_sl_3p_auth_rovo_embed_footer_kill_switch');
};
const $9741347bf457b85f$var$isEmbedRovoActionsFooterExperimentEnabledNoExposure = (product)=>{
    return $9741347bf457b85f$var$isEmbedRovoActionsFooterKillSwitchEnabled(product) && (0, $anBbz.expValEqualsNoExposure)($9741347bf457b85f$export$76c8c65be40d033d, 'isEnabled', true);
};
const $9741347bf457b85f$export$d92e090f28e31112 = ({ extensionKey: extensionKey, isRovoChatActionOptedIn: isRovoChatActionOptedIn, isRovoChatEnabled: isRovoChatEnabled, product: product })=>{
    const isEligible = $9741347bf457b85f$var$isEmbedRovoActionsFooterKillSwitchEnabled(product) && isRovoChatEnabled && isRovoChatActionOptedIn && $9741347bf457b85f$var$isEligibleEmbedRovoActionsFooterExtensionKey(extensionKey);
    if (!isEligible) return undefined;
    return {
        [$9741347bf457b85f$export$76c8c65be40d033d]: {
            isEligible: true,
            isTreatment: $9741347bf457b85f$var$isEmbedRovoActionsFooterExperimentEnabledNoExposure(product)
        }
    };
};
const $9741347bf457b85f$var$useEmbedRovoActionsFooterExperiment = (url, actionOptions, rovoOptions, product)=>{
    const isRovoChatEnabled = (0, $aflIU.getIsRovoChatEnabled)(rovoOptions);
    const cardState = (0, $9H66G.useSmartCardState)(url ?? '');
    const extensionKey = (0, $2Q7sv.getExtensionKey)(cardState.details);
    const isRovoChatActionOptedIn = actionOptions?.rovoChatAction?.optIn ?? false;
    return (0, $cozmU.useMemo)(()=>{
        if (!isRovoChatEnabled || !url || !isRovoChatActionOptedIn || !extensionKey) return $9741347bf457b85f$var$NOT_ENABLED_RESULT;
        if (!$9741347bf457b85f$var$isEligibleEmbedRovoActionsFooterExtensionKey(extensionKey)) return $9741347bf457b85f$var$NOT_ENABLED_RESULT;
        return {
            isEnabled: $9741347bf457b85f$export$f52bc2858cff4634(product)
        };
    }, [
        isRovoChatEnabled,
        extensionKey,
        url,
        isRovoChatActionOptedIn,
        product
    ]);
};
var $9741347bf457b85f$export$2e2bcd8739ae039 = $9741347bf457b85f$var$useEmbedRovoActionsFooterExperiment;











const $46eb4abe0e555d2b$export$126e73c0e270bd5c = ({ extensionKey: extensionKey })=>{
    const defaultPrompts = [
        (0, $edVsK.RovoChatPromptKey).KEY_HIGHLIGHTS
    ];
    if (extensionKey === 'github-object-provider' || extensionKey === 'gitlab-object-provider') return [
        (0, $edVsK.RovoChatPromptKey).EXPLAIN_CODE,
        ...defaultPrompts
    ];
    return [
        (0, $edVsK.RovoChatPromptKey).SUMMARIZE_DOCUMENT,
        ...defaultPrompts
    ];
};





/* Frame.tsx generated by @compiled/babel-plugin v2.0.0 */ 









var $1hQ0e = parcelRequire("1hQ0e");








var $gJj3k = parcelRequire("gJj3k");

/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 


/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $70fd23309a2b541b$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $70fd23309a2b541b$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $cozmU.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $cozmU.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $cozmU.useEffect)(()=>{
        if (dwell.time > 0 && $70fd23309a2b541b$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $cozmU.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        // Require: iframe loaded, mouse over, and >75% visible.
        // Note: isWindowFocused is intentionally not required - it's unreliable and
        // prevents tracking. The mouse over check is sufficient to indicate user engagement.
        const shouldTrack = isIframeLoaded && isMouseOver && iframePercentVisible > 0.75;
        if (shouldTrack) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        } else if (dwellTimeoutId.current) {
            clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = undefined;
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};


function $12f901a32427aa31$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $12f901a32427aa31$var$iframeStyles = null;
const $12f901a32427aa31$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, isMouseOver: isMouseOverProp, title: title, extensionKey: extensionKey }, iframeRef)=>{
    (0, $6cFsl.di)((0, $gJj3k.IFrame));
    const doc = (0, $1hQ0e.getDocument)();
    const [isIframeLoaded, setIframeLoaded] = (0, $cozmU.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $cozmU.useState)(false); // Accessing the document here for SSR where document.hasFocus may be absent breaks SSR
    // when we're trying to load things like Loom frames in SSR
    // We _could_ either throw a guard in here (i.e check for the existence of document)
    // _or_
    // we can default to false, and set this state once the frame ref is available in a useEffect (safer IMO)
    // which already seems to be existing behavior in a useEffect below.
    const [isWindowFocused, setWindowFocused] = (0, $cozmU.useState)(// The below will be removed as part of FG cleanup
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    (0, $iDrrr.fg)('jpx-1074-smart-links-iframe') ? doc?.hasFocus() ?? false : document.hasFocus()); // Use prop if provided (from wrapper), otherwise use local state (for backward compatibility)
    const effectiveMouseOver = isMouseOverProp !== undefined ? isMouseOverProp : isMouseOver;
    const ref = (0, $cozmU.useRef)();
    const mergedRef = $12f901a32427aa31$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $cozmU.useState)(0); /**
                                                            * These are the 'percent visible' thresholds at which the intersectionObserver will
                                                            * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
                                                            * vice versa. It's in a state object so that its static for the useEffect
                                                            */ 
    const [threshold] = (0, $cozmU.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry?.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $cozmU.useEffect)(()=>{
        // Initialize with current focus state
        // The below will be removed as part of FG cleanup
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        setWindowFocused((0, $iDrrr.fg)('jpx-1074-smart-links-iframe') ? doc?.hasFocus() ?? false : document.hasFocus());
        const onBlur = ()=>{
            setWindowFocused(false);
            if ((0, $iDrrr.fg)('jpx-1074-smart-links-iframe')) {
                if (doc?.activeElement === ref.current) onIframeFocus && onIframeFocus();
            } else // The below will be removed as part of FG cleanup
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus,
        doc
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70fd23309a2b541b$export$e3cb965901aecabd), {
        isIframeLoaded: isIframeLoaded,
        isMouseOver: effectiveMouseOver,
        isWindowFocused: isWindowFocused,
        iframePercentVisible: percentVisible,
        onIframeDwell: onIframeDwell
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gJj3k.IFrame), {
        childRef: mergedRef,
        src: url,
        "data-testid": `${testId}-frame`,
        "data-test-iframe-loaded": isIframeLoaded,
        onMouseEnter: ()=>{
            onIframeMouseEnter?.(); // Use local state if prop not provided, otherwise prop takes precedence
            if (isMouseOverProp === undefined) setMouseOver(true);
        },
        onMouseLeave: ()=>{
            onIframeMouseLeave?.(); // Use local state if prop not provided, otherwise prop takes precedence
            if (isMouseOverProp === undefined) setMouseOver(false);
        },
        allowFullScreen: true,
        scrolling: "yes",
        allow: "autoplay; encrypted-media; clipboard-write",
        onLoad: ()=>{
            setIframeLoaded(true);
        },
        sandbox: (0, $16kNn.getIframeSandboxAttribute)(isTrusted),
        title: title,
        extensionKey: extensionKey,
        className: (0, $hekY6.default)([
            "_30huDKdnbC _4bt5LAnQyn _2WAcuGnQyn _0bjKvDzXzM _2IhTondnbC _3OE6xYdnbC _39xV02N91d _0jFU0VN91d _1mT5xdRAKS"
        ])
    }));
});







var $cEvdy = parcelRequire("cEvdy");

const $2edfb61374fec3d9$export$50ac35a9a8f2ebaa = ({ url: url, embedIframeRef: embedIframeRef })=>{
    const resolve = (0, $cEvdy.default)();
    (0, $cozmU.useEffect)(()=>{
        const messageCallback = (event)=>{
            if (typeof embedIframeRef === 'function') return;
            const isFromExpectedIframe = embedIframeRef && event.source === embedIframeRef.current?.contentWindow;
            if (event.data === 'force-resolve-smart-link' && isFromExpectedIframe) resolve({
                url: url,
                isReloading: true
            });
        };
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        resolve,
        url,
        embedIframeRef
    ]);
};



const $5dcf92556a9a48ad$var$EmbedRovoActionsFooter = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "AgJNn",
    name: "EmbedRovoActionsFooter",
    loader: ()=>(parcelRequire("ehQDZ")).then((module)=>module.default),
    loading: ()=>null
});
$5dcf92556a9a48ad$var$EmbedRovoActionsFooter.displayName = 'lazy(EmbedRovoActionsFooter)';
const $5dcf92556a9a48ad$var$styles = {
    contentWithFooter: "_3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _4kiQYAdnbC",
    frameWithFooter: "_2O5Vij7dHp _4kiQYAdnbC",
    footer: "_3iDTPbQ4SZ _37wbyuchRC _0xmtko2ADO _46hvQm2ADO _03SyCP2ADO _0LQT5E2ADO"
};
const $5dcf92556a9a48ad$var$EmbedFrameWithRovoFooter = ({ actionOptions: actionOptions, details: details, frame: frame, link: link, testId: testId })=>{
    const { rovoOptions: rovoOptions, product: product } = (0, $8QLAc.default)();
    const { isEnabled: isEmbedRovoActionsFooterEnabled } = (0, $9741347bf457b85f$export$2e2bcd8739ae039)(link, actionOptions, rovoOptions, product);
    const rovoActionData = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>isEmbedRovoActionsFooterEnabled && details ? (0, $irGZZ.default)({
            response: details,
            rovoConfig: {
                rovoOptions: rovoOptions,
                product: product
            },
            product: product,
            actionOptions: actionOptions,
            appearance: (0, $4yYAm.CardDisplay).Embed,
            isEmbedRovoActionsFooterExperimentEnabled: isEmbedRovoActionsFooterEnabled
        }) : undefined, [
        actionOptions,
        details,
        isEmbedRovoActionsFooterEnabled,
        product,
        rovoOptions
    ]);
    const prompts = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (!isEmbedRovoActionsFooterEnabled) return [];
        return (0, $46eb4abe0e555d2b$export$126e73c0e270bd5c)({
            extensionKey: (0, $2Q7sv.getExtensionKey)(details)
        });
    }, [
        details,
        isEmbedRovoActionsFooterEnabled
    ]);
    const footer = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>rovoActionData && prompts.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5dcf92556a9a48ad$var$EmbedRovoActionsFooter, {
            actionData: rovoActionData,
            prompts: prompts,
            testId: `${testId}-rovo-actions-footer`
        }) : undefined, [
        prompts,
        rovoActionData,
        testId
    ]);
    return footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5dcf92556a9a48ad$var$styles.contentWithFooter
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5dcf92556a9a48ad$var$styles.frameWithFooter
        ])
    }, frame), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            $5dcf92556a9a48ad$var$styles.footer
        ])
    }, footer)) : frame;
};
const $5dcf92556a9a48ad$var$EmbedFrameWithoutRovoFooter = ({ frame: frame })=>frame;
const $5dcf92556a9a48ad$var$EmbedFrameWithOptionalRovoFooter = (0, $rECdA.componentWithFG)('platform_sl_3p_auth_rovo_embed_footer_kill_switch', $5dcf92556a9a48ad$var$EmbedFrameWithRovoFooter, $5dcf92556a9a48ad$var$EmbedFrameWithoutRovoFooter);
const $5dcf92556a9a48ad$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ actionOptions: actionOptions, link: link, context: context, details: details, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, isSupportTheming: isSupportTheming, type: type, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, extensionKey: extensionKey }, embedIframeRef)=>{
    const iconFromContext = context?.icon;
    const iconLabel = context?.iconLabel;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || context?.text;
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: "icon",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    const icon = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c56aa820dbfc924e$export$4a122bafaa48b23d), {
            src: src,
            ...(0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon') ? {
                alt: iconLabel
            } : undefined,
            default: linkGlyph,
            appearance: (0, $16kNn.isProfileType)(type) ? 'round' : 'square',
            hideLoadingSkeleton: hideIconLoadingSkeleton
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        type,
        hideIconLoadingSkeleton,
        iconLabel
    ]);
    (0, $2edfb61374fec3d9$export$50ac35a9a8f2ebaa)({
        url: link,
        embedIframeRef: embedIframeRef
    });
    const themeState = (0, $IQ4Dz.default)();
    let previewUrl = preview?.src;
    if (previewUrl && isSupportTheming) previewUrl = (0, $16kNn.getPreviewUrlWithTheme)(previewUrl, themeState);
    const [isMouseOver, setMouseOver] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(false);
    const frame = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12f901a32427aa31$export$b89a827e9254211a), {
        url: previewUrl,
        isTrusted: isTrusted,
        testId: testId,
        ref: embedIframeRef,
        onIframeDwell: onIframeDwell,
        onIframeFocus: onIframeFocus,
        onIframeMouseEnter: onIframeMouseEnter,
        onIframeMouseLeave: onIframeMouseLeave,
        isMouseOver: isMouseOver,
        title: text,
        extensionKey: extensionKey
    });
    const frameWithFooter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5dcf92556a9a48ad$var$EmbedFrameWithOptionalRovoFooter, {
        actionOptions: actionOptions,
        details: details,
        frame: frame,
        link: link,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $856OS.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        CompetitorPrompt: CompetitorPrompt,
        onContentMouseEnter: ()=>{
            setMouseOver(true);
            onIframeMouseEnter?.();
        },
        onContentMouseLeave: ()=>{
            setMouseOver(false);
            onIframeMouseLeave?.();
        }
    }, frameWithFooter);
});












var $cXtTj = parcelRequire("cXtTj");














const $100aad242333a22e$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_1375_267)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "563.88",
        height: "265.81",
        transform: "translate(0.870117 0.509766)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
        fill: "#DFE1E5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
        fill: "#DFE1E5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
        stroke: "url(#paint0_linear_1375_267)",
        strokeWidth: "4.4681",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
        fill: "#403294"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.25",
        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
        fill: "url(#paint1_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.25",
        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
        fill: "url(#paint2_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
        stroke: "url(#paint3_linear_1375_267)",
        strokeWidth: "4.4681",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        opacity: "0.38",
        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
        fill: "url(#paint4_radial_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
        fill: "url(#paint5_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
        fill: "url(#paint6_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
        fill: "url(#paint7_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
        fill: "url(#paint8_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
        fill: "url(#paint9_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
        fill: "url(#paint10_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
        fill: "url(#paint11_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
        fill: "url(#paint12_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
        fill: "#172B4D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
        fill: "url(#paint13_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
        fill: "url(#paint14_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
        fill: "url(#paint15_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
        fill: "url(#paint16_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
        fill: "#6554C0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
        fill: "url(#paint17_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
        fill: "#5243AA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
        fill: "url(#paint18_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
        fill: "#B3BAC5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint0_linear_1375_267",
        x1: "141.994",
        y1: "181.192",
        x2: "0.870117",
        y2: "181.192",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#C1C7D0",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint1_linear_1375_267",
        x1: "208.292",
        y1: "264.428",
        x2: "0.870117",
        y2: "264.428",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.8433",
        stopColor: "#091E42",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint2_linear_1375_267",
        x1: "357.327",
        y1: "264.428",
        x2: "564.748",
        y2: "264.428",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.8433",
        stopColor: "#091E42",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint3_linear_1375_267",
        x1: "423.624",
        y1: "181.192",
        x2: "564.748",
        y2: "181.192",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.1724",
        stopColor: "#076AFF",
        stopOpacity: "0.8007"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.4145",
        stopColor: "#1976FF",
        stopOpacity: "0.5208"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.6966",
        stopColor: "#378BFF",
        stopOpacity: "0.1947"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.8651",
        stopColor: "#4C9AFF",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
        id: "paint4_radial_1375_267",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(285 99.0229) scale(96.5182)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#FFF0B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.1584",
        stopColor: "#FFE587",
        stopOpacity: "0.8416"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.3589",
        stopColor: "#FFDA57",
        stopOpacity: "0.6411"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.5498",
        stopColor: "#FFD031",
        stopOpacity: "0.4502"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.7256",
        stopColor: "#FFC916",
        stopOpacity: "0.2744"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.8811",
        stopColor: "#FFC506",
        stopOpacity: "0.1189"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#FFC400",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint5_linear_1375_267",
        x1: "346.074",
        y1: "98.8386",
        x2: "423.624",
        y2: "98.8386",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint6_linear_1375_267",
        x1: "237.087",
        y1: "120.044",
        x2: "276.412",
        y2: "120.044",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#DFE1E5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint7_linear_1375_267",
        x1: "237.087",
        y1: "75.0106",
        x2: "276.412",
        y2: "75.0106",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#DFE1E5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint8_linear_1375_267",
        x1: "335.969",
        y1: "146.593",
        x2: "335.969",
        y2: "51.4514",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#B2D4FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint9_linear_1375_267",
        x1: "219.544",
        y1: "98.8386",
        x2: "141.994",
        y2: "98.8386",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#EBECF0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint10_linear_1375_267",
        x1: "229.65",
        y1: "146.593",
        x2: "229.65",
        y2: "51.4514",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#F4F5F7"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint11_linear_1375_267",
        x1: "402.858",
        y1: "216.64",
        x2: "421.684",
        y2: "223.492",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.8134",
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.8713",
        stopColor: "#0065FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint12_linear_1375_267",
        x1: "376.968",
        y1: "157.139",
        x2: "433.936",
        y2: "157.139",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint13_linear_1375_267",
        x1: "289.638",
        y1: "45.0027",
        x2: "289.638",
        y2: "0.510323",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#FFF0B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#FFC400"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint14_linear_1375_267",
        x1: "262.238",
        y1: "36.2259",
        x2: "272.592",
        y2: "36.2259",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint15_linear_1375_267",
        x1: "259.6",
        y1: "180.859",
        x2: "259.6",
        y2: "141.017",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint16_linear_1375_267",
        x1: "284.971",
        y1: "171.613",
        x2: "284.971",
        y2: "149.45",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint17_linear_1375_267",
        x1: "157.982",
        y1: "221.995",
        x2: "188.627",
        y2: "221.995",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "0.3435",
        stopColor: "#6554C0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#998DD9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint18_linear_1375_267",
        x1: "163.185",
        y1: "155.517",
        x2: "213.758",
        y2: "155.517",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#5243AA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#8777D9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_1375_267"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "563.88",
        height: "265.81",
        fill: "white",
        transform: "translate(0.870117 0.509766)"
    }))));















var $cSGyR = parcelRequire("cSGyR");


var $lSQgn = parcelRequire("lSQgn");


var $cJ0FD = parcelRequire("cJ0FD");










/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 





/* CarouselSlide.tsx generated by @compiled/babel-plugin v2.0.0 */ 












var $w6R6I = parcelRequire("w6R6I");
















var $hBYtq = parcelRequire("hBYtq");






const $d76e07b4ffd67ffa$var$styles = {
    columnImage: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEskRj _4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLFlnN _37wbyuchRC _4kiQYAdnbC _4ouGXIdnbC _0KLXruJVoT",
    imageContainer: "_1mT5xdRAKS _39xV02N91d _0jFU0VN91d",
    imageAbsolute: "_1mT5xdWVPG _2IhTondnbC _3OE6xYdnbC _39xV02N91d",
    columnContent: "_2mHwu8NHnM _2O5Vij7dHp _3YEZNO7dHp _1bHrqEgZxp _4bt5LAIZbP _2WAcuGIZbP _3iDTPbQ4SZ _0aFT5vbt8w _4kiQYAdnbC _0Of8r2S40j _1ZnuxbS40j _1wydGWS40j _2Zuz6QS40j _0hPCNLchRC _37wbyuI7V3",
    columnContentTop: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d",
    columnContentBody: "_2mHwu8NHnM _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLchRC _39xV02N91d",
    columnContentCompact: "_0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO",
    dot: "_0bjKvDS5Zs _39xV02Jg58 _0jFU0VJg58 _0KLXruDMqu _3Z9K0w2HTN _1kOSYtQiA2 _0qk6IKUtCU _1pp6NdYbGa",
    dotActive: "_0KLXrukLmD",
    dotPassable: "_0bjKvDS5Zs _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F _0KLXru66of _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg",
    icon: "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT",
    iconImage: "_39xV02N91d _0jFU0VN91d _00EA0egIor",
    image: "_39xV02N91d _0NUa3rPIoL _00EA0egIor _1PLshBXWGq _3iDTPbvLZJ",
    rowButton: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5v1qpb _3TGfC9HnLE _0hPCNLDIqT",
    rowButtonCompact: "_39xV02N91d",
    rowDot: "_2mHwu8Pgdg _3iDTPbQ4SZ _0aFT5v1qpb _0hPCNLDIqT",
    rowIcon: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT",
    slide: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _3TGfC9LRg7 _39xV02N91d _0jFU0VN91d _0hPCNLFlnN _24h04i2Njc"
};
const $d76e07b4ffd67ffa$var$CarouselSlide = ({ icon: icon, iconLabel: iconLabel = '', title: title, description: description, image: image, primaryButtonLabel: primaryButtonLabel, onPrimaryButtonClick: onPrimaryButtonClick, onDotClick: onDotClick, onNextClick: onNextClick, slideIndex: slideIndex, totalSlides: totalSlides, size: size, testId: testId = 'embed-card-carousel-slide' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isCompact = size !== 'full';
    const showPrimaryButton = typeof onPrimaryButtonClick === 'function';
    const showNavigation = totalSlides > 1;
    const renderedIcon = (0, $cozmU.useMemo)(()=>{
        if (typeof icon === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d76e07b4ffd67ffa$var$styles.icon
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: icon,
            alt: iconLabel,
            className: (0, $hekY6.default)([
                $d76e07b4ffd67ffa$var$styles.iconImage
            ])
        }));
        if (icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $d76e07b4ffd67ffa$var$styles.icon
        }, icon);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            appearance: "blue",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cSGyR))),
            label: iconLabel,
            size: "small",
            testId: "embed-card-fallback-icon"
        });
    }, [
        icon,
        iconLabel
    ]);
    const renderedImage = image == null ? null : typeof image === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        src: image,
        alt: title,
        className: (0, $hekY6.default)([
            $d76e07b4ffd67ffa$var$styles.image
        ])
    }) : image;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.slide,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($d76e07b4ffd67ffa$var$styles.columnContent, isCompact && $d76e07b4ffd67ffa$var$styles.columnContentCompact)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.columnContentTop
    }, showPrimaryButton && isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: (0, $w6R6I.cx)($d76e07b4ffd67ffa$var$styles.rowButton, $d76e07b4ffd67ffa$var$styles.rowButtonCompact)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onPrimaryButtonClick,
        shouldFitContainer: true,
        testId: `${testId}-connect-compact`
    }, primaryButtonLabel)), renderedIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.rowIcon
    }, renderedIcon), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "medium",
        testId: `${testId}-title`
    }, title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.columnContentBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        testId: `${testId}-description`
    }, description)), (showPrimaryButton && !isCompact || showNavigation && onNextClick) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.rowButton
    }, showPrimaryButton && !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        onClick: onPrimaryButtonClick,
        testId: `${testId}-connect`
    }, primaryButtonLabel), showNavigation && onNextClick && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        onClick: onNextClick,
        testId: `${testId}-next`
    }, formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_button_next))))), showNavigation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.rowDot,
        role: "group",
        "aria-label": formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_dot_row_label)
    }, Array.from({
        length: totalSlides
    }, (_, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            key: i,
            xcss: $d76e07b4ffd67ffa$var$styles.dotPassable,
            onClick: ()=>onDotClick?.(i),
            "aria-label": formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_dot_label, {
                index: i + 1,
                total: totalSlides
            }),
            "aria-current": i === slideIndex ? 'true' : undefined,
            testId: `${testId}-dot-${i}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: (0, $w6R6I.cx)($d76e07b4ffd67ffa$var$styles.dot, i === slideIndex && $d76e07b4ffd67ffa$var$styles.dotActive)
        }))))), !isCompact && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.columnImage,
        testId: `${testId}-image-panel-${slideIndex}`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.imageContainer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d76e07b4ffd67ffa$var$styles.imageAbsolute
    }, renderedImage))));
};
var $d76e07b4ffd67ffa$export$2e2bcd8739ae039 = $d76e07b4ffd67ffa$var$CarouselSlide;


const $271896453320d65e$var$styles = {
    carousel: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _39xV02N91d _0jFU0VN91d _1mT5xdRAKS"
};
const $271896453320d65e$var$fadeIn = null;
const $271896453320d65e$var$slideWrapperMap = {
    static: "_39xV02N91d _0jFU0VN91d",
    animated: "_39xV02N91d _0jFU0VN91d _1gBibyZMPz _0nFVCGwPCu _43vdfTF4l5 _3Y6bKpZSoF _0LqqFdYbGa _0adGzLrPZy"
};
const $271896453320d65e$var$getSize = (width, height)=>{
    if (width < 200 || height < 100) return 'minimal';
    if (width < 400 || height < 140) return 'compact';
    return 'full';
};
const $271896453320d65e$var$Carousel = ({ icon: icon, iconLabel: iconLabel, initialSlideIndex: initialSlideIndex = 0, items: items, onNextClick: onNextClick, onPrimaryButtonClick: onPrimaryButtonClick, primaryButtonLabel: primaryButtonLabel, testId: testId = 'embed-card-teaser-carousel' })=>{
    const [activeIndex, setActiveIndex] = (0, $cozmU.useState)(initialSlideIndex);
    const [size, setSize] = (0, $cozmU.useState)('full'); // Tracks whether the user has navigated at least once.
    // The first slide is rendered statically (no animation) to avoid any
    // CSS animation running during SSR or on the initial paint.
    const hasNavigated = (0, $cozmU.useRef)(false);
    const containerRef = (0, $cozmU.useRef)(null); // Observe the carousel container's size and update the layout bucket.
    (0, $cozmU.useEffect)(()=>{
        const el = containerRef.current;
        if (!el) return;
        const observer = new ResizeObserver(([entry])=>{
            const { width: width, height: height } = entry.contentRect;
            setSize($271896453320d65e$var$getSize(width, height));
        });
        observer.observe(el);
        return ()=>observer.disconnect();
    }, []);
    const goNext = (0, $cozmU.useCallback)(()=>{
        hasNavigated.current = true;
        onNextClick?.(items[activeIndex].id);
        setActiveIndex((current)=>(current + 1) % items.length);
    }, [
        items,
        activeIndex,
        onNextClick
    ]);
    const goTo = (0, $cozmU.useCallback)((index)=>{
        if (index === activeIndex) return;
        hasNavigated.current = true;
        setActiveIndex(index);
    }, [
        activeIndex
    ]);
    const handlePrimaryButtonClick = (0, $cozmU.useCallback)(()=>{
        onPrimaryButtonClick?.(items[activeIndex].id);
    }, [
        onPrimaryButtonClick,
        items,
        activeIndex
    ]);
    const currentSlide = items[activeIndex];
    const isLastSlide = activeIndex === items.length - 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: containerRef,
        xcss: $271896453320d65e$var$styles.carousel,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        key: activeIndex,
        xcss: $271896453320d65e$var$slideWrapperMap[hasNavigated.current ? 'animated' : 'static'],
        "aria-live": "polite"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d76e07b4ffd67ffa$export$2e2bcd8739ae039), {
        primaryButtonLabel: primaryButtonLabel,
        description: currentSlide.description,
        icon: icon,
        iconLabel: iconLabel,
        image: currentSlide.image,
        title: currentSlide.title,
        onPrimaryButtonClick: onPrimaryButtonClick ? handlePrimaryButtonClick : undefined,
        onDotClick: goTo,
        onNextClick: !isLastSlide ? goNext : undefined,
        size: size,
        slideIndex: activeIndex,
        testId: `${testId}-slide`,
        totalSlides: items.length
    })));
};
var $271896453320d65e$export$2e2bcd8739ae039 = $271896453320d65e$var$Carousel;










const $b229bec432b10716$var$LazyRovoChatBenefitImage = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("JMHgK")));
var $b229bec432b10716$export$2e2bcd8739ae039 = $b229bec432b10716$var$LazyRovoChatBenefitImage;






const $94cf8a623e442cb8$var$LazyRovoSearchBenefitImage = /*#__PURE__*/ (0, $cozmU.lazy)(()=>(parcelRequire("1DOok")));
var $94cf8a623e442cb8$export$2e2bcd8739ae039 = $94cf8a623e442cb8$var$LazyRovoSearchBenefitImage;


/* NoAuthAvailableImage.tsx generated by @compiled/babel-plugin v2.0.0 */ 






const $98d344ae937c575f$var$styles = {
    container: "_39xV02N91d _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0Of8r2NHnM _1wydGWNHnM"
};
const $98d344ae937c575f$var$NoAuthAvailableImage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $98d344ae937c575f$var$styles.container
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $100aad242333a22e$export$6526edaac83a8c90), null));
var $98d344ae937c575f$export$2e2bcd8739ae039 = $98d344ae937c575f$var$NoAuthAvailableImage;






var $NlHoa = parcelRequire("NlHoa");


var $6lKz8 = parcelRequire("6lKz8");


var $9Q3yl = parcelRequire("9Q3yl");


var $bltJZ = parcelRequire("bltJZ");

parcelRequire("cozmU");


var $hQVHS = parcelRequire("hQVHS");


var $hcVQz = parcelRequire("hcVQz");

const $442b446e44696e25$export$5ed3e1bb3b04fc02 = (0, $hcVQz.tempSizeWrapper)((0, $hQVHS.ProjectsIcon));



var $8JGXU = parcelRequire("8JGXU");


var $6YXrY = parcelRequire("6YXrY");


var $ecv2t = parcelRequire("ecv2t");

const $cf42489b45990929$export$4384da9b8b140bf4 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $ecv2t.TrelloIcon), (0, $8JGXU.TrelloIcon));


const $8744eb45bfff96be$var$ProductIcon = ({ product: product, size: size = 'xsmall' })=>{
    switch(product){
        case 'ATLAS':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $442b446e44696e25$export$5ed3e1bb3b04fc02), {
                size: size
            });
        case 'BITBUCKET':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6lKz8.BitbucketIcon), {
                size: size
            });
        case 'CONFLUENCE':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Q3yl.ConfluenceIcon), {
                size: size
            });
        case 'JIRA':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
                size: size
            });
        case 'TRELLO':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cf42489b45990929$export$4384da9b8b140bf4), {
                size: size
            });
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $NlHoa.AtlassianIcon), {
                appearance: "brand",
                size: size
            });
    }
};
var $8744eb45bfff96be$export$2e2bcd8739ae039 = $8744eb45bfff96be$var$ProductIcon;


/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 



var $kkpJg = parcelRequire("kkpJg");

const $3a6f3ec5db73232c$var$SmartLinkBenefitImage = ({ productIcon: productIcon, providerIcon: providerIcon })=>{
    const productIconSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kkpJg.default), {
        icon: productIcon,
        x: 68,
        y: 58,
        w: 24,
        h: 24
    });
    const providerIconSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kkpJg.default), {
        icon: providerIcon,
        x: 98.8,
        y: 217.1,
        w: 20,
        h: 20
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "100%",
        viewBox: "0 0 440 660",
        preserveAspectRatio: "xMidYMin meet",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_3120_9396)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        transform: "scale(1.3) translate(0, 0)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M366.41 476.854C366.44 476.804 366.44 476.714 366.5 476.644C364.75 475.764 364.55 473.604 363.2 472.314L363.15 472.264C361.78 471.824 362.15 470.454 360.45 470.444C360.45 470.444 360.89 470.224 360.9 470.224C358.14 467.484 351.32 460.754 351.32 460.754C351.17 461.364 352.41 460.304 353.66 460.484C353.66 460.484 353.75 460.254 353.84 460.434C357.03 457.324 360.62 456.134 364.7 454.654C366.74 454.104 367.05 448.334 363.56 450.724C363.52 450.684 363.43 450.654 363.39 450.584C362.17 452.004 360.14 451.484 358.6 452.224L358.54 452.254L355.98 453.504C354.59 454.074 352.94 454.524 351.21 454.964C351.26 454.914 351.31 454.864 351.36 454.814C351.36 454.814 351.54 452.044 351.49 450.674C351.49 450.674 353.24 448.474 352.66 446.964C353.65 445.194 357.17 441.324 353.97 440.224C352.92 440.224 352.1 439.314 351.74 441.004C351.68 440.994 351.6 441.014 351.52 440.984C351.33 442.734 349.26 443.974 348.69 445.634L348.67 445.704C348.81 447.124 347.71 448.524 347.7 448.524C347.18 449.824 346.5 451.244 345.78 452.724C345.48 451.924 345.15 451.214 344.82 450.704C343.62 449.404 344.13 431.644 339.69 435.564C339.9 438.914 340.96 442.404 340.1 445.384C339.68 445.614 340.32 446.804 340.84 447.774C340.8 449.004 340.55 449.664 340.48 451.424C338.28 449.834 328.68 441.784 329.27 447.204C330.3 447.754 331.05 448.384 331.59 449.664C332.09 450.214 336.5 452.694 336.64 453.314C336.35 454.174 341.56 454.864 339.45 455.504C339.76 456.184 340.18 456.834 340.67 457.464C338.39 457.704 335.66 458.374 334.23 459.244C333.98 459.674 324.88 460.254 321.58 462.384C319.61 463.494 317.87 464.044 319.92 465.714C320.66 465.114 323.44 465.974 323.38 465.184C324.06 465.464 328.66 463.704 329.17 464.004C329.42 464.404 333.04 462.284 332.61 463.284C335.12 463.994 338.18 463.414 341.36 462.604C340.1 464.604 338.86 467.454 338.7 469.224C337.62 471.494 334.77 476.514 333.86 479.594C332.56 481.834 333.01 482.014 334.65 483.164L334.68 483.194C335.02 483.424 334.64 483.194 335.93 483.244C335.8 483.124 335.61 482.604 335.36 482.694C335.53 482.344 337.49 481.844 336.67 481.374C336.64 481.304 337.92 480.324 338.05 479.264C339.19 475.484 341.92 473.574 343.94 469.264C343.89 469.714 347.29 478.184 347.13 482.404C346.88 484.484 351.92 487.584 351.19 482.944C351.25 482.924 351.3 482.844 351.39 482.834C350.58 480.924 351.65 478.954 351.23 477.014L351.21 476.934C350.3 475.754 351.35 474.774 349.91 473.814C349.91 473.814 350.4 473.864 350.41 473.874C349.77 471.124 349.37 467.764 348.77 464.754C350.92 466.704 352.81 468.804 353.59 471.114L353.69 470.964C353.69 471.034 353.84 471.084 353.71 471.244C355.52 471.624 356.14 472.384 357.45 472.894C357.45 472.894 358.85 475.424 360.48 475.514L362.96 479.024C364.03 480.834 369.8 479.794 366.45 476.894L366.41 476.854Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "44",
        y: "42",
        width: "417",
        height: "618",
        rx: "12",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "351.259",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2249 94)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "351.259",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2126 112.083)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "107",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2007 130.165)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "351.259",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2324 385)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "351.259",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2205 403)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "271.987",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 68.2083 421)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "26.8308",
        height: "7.5752",
        transform: "matrix(0.999993 0.00317261 -0.00509147 0.99999 342.951 94.4097)",
        fill: "#D3F1A7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "34.6884",
        height: "12.9096",
        transform: "matrix(0.999993 0.00317261 -0.00509147 0.99999 370.104 80.0767)",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M368.765 80.1709L370.08 80.1759L369.983 102.033L368.668 102.028L368.765 80.1709Z",
        fill: "#82B536"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "26.1985",
        height: "2.5257",
        transform: "matrix(0.999993 0.00317261 -0.00509147 0.99999 373.772 85.4707)",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "62",
        height: "8",
        transform: "matrix(1 -0.000310775 -0.000336467 1 100.479 66.0459)",
        fill: "#F0F1F2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "75.0083",
        height: "15.7741",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.793 233.837)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "75.0083",
        height: "15.7741",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.793 233.837)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "16.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.946 233.803)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "16.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.946 233.803)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "31",
        height: "8",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 211.886 238.778)",
        fill: "#94C748"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "75.0083",
        height: "15.7741",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.784 249.924)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "75.0083",
        height: "15.7741",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.784 249.924)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "16.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.937 249.89)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "16.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.937 249.89)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "50",
        height: "8",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 226.663 254.858)",
        fill: "#FBD779"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "74.805",
        height: "14.961",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.776 266.012)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "74.805",
        height: "14.961",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.776 266.012)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "15.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.725 265.977)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "15.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.725 265.977)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "8",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 217.979 270.451)",
        fill: "#C97CF4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "74.805",
        height: "14.961",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.767 281.744)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "74.805",
        height: "14.961",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 117.767 281.744)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "15.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.717 281.71)",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "0.936372",
        y: "0.932176",
        width: "152.13",
        height: "15.1299",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 192.717 281.71)",
        stroke: "#F0F1F2",
        strokeWidth: "1.87013"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "8",
        transform: "matrix(1.00193 -0.000455984 -0.000532466 0.997369 262.94 286.163)",
        fill: "#357DE8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_3120_9396)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M223.554 267.082C223.289 267.367 222.539 267.001 222.639 266.641C222.787 266.127 222.999 265.621 223.339 265.003C223.771 264.319 224.027 264.224 224.276 263.745C224.733 262.944 225.285 261.498 225.416 261.145C225.438 261.092 225.457 261.045 225.493 260.999C225.523 260.949 225.521 260.997 225.564 260.954C225.571 260.942 225.581 260.939 225.582 260.923C225.582 260.923 225.572 260.91 225.569 260.9L225.556 260.893C225.509 260.87 225.462 260.846 225.415 260.822C224.942 260.621 224.374 260.389 223.818 260.195C222.789 259.785 222.154 259.534 221.821 259.405C221.041 259.089 220.483 258.781 219.969 258.415C219.687 258.215 219.976 257.579 220.329 257.63C220.971 257.722 221.594 257.877 222.381 258.181C222.683 258.302 223.405 258.379 224.317 258.706C224.469 258.759 224.609 258.83 224.739 258.92C225.112 259.158 225.543 259.386 225.945 259.574L226.093 259.649C226.18 259.678 226.254 259.715 226.331 259.746C226.499 259.816 226.66 259.882 226.811 259.95C227.121 260.075 227.396 260.183 227.628 260.277C227.337 260.799 227.177 261.097 227.177 261.097C227.177 261.097 225.861 263.422 225.305 264.405C224.914 265.094 224.726 265.426 224.608 265.625C224.255 266.236 223.925 266.69 223.55 267.088L223.554 267.082Z",
        fill: "#292A2E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M211.197 241.523C212.078 240.978 212.545 241.643 211.861 242.255C210.914 243.162 210.001 244.175 209.137 245.648C208.645 246.479 208.376 247.02 208.168 247.504C207.953 247.984 207.802 248.415 207.69 249.06C207.488 250.152 207.549 251.652 207.875 252.924C208.02 253.562 208.273 254.135 208.458 254.601C208.696 255.052 208.879 255.404 208.984 255.594C209.058 255.705 209.129 255.821 209.192 255.934C209.397 256.353 210.037 257.478 211.223 258.622C211.797 259.212 212.55 259.749 213.357 260.24C214.182 260.7 215.077 261.115 216 261.35C216.634 261.56 217.235 261.648 217.774 261.752C218.322 261.813 218.805 261.865 219.234 261.89C220.098 261.917 220.732 261.861 221.161 261.813C223.198 261.565 224.664 261.06 226.063 260.448C226.812 260.095 227.271 260.643 226.549 261.172C225.23 262.091 223.63 262.835 221.343 263.124C220.478 263.217 218.562 263.598 215.947 262.954C215.532 262.832 215.106 262.728 214.724 262.534C213.033 261.802 211.304 260.632 210.175 259.525C209.878 259.261 209.626 258.996 209.418 258.745C209.209 258.493 208.995 258.296 208.864 258.092C208.579 257.705 208.407 257.48 208.407 257.48C208.407 257.48 208.346 257.392 208.236 257.24C208.14 257.078 208.003 256.839 207.834 256.551C207.489 255.972 207.111 255.126 206.816 254.168C206.184 252.249 206.242 249.858 206.558 248.501C207.012 246.456 207.592 245.564 207.882 245.017C208.855 243.374 210.003 242.319 211.197 241.523Z",
        fill: "#292A2E"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "72",
        y: "161",
        width: "347",
        height: "207",
        rx: "6",
        fill: "#8FB8F6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        x: "66.75",
        y: "155.75",
        width: "348.5",
        height: "207.5",
        rx: "3.25",
        fill: "#F9FBFD",
        stroke: "#8FB8F6",
        strokeWidth: "1.5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "107",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 103.012 173.165)",
        fill: "#D0DEF2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("mask", {
        id: "path-49-inside-1_3120_9396",
        fill: "white"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M103 206H379V362H103V206Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M103 206H379V362H103V206Z",
        fill: "white"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M103 206V205H102V206H103ZM379 206H380V205H379V206ZM103 206V207H379V206V205H103V206ZM379 206H378V362H379H380V206H379ZM103 362H104V206H103H102V362H103Z",
        fill: "#0B120E",
        fillOpacity: "0.14",
        mask: "url(#path-49-inside-1_3120_9396)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "107",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 121.005 224.002)",
        fill: "#6B6E76"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "237.496",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 121.005 242.005)",
        fill: "#6B6E76"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "237.496",
        height: "8",
        transform: "matrix(1 -2.23478e-05 -0.000671322 1 121.005 260.005)",
        fill: "#6B6E76"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M61.3378 122.737C61.6171 122.177 58.1342 113.118 57.2561 115.732C56.801 116.617 57.0322 117.422 58.0247 117.666C56.2623 117.985 59.0352 119.646 58.611 120.492C57.284 120.234 60.4323 122.647 59.0166 122.206C59.6449 132.085 75.9612 151.538 63.6634 127.589C63.5817 130.007 62.6201 127.756 62.6812 126.669C64.6157 128.167 62.2943 123.699 61.5656 122.884C61.8811 124.279 60.2179 122.01 61.3344 122.741L61.3378 122.737Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M49.5857 140.943C49.2459 139.662 39.2484 134.515 38.2637 133.861C35.9524 132.802 36.384 135.758 38.2594 136.193C38.6122 136.426 41.3136 137.197 40.3497 137.823C41.4171 140.321 46.0137 140.555 46.7236 142.668C47.2511 142.314 48.1137 143.046 48.4778 142.865C48.5362 143.497 49.4685 143.827 49.5152 143.674C52.2908 146.31 54.2499 142.903 50.7524 141.538C50.8676 141.425 50.1541 140.706 49.5943 140.943L49.5857 140.943Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M39.4701 174.033C41.1809 175.147 39.6046 175.107 38.7741 174.555C39.8901 173.487 36.7954 173.565 36.0723 173.932C36.4066 173.988 36.5682 174.533 35.8805 174.456C36.2338 173.13 27.5479 172.249 31.8883 175.362C32.0358 175.367 32.0059 174.299 32.2092 174.645C32.0627 176.249 33.3227 175.211 33.6952 175.114C33.7617 175.957 34.0569 175.199 34.1847 175.555C33.8165 176.657 35.8605 174.913 35.4289 176C37.5666 177.865 41.2905 175.863 42.9467 177.541C43.8244 175.717 50.427 179.002 47.6545 175.204C44.8439 174.19 42.5606 173.57 39.4701 174.033Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M21.2561 153.478C20.8018 156.036 26.7133 155.89 28.429 157.072C30.5261 158.735 52.0689 165.506 46.1376 159.992C39.609 157.994 34.4269 155.302 26.3618 153.802C25.0538 153.469 20.9211 151.644 21.2561 153.478Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M82.7198 134.846C85.0673 136.492 82.5184 138.446 84.4665 139.99C88.1502 142.366 87.5201 123.15 84.0027 123.526C81.095 124.254 83.8998 133.561 82.7198 134.846Z",
        fill: "#101214"
    }), productIconSlot), providerIconSlot), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("linearGradient", {
        id: "paint0_linear_3120_9396",
        x1: "89.6875",
        y1: "172.49",
        x2: "89.6875",
        y2: "177.111",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "#1A237E",
        stopOpacity: "0.2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "#1A237E",
        stopOpacity: "0.02"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("radialGradient", {
        id: "paint1_radial_3120_9396",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(77.4644 167.395) scale(24.8062 23.319)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        stopColor: "white",
        stopOpacity: "0.1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("stop", {
        offset: "1",
        stopColor: "white",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_3120_9396"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "440",
        height: "660",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_3120_9396"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white",
        transform: "matrix(1 -0.000310775 -0.000336467 1 68.0081 58.0562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_3120_9396"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "18.4543",
        height: "24.9028",
        fill: "white",
        transform: "matrix(-0.507908 0.846939 0.903773 0.454122 212.523 240.466)"
    }))));
};
var $3a6f3ec5db73232c$export$2e2bcd8739ae039 = $3a6f3ec5db73232c$var$SmartLinkBenefitImage;


const $8c5432aa21bcbbd9$var$PARENT_PRODUCT = {
    ATLAS: 'ATLAS',
    BITBUCKET: 'BITBUCKET',
    CONFLUENCE: 'CONFLUENCE',
    CSM: 'JIRA',
    JPD: 'JIRA',
    JSM: 'JIRA',
    JSW: 'JIRA',
    JWM: 'JIRA',
    TRELLO: 'TRELLO'
};
const $8c5432aa21bcbbd9$var$PRODUCT_COMPANION = {
    ATLAS: 'ATLAS',
    BITBUCKET: 'BITBUCKET',
    CONFLUENCE: 'JIRA',
    JIRA: 'CONFLUENCE',
    TRELLO: 'TRELLO'
};
const $8c5432aa21bcbbd9$var$UnauthorizedCarouselView = ({ context: context, frameStyle: frameStyle, inheritDimensions: inheritDimensions, isSelected: isSelected, onAuthorize: onAuthorize, onClick: onClick, testId: testId = 'embed-card-unauthorized-view', url: url })=>{
    (0, $6cFsl.di)((0, $271896453320d65e$export$2e2bcd8739ae039));
    (0, $6cFsl.di)((0, $b229bec432b10716$export$2e2bcd8739ae039));
    (0, $6cFsl.di)((0, $94cf8a623e442cb8$export$2e2bcd8739ae039));
    const intl = (0, $kSwu1.useIntl)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const { rovoOptions: rovoOptions, product: product } = (0, $8QLAc.default)();
    const canAuthorize = typeof onAuthorize === 'function';
    const providerName = context?.text;
    const providerIcon = (0, $cozmU.useMemo)(()=>{
        const iconLabel = context?.iconLabel ?? context?.text ?? '';
        if (typeof context?.icon === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            src: context.icon,
            alt: iconLabel
        });
        if (context?.icon) return context.icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lSQgn.default), {
            appearance: "blue",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cSGyR))),
            label: iconLabel,
            size: "small",
            testId: "embed-card-fallback-icon"
        });
    }, [
        context
    ]);
    const items = (0, $cozmU.useMemo)(()=>{
        if (!canAuthorize) return [
            {
                id: 'no-auth-available',
                title: intl.formatMessage((0, $dM7c5.messages).unauthorised_account_name_no_provider),
                description: intl.formatMessage((0, $dM7c5.messages).unauthorised_account_description_no_provider),
                image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $98d344ae937c575f$export$2e2bcd8739ae039), null)
            }
        ];
        const parentProduct = product ? $8c5432aa21bcbbd9$var$PARENT_PRODUCT[product] : undefined;
        const parentProductIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8744eb45bfff96be$export$2e2bcd8739ae039), {
            product: parentProduct
        });
        const parentProductAlt = parentProduct ? $8c5432aa21bcbbd9$var$PRODUCT_COMPANION[parentProduct] : parentProduct;
        const parentProductIconAlt = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8744eb45bfff96be$export$2e2bcd8739ae039), {
            product: parentProductAlt
        });
        // We only have special text for Google Drive and i18n select takes only one word (no space).
        const i18nSelectContext = context?.text === 'Google Drive' ? 'Google' : context?.text;
        const slides = [
            {
                id: 'smart-link-benefit',
                title: intl.formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_sl_title),
                description: intl.formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_sl_description, {
                    context: i18nSelectContext,
                    product: parentProduct
                }),
                image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3a6f3ec5db73232c$export$2e2bcd8739ae039), {
                    productIcon: parentProductIcon,
                    providerIcon: providerIcon
                })
            }
        ];
        // If the link has an unauthorized status and provides an onAuthorize callback,
        // it is likely a 3P (third-party) link and is supported by Rovo. In that case,
        // we show additional Rovo-specific teaser slides to encourage the user to connect their account.
        if (rovoOptions?.isRovoEnabled) slides.push({
            id: 'rovo-search-benefit',
            title: intl.formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_rovo_title),
            description: intl.formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_rovo_description, {
                context: providerName,
                product: parentProduct
            }),
            image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $94cf8a623e442cb8$export$2e2bcd8739ae039), {
                productIcon: parentProductIcon,
                productIconAlt: parentProductIconAlt,
                providerIcon: providerIcon
            }))
        });
        if (rovoOptions?.isRovoEnabled && rovoOptions?.isRovoLLMEnabled) slides.push({
            id: 'rovo-chat-benefit',
            title: intl.formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_rovochat_title),
            description: intl.formatMessage((0, $dM7c5.messages).connect_link_account_embed_carousel_rovochat_description, {
                context: providerName
            }),
            image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Suspense), {
                fallback: null
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b229bec432b10716$export$2e2bcd8739ae039), {
                productIcon: parentProductIcon,
                productIconAlt: parentProductIconAlt,
                providerIcon: providerIcon
            }))
        });
        return slides;
    }, [
        canAuthorize,
        context,
        intl,
        product,
        providerName,
        providerIcon,
        rovoOptions
    ]);
    const handleOnAuthorizeClick = (0, $cozmU.useCallback)((slideId)=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            fireEvent('ui.button.clicked.carouselConnect', {
                display: 'embed',
                slideId: slideId
            });
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const handleOnNextClick = (0, $cozmU.useCallback)((slideId)=>{
        fireEvent('ui.button.clicked.carouselNext', {
            display: 'embed',
            slideId: slideId
        });
    }, [
        fireEvent
    ]);
    const buttonLabel = context?.text ? intl.formatMessage((0, $dM7c5.messages).connect_3p_account, {
        context: context.text
    }) : intl.formatMessage((0, $dM7c5.messages).connect_link_account_card);
    const icon = (0, $cozmU.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(context?.icon)) return context.icon;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c56aa820dbfc924e$export$4a122bafaa48b23d), {
            default: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: "icon",
                color: "currentColor"
            }),
            src: typeof context?.icon === 'string' ? context.icon : undefined
        });
    }, [
        context?.icon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $856OS.ExpandedFrame), {
        allowScrollBar: true,
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        isSelected: isSelected,
        inheritDimensions: inheritDimensions,
        onClick: onClick,
        setOverflow: true,
        testId: testId,
        text: context?.text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $271896453320d65e$export$2e2bcd8739ae039), {
        icon: context?.icon,
        iconLabel: context?.text,
        items: items,
        onNextClick: handleOnNextClick,
        onPrimaryButtonClick: canAuthorize ? handleOnAuthorizeClick : undefined,
        primaryButtonLabel: buttonLabel,
        testId: `${testId}-carousel`
    }));
};
var $8c5432aa21bcbbd9$export$2e2bcd8739ae039 = $8c5432aa21bcbbd9$var$UnauthorizedCarouselView;


const $1d2b6b3921e803b4$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $cozmU.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $cozmU.useMemo)(()=>{
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: context?.text ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $dM7c5.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4bvRC.default), {
                    providerName: context?.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...(0, $dM7c5.messages).connect_unauthorised_account_action,
                    values: values
                }))
            };
        }
        const values = context?.text ? {
            context: context?.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $dM7c5.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $dM7c5.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).unauthorised_account_name_no_provider),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).unauthorised_account_description_no_provider)
        };
    }, [
        context?.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ffabb40f353fd16d$export$2e2bcd8739ae039), {
        ...unresolvedViewProps,
        ...content,
        icon: context?.icon,
        image: context?.image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $100aad242333a22e$export$6526edaac83a8c90), null),
        testId: testId,
        text: context?.text
    });
};
const $1d2b6b3921e803b4$var$UnauthorizedViewGated = (props)=>{
    if ((0, $cXtTj.default).initializeCompleted() && (0, $cXtTj.default).getExperimentValue('platform_sl_embed_preauth_teaser_exp', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8c5432aa21bcbbd9$export$2e2bcd8739ae039), props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1d2b6b3921e803b4$var$UnauthorizedView, props);
};
var $1d2b6b3921e803b4$export$2e2bcd8739ae039 = $1d2b6b3921e803b4$var$UnauthorizedViewGated;


const $b3ceae4ab8d9d0f7$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "smart-card-embed-card"
    }), children);
const $b3ceae4ab8d9d0f7$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, handleFrameAuxClick: handleFrameAuxClick, handleFrameContextMenu: handleFrameContextMenu, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton }, iframeRef)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $2Q7sv.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $2Q7sv.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $e8b011f03e2ed95f$export$f93c47f1b2b3f55b)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b3ceae4ab8d9d0f7$var$UFOLoadHoldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ca1983200af5b1b$export$2e2bcd8739ae039), {
                url: url,
                cardState: cardState,
                onClick: handleFrameClick,
                onError: onError,
                onResolve: onResolve,
                renderers: renderers,
                actionOptions: actionOptions,
                testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
            }));
        case 'resolved':
            const resolvedViewProps = (0, $f2176b8b78b3d5c8$export$d6cf81ca6e68bcc3)(details, platform, iframeUrlType);
            if (onResolve) onResolve({
                title: resolvedViewProps.title,
                url: url,
                aspectRatio: resolvedViewProps.preview?.aspectRatio,
                extensionKey: details?.meta?.key
            });
            if ((0, $97c57299ded7b56e$export$a019611f39785186)(shouldControlDataExport, cardState.details)) {
                const unauthViewProps = (0, $f2176b8b78b3d5c8$export$d6cf81ca6e68bcc3)(details, platform);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d2b6b3921e803b4$export$2e2bcd8739ae039), {
                    context: unauthViewProps.context,
                    extensionKey: extensionKey,
                    frameStyle: frameStyle,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    inheritDimensions: inheritDimensions,
                    isSelected: isSelected,
                    onAuthorize: handleAuthorize,
                    onClick: handleFrameClick,
                    testId: testId,
                    url: unauthViewProps.link
                });
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dcf92556a9a48ad$export$30f3c6c32b384a8b), {
                ...resolvedViewProps,
                actionOptions: actionOptions,
                details: details,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                // Support middle-/right-clicks for "resolved" only — the vast majority of clicks happen here.
                // Other states (e.g. "resolving") could be added later for completeness.
                onAuxClick: handleFrameAuxClick,
                onContextMenu: handleFrameContextMenu,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                onIframeMouseEnter: onIframeMouseEnter,
                onIframeMouseLeave: onIframeMouseLeave,
                testId: testId,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                extensionKey: extensionKey
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $77f5ac99c8e12626$export$68e1703c529dc7e0)(details);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Zwrg.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ca1983200af5b1b$export$2e2bcd8739ae039), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    // Support middle-/right-clicks for "resolved" only — the vast majority of clicks happen here.
                    // Other states (e.g. "resolving") could be added later for completeness.
                    onAuxClick: handleFrameAuxClick,
                    onContextMenu: handleFrameContextMenu,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $f2176b8b78b3d5c8$export$d6cf81ca6e68bcc3)(details, platform);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1d2b6b3921e803b4$export$2e2bcd8739ae039), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $f2176b8b78b3d5c8$export$d6cf81ca6e68bcc3)(details, platform);
            const cardMetadata = details?.meta ?? (0, $8p295.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5dcf92556a9a48ad$export$30f3c6c32b384a8b), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                extensionKey: extensionKey
            });
            const forbiddenAccessContext = (0, $leSBv.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: forbiddenViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0932ea1b8e978982$export$2e2bcd8739ae039), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $f2176b8b78b3d5c8$export$d6cf81ca6e68bcc3)(details, platform);
            const notFoundAccessContext = details?.meta ? (0, $leSBv.extractRequestAccessContextImproved)({
                jsonLd: details?.meta,
                url: url,
                product: notFoundViewProps.context?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2ca454ac27b3dd0b$export$2e2bcd8739ae039), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1402c290c2a79a1a$export$6819d845957344e), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});


































var $aw4sA = parcelRequire("aw4sA");


var $a1w5z = parcelRequire("a1w5z");





var $4uUBn = parcelRequire("4uUBn");


var $bAr6P = parcelRequire("bAr6P");

const $561dde74fc5c9bd8$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b8pma.default), {
        name: "smart-card-inline-card"
    }), children);
const $561dde74fc5c9bd8$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, handleFrameAuxClick: handleFrameAuxClick, handleFrameContextMenu: handleFrameContextMenu, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $2Q7sv.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const resolvedProps = status === (0, $4yYAm.SmartLinkStatus).Resolved ? (0, $77f5ac99c8e12626$export$68e1703c529dc7e0)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $cozmU.useEffect)(()=>{
        switch(status){
            case (0, $4yYAm.SmartLinkStatus).Resolved:
                onResolve?.({
                    url: url,
                    title: resolvedProps.title,
                    extensionKey: details?.meta?.key
                });
                break;
            case (0, $4yYAm.SmartLinkStatus).Errored:
            case (0, $4yYAm.SmartLinkStatus).Fallback:
            case (0, $4yYAm.SmartLinkStatus).Forbidden:
            case (0, $4yYAm.SmartLinkStatus).NotFound:
            case (0, $4yYAm.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title,
        details?.meta?.key
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($561dde74fc5c9bd8$var$UFOLoadHoldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4uUBn.InlineCardResolvingView), {
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                inlinePreloaderStyle: inlinePreloaderStyle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline
            }));
        case 'resolved':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1Zwrg.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                // Support middle-/right-clicks for "resolved" only — the vast majority of clicks happen here.
                // Other states (e.g. "resolving") could be added later for completeness.
                onAuxClick: handleFrameAuxClick,
                onContextMenu: handleFrameContextMenu,
                testId: testIdWithStatus,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'unauthorized':
            const provider = (0, $hHrlI.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bAr6P.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $hHrlI.extractSmartLinkProvider)(details);
            const cardMetadata = details?.meta ?? (0, $8p295.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $leSBv.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: providerForbidden?.text ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1w5z.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden?.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $hHrlI.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aw4sA.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h1uyX.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline,
                viewType: "errored"
            });
    }
};



var $19KQj = parcelRequire("19KQj");





var $fzDaA = parcelRequire("fzDaA");


var $4xRBl = parcelRequire("4xRBl");


var $lL0wb = parcelRequire("lL0wb");

const $adf961e1c1bb4505$var$withCardIntersectionObserver = (Component)=>(props)=>{
        // TODO: NAVX-4682: Add feature parity to LazyIntersectionObserverCard for no lazy loading
        const { appearance: appearance, children: children, id: id, onError: onErrorCallback, ui: ui, url: url = '' } = props;
        const { onIntersecting: onIntersecting, onStatusSettled: onStatusSettled } = (0, $4xRBl.useSmartLinkSeenEvent)({
            appearance: appearance,
            children: children,
            id: id,
            ui: ui,
            url: url
        });
        const onError = (0, $cozmU.useCallback)((data)=>{
            if (data?.status) onStatusSettled(data.status);
            onErrorCallback?.(data);
        }, [
            onStatusSettled,
            onErrorCallback
        ]);
        const ref = (0, $fzDaA.default)({
            onIntersecting: onIntersecting
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lL0wb.default), {
            appearance: props.appearance,
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, {
            ...props,
            onError: onError
        }));
    };
var $adf961e1c1bb4505$export$2e2bcd8739ae039 = $adf961e1c1bb4505$var$withCardIntersectionObserver;



















const $2f46b60da1a1e284$var$useExperimentMetaEventAttributes = ({ actionOptions: actionOptions, appearance: appearance, state: state })=>{
    const { connections: { client: { baseUrlOverride: baseUriWithNoTrailingSlash } } } = (0, $cMyWi.useSmartLinkContext)();
    const { rovoOptions: rovoOptions, product: product } = (0, $8QLAc.default)();
    const { details: details, status: status } = state;
    const extensionKey = (0, $2Q7sv.getExtensionKey)(details);
    const embedRovoActionsFooterExperimentMeta = appearance === 'embed' && status === 'resolved' ? (0, $9741347bf457b85f$export$d92e090f28e31112)({
        extensionKey: extensionKey,
        isRovoChatActionOptedIn: actionOptions?.rovoChatAction?.optIn ?? false,
        isRovoChatEnabled: (0, $aflIU.getIsRovoChatEnabled)(rovoOptions),
        product: product
    }) : undefined;
    if (!embedRovoActionsFooterExperimentMeta && !(0, $iDrrr.fg)('social-proof-3p-unauth-block-fg') && !(0, $iDrrr.fg)('platform_sl_3p_preauth_soc_proof_inline_killswitch')) return undefined;
    const blockSocialProofExperimentMeta = appearance === 'block' && status === 'unauthorized' && (0, $iDrrr.fg)('social-proof-3p-unauth-block-fg') ? (0, $593a61648c304682$export$49fab64ef7e3aab7)({
        extensionKey: extensionKey,
        baseUriWithNoTrailingSlash: baseUriWithNoTrailingSlash
    }) : undefined;
    const inlineSocialProofExperimentMeta = appearance === 'inline' && status === 'unauthorized' && (0, $iDrrr.fg)('platform_sl_3p_preauth_soc_proof_inline_killswitch') ? (0, $593a61648c304682$export$e53e13aaa7d7b805)({
        extensionKey: extensionKey,
        baseUriWithNoTrailingSlash: baseUriWithNoTrailingSlash
    }) : undefined;
    const experimentMeta = {
        ...blockSocialProofExperimentMeta,
        ...inlineSocialProofExperimentMeta,
        ...embedRovoActionsFooterExperimentMeta
    };
    if (Object.keys(experimentMeta).length > 0) return experimentMeta;
};
var $2f46b60da1a1e284$export$2e2bcd8739ae039 = $2f46b60da1a1e284$var$useExperimentMetaEventAttributes;


const $6c8ebed741634f4e$var$thirdPartyARIPrefix = 'ari:third-party';
function $6c8ebed741634f4e$var$Component({ id: id, url: url, title: title, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, disablePreviewPanel: disablePreviewPanel, placeholderData: placeholderData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    let isFlexibleUi = (0, $cozmU.useMemo)(()=>(0, $4abK1.isFlexibleUiCard)(children, ui), [
        children,
        ui
    ]);
    // Get state, actions for this card.
    // appearance is pre-resolved by the caller (loader.tsx for Card, ssr.tsx for CardSSR):
    // FlexibleCards are always passed appearance='block' when FG is on, so component.tsx
    // simply consumes whatever appearance it receives.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $13cbf7ecf495c2ea$export$9f4e486b1dc3e700)(id, url, appearance);
    const ari = (0, $2Q7sv.getObjectAri)(state.details);
    const name = (0, $2Q7sv.getObjectName)(state.details);
    const definitionId = (0, $2Q7sv.getDefinitionId)(state.details);
    const extensionKey = (0, $2Q7sv.getExtensionKey)(state.details);
    const resourceType = (0, $2Q7sv.getResourceType)(state.details);
    const services = (0, $2Q7sv.getServices)(state.details);
    const thirdPartyARI = (0, $2Q7sv.getThirdPartyARI)(state.details);
    const firstPartyIdentifier = (0, $2Q7sv.getFirstPartyIdentifier)();
    const appendCrossProductAnalyticsParams = (0, $dz9dk.useSmartLinkCrossProductUrlWrapperGated)({
        details: state.details
    });
    const actionOptions = (0, $5b32e42d109a17bd$export$2ae4cf79c720146a)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    // TODO: [ZS] Add new experiment flag to determine if the Rovo Actions CTA should be shown
    const rovoActionsCtaShown = false;
    const fire3PClickEvent = (0, $iDrrr.fg)('platform_smartlink_3pclick_analytics') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $19KQj.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    // Shared scope guard for all 3P-click handlers.
    const shouldFire3PClickEvent = thirdPartyARI && thirdPartyARI.startsWith($6c8ebed741634f4e$var$thirdPartyARIPrefix) && (0, $2Q7sv.getClickUrl)(url, state.details) === url && fire3PClickEvent && (0, $iDrrr.fg)('platform_smartlink_3pclick_analytics');
    const getDestinationUrl = (0, $cozmU.useCallback)(()=>{
        // FIXME: destinationUrl should be rendered in the DOM anchor href instead of derived at click time
        const preferredUrl = (0, $2Q7sv.getClickUrl)(url, state.details) ?? url;
        return appendCrossProductAnalyticsParams(preferredUrl) ?? preferredUrl;
    }, [
        appendCrossProductAnalyticsParams,
        state.details,
        url
    ]);
    // Setup UI handlers.
    const handleClickWrapper = (0, $cozmU.useCallback)((event)=>{
        const isModifierKeyPressed = (0, $16kNn.isSpecialKey)(event) || (0, $16kNn.isSpecialClick)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $4yYAm.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        if (shouldFire3PClickEvent) // For questions or concerns about this event,
        // please reach out to the 3P Workflows Team via Slack in #help-3p-connector-workflow
        fire3PClickEvent?.();
        const isDisablePreviewPanel = disablePreviewPanel && (0, $fqVYq.editorExperiment)('platform_editor_preview_panel_linking_exp', true, {
            exposure: true
        });
        if ((0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping')) {
            // FIXME: InlineCard, BlockCard and EmbedCard call event.preventDefault() internally
            // before the event bubbles up to this handler. This forces us to snapshot
            // event.defaultPrevented before calling onClick to detect whether the consumer
            // specifically prevented navigation. Ideally those components should not call
            // preventDefault so this workaround can be removed.
            const isEventDefaultPrevented = event.defaultPrevented;
            const canOpenPreviewPanel = !isModifierKeyPressed && ari && name && openPreviewPanel && isPreviewPanelAvailable?.({
                ari: ari
            }) && !isDisablePreviewPanel;
            // Preview panel takes priority over link navigation when available.
            if (canOpenPreviewPanel) {
                event.preventDefault();
                event.stopPropagation();
                openPreviewPanel({
                    url: url,
                    ari: ari,
                    name: name,
                    iconUrl: (0, $2Q7sv.getObjectIconUrl)(state.details),
                    panelData: {
                        embedUrl: (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $8OcYi.extractSmartLinkEmbed)(state.details)?.src : undefined
                    }
                });
                (0, $l1f3f.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                    attributes: {
                        clickOutcome: 'previewPanel'
                    }
                });
                return;
            }
            const destinationUrl = getDestinationUrl();
            (0, $5C2uB.updateAnchorHref)(event, destinationUrl);
            // For FlexibleCard, read target from the clicked anchor element (e.g. _blank for links
            // rendered with explicit target). For classic cards, default to _self
            const { target: anchorTarget } = (0, $5C2uB.getAnchorAttributesFromEvent)(event);
            const target = (0, $16kNn.isSpecialEvent)(event) ? '_blank' : isFlexibleUi ? anchorTarget : '_self';
            onClick?.(event, {
                url: url,
                destinationUrl: destinationUrl
            });
            // Check if the event is prevented via onClick callback
            const consumerPreventedNavigation = event.defaultPrevented && !isEventDefaultPrevented;
            // Classic cards (InlineCard, BlockCard, EmbedCard) rely on their own anchor navigation
            // when onClick is provided, so this handler should not open the link for them.
            // FlexibleCard's anchor is prevented from native navigation, so this handler always
            // opens the link for FlexibleCard unless the consumer's onClick called preventDefault.
            const shouldOpenLink = isFlexibleUi || !onClick;
            const doOpenLink = shouldOpenLink && !consumerPreventedNavigation;
            if (doOpenLink) {
                event.preventDefault();
                window.open(destinationUrl, target);
            }
            // Only set clickOutcome when this handler actually opened the link.
            // If a parent onClick handled navigation, fire a generic click event instead.
            (0, $l1f3f.fireLinkClickedEvent)(createAnalyticsEvent)(event, doOpenLink ? {
                attributes: {
                    clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                }
            } : undefined);
        } else {
            // If preview panel is available and the user clicked on the link,
            // delegate the click to the preview panel handler
            if (!isModifierKeyPressed && ari && name && openPreviewPanel && isPreviewPanelAvailable?.({
                ari: ari
            }) && !isDisablePreviewPanel) {
                event.preventDefault();
                event.stopPropagation();
                openPreviewPanel({
                    url: url,
                    ari: ari,
                    name: name,
                    iconUrl: (0, $2Q7sv.getObjectIconUrl)(state.details),
                    panelData: {
                        embedUrl: (0, $ieeJu.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (0, $8OcYi.extractSmartLinkEmbed)(state.details)?.src : undefined
                    }
                });
                (0, $l1f3f.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                    attributes: {
                        clickOutcome: 'previewPanel'
                    }
                });
                return;
            } else if (!onClick && !isFlexibleUi) {
                const clickUrl = (0, $2Q7sv.getClickUrl)(url, state.details);
                // Ctrl+left click on mac typically doesn't trigger onClick
                // The event could have potentially had `e.preventDefault()` called on it by now
                // event by smart card internally
                // If it has been called then only then can `isSpecialEvent` be true.
                const target = (0, $16kNn.isSpecialEvent)(event) ? '_blank' : '_self';
                window.open(clickUrl, target);
                (0, $l1f3f.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                    attributes: {
                        clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
                    }
                });
            } else {
                if (onClick) onClick(event);
                (0, $l1f3f.fireLinkClickedEvent)(createAnalyticsEvent)(event);
            }
        }
    }, [
        fireEvent,
        id,
        isFlexibleUi,
        appearance,
        definitionId,
        getDestinationUrl,
        onClick,
        url,
        state.details,
        ari,
        name,
        fire3PClickEvent,
        shouldFire3PClickEvent,
        isPreviewPanelAvailable,
        openPreviewPanel,
        createAnalyticsEvent,
        disablePreviewPanel
    ]);
    // Middle-click handler to trigger fire3PClickEvent on middle-clicks.
    // Scope is limited to 3P click analytics.
    const handleFrameAuxClick = (0, $cozmU.useCallback)((event)=>{
        if ((0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping')) {
            const destinationUrl = getDestinationUrl();
            (0, $5C2uB.updateAnchorHref)(event, destinationUrl);
        }
        // isAuxClick filters Windows right-clicks (button === 2) that also fire onAuxClick.
        if ((0, $5C2uB.isAuxClick)(event) && shouldFire3PClickEvent) fire3PClickEvent?.({
            isAuxClick: true
        });
    }, [
        fire3PClickEvent,
        getDestinationUrl,
        shouldFire3PClickEvent
    ]);
    // Right-click handler to trigger fire3PClickEvent on right-clicks.
    // Scope is limited to 3P click analytics.
    const handleFrameContextMenu = (0, $cozmU.useCallback)((event)=>{
        if ((0, $iDrrr.fg)('platform_smartlink_xpc_url_wrapping')) {
            const destinationUrl = getDestinationUrl();
            (0, $5C2uB.updateAnchorHref)(event, destinationUrl);
        }
        if (shouldFire3PClickEvent) fire3PClickEvent?.({
            isContextMenu: true
        });
    }, [
        fire3PClickEvent,
        getDestinationUrl,
        shouldFire3PClickEvent
    ]);
    const { reload: reload } = actions;
    const handleAuthorize = (0, $cozmU.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $cozmU.useCallback)(()=>{
        reload();
    }, [
        reload
    ]);
    const hasMounted = (0, $cozmU.useRef)(false);
    const prevAppearance = (0, $cozmU.useRef)(appearance);
    // When appearance changes from inline to non-inline on a mounted card
    // (e.g. direct consumer changes inline → block/embed), reload with the new appearance
    // so ORS can return the appropriate full data. We intentionally do NOT reload on
    // block → embed or embed → block transitions since both already have full ORS data.
    (0, $cozmU.useEffect)(()=>{
        if (!hasMounted.current) {
            hasMounted.current = true;
            prevAppearance.current = appearance;
            return;
        }
        if (prevAppearance.current === 'inline' && appearance !== 'inline' && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization')) reload(appearance);
        prevAppearance.current = appearance;
    }, [
        appearance,
        reload
    ]);
    const handleInvoke = (0, $cozmU.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    const experimentMetaEventAttributes = (0, $2f46b60da1a1e284$export$2e2bcd8739ae039)({
        actionOptions: actionOptions,
        appearance: appearance,
        state: state
    });
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $cozmU.useEffect)(()=>{
        $98Qqv.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $98Qqv.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.smartLink.resolved', {
                definitionId: definitionId ?? null,
                duration: $98Qqv.getMeasure(id, state.status)?.duration ?? null
            });
            else if (state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError' && state.error?.name !== 'InvalidUrlError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $cozmU.useEffect)(()=>{
        if ((0, $2Q7sv.isFinalState)(state.status)) {
            (0, $jdqmT.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $jdqmT.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance,
                ...appearance === 'inline' && {
                    rovoActionsCtaShown: rovoActionsCtaShown
                },
                ...experimentMetaEventAttributes && {
                    experimentMeta: experimentMetaEventAttributes
                }
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        rovoActionsCtaShown,
        state.status,
        experimentMetaEventAttributes
    ]);
    const onIframeDwell = (0, $cozmU.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'focus'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeMouseEnter = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'mouseenter'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeMouseLeave = (0, $cozmU.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'mouseleave'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if (error?.name === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bVAqi.default), {
            id: id,
            cardState: cardState,
            placeholderData: placeholderData,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            onAuxClick: handleFrameAuxClick,
            onContextMenu: handleFrameContextMenu,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            title: title,
            testId: testId,
            onResolve: onResolve,
            onError: onError
        }, children);
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $561dde74fc5c9bd8$export$aff6291803939b05), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                handleFrameAuxClick: handleFrameAuxClick,
                handleFrameContextMenu: handleFrameContextMenu,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'block':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $958d842453deb70e$export$d18ccd25c0d2c6b0), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                handleFrameAuxClick: handleFrameAuxClick,
                handleFrameContextMenu: handleFrameContextMenu,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'embed':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3ceae4ab8d9d0f7$export$6789d7ecdc77631b), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleFrameAuxClick: handleFrameAuxClick,
                handleFrameContextMenu: handleFrameContextMenu,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                onIframeMouseEnter: onIframeMouseEnter,
                onIframeMouseLeave: onIframeMouseLeave,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
    }
}
const $6c8ebed741634f4e$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $4abK1.isFlexibleUiCard)(props.children, props?.ui) ? (0, $4yYAm.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hsgLh.SmartLinkModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1smAh.SmartLinkAnalyticsContext), {
        url: props.url,
        id: props.id,
        display: display
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6c8ebed741634f4e$var$Component, props)));
};
const $6c8ebed741634f4e$export$d4ee8167ac732647 = (0, $adf961e1c1bb4505$export$2e2bcd8739ae039)($6c8ebed741634f4e$export$7598f5d7c597dd32);
module.exports["CardWithUrlContent"] = $6c8ebed741634f4e$export$7598f5d7c597dd32;
module.exports["CardWithUrl"] = $6c8ebed741634f4e$export$d4ee8167ac732647;

});

parcelRegister("856OS", function(module, exports) {
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lpNn5 = parcelRequire("lpNn5");


var $3tPPd = parcelRequire("3tPPd");


var $ghw3R = parcelRequire("ghw3R");


var $aFr4e = parcelRequire("aFr4e");

const $6317c3ad9e8d2304$var$styles = {
    linkWrapper: "_2mHwu82ADO _1mT5xdRAKS _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0Vw5sG _0Of8r22ADO _1Znuxb2ADO _1wydGW2ADO _2Zuz6Q2ADO _20VacPYbGa _1JM8vvoAmG _2Gfj6iyzSk _0GBAIrogpp _2WYcYGWVPG _2KaDuOdnbC _0cAGM7dnbC _4zi1EpdnbC _2ZHpDRdnbC _3wEj0XjOvk _39mJBjdnbC _03rd7HdnbC _3AJDandnbC",
    linkWrapperInheritDimensions: "_0jFU0VN91d",
    linkWrapperSelected: "_0Av05f5WZX",
    linkWrapperBorderAndBackground: "_4l3pdPOeNX _3wEj0Xqi9L _3AJDan7dHp",
    linkWrapperInteractiveNotHidden: "_18YWq9OeNX _0jKh9gqi9L _2baiL77dHp",
    header: "_2sNsIgEqul _2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuI7V3 _0jFU0VSPN1 _42Yu6B7dHp",
    leftSection: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC",
    tooltipWrapper: "_4bt5LAnQyn _2WAcuGnQyn",
    headerAnchor: "_2sNsIgEqul _4bt5LAnQyn _2WAcuGnQyn _3iDTPbvLZJ _39HuIbz8Lp _1ANEUSLRg7 _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8",
    headerIcon: "_2sNsIgEqul _39xV02ey7F _0jFU0Vey7F",
    contentStyle: "_30huDKFq6s _0bjKvD8jTr _4bt5LAnQyn _2WAcuGnQyn _23rrnHUL21 _0KLXruqi9L _2O5Vij7dHp _0jFU0VN91d _42Yu6B7dHp",
    contentInteractiveActiveBorder: "_3F4jYbiUq6",
    contentOverflowAuto: "_4bt5LAIZbP _2WAcuGIZbP"
};
const $6317c3ad9e8d2304$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true, CompetitorPrompt: CompetitorPrompt, onContentMouseEnter: onContentMouseEnter, onContentMouseLeave: onContentMouseLeave })=>{
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const handleClick = (event)=>(0, $ghw3R.handleClickCommon)(event, onClick);
    const handleMouseDown = (0, $3tPPd.useMouseDownEvent)();
    const CompetitorPromptComponent = CompetitorPrompt && href ? /*#__PURE__*/ $cozmU.createElement(CompetitorPrompt, {
        sourceUrl: href,
        linkType: "embed"
    }) : null;
    const renderHeader = ()=>{
        return frameStyle !== 'hide' && /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $6317c3ad9e8d2304$var$styles.header,
                "embed-header"
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $6317c3ad9e8d2304$var$styles.leftSection
            ])
        }, /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $6317c3ad9e8d2304$var$styles.headerIcon
            ])
        }, icon), /*#__PURE__*/ $cozmU.createElement("div", {
            className: (0, $hekY6.default)([
                $6317c3ad9e8d2304$var$styles.tooltipWrapper
            ])
        }, !isPlaceholder && /*#__PURE__*/ $cozmU.createElement((0, $lpNn5.default), {
            content: text,
            hideTooltipOnMouseDown: true
        }, /*#__PURE__*/ $cozmU.createElement("a", {
            href: href,
            onClick: handleClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            onMouseDown: handleMouseDown,
            className: (0, $hekY6.default)([
                $6317c3ad9e8d2304$var$styles.headerAnchor
            ])
        }, text)))), CompetitorPromptComponent);
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        return /*#__PURE__*/ $cozmU.createElement("div", {
            "data-testid": "embed-content-wrapper",
            // See: HOT-107830
            contentEditable: false,
            onMouseEnter: onContentMouseEnter,
            onMouseLeave: onContentMouseLeave,
            onFocus: onContentMouseEnter,
            onBlur: onContentMouseLeave,
            className: (0, $hekY6.default)([
                $6317c3ad9e8d2304$var$styles.contentStyle,
                setOverflow && allowScrollBar && $6317c3ad9e8d2304$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $6317c3ad9e8d2304$var$styles.contentInteractiveActiveBorder
            ])
        }, children);
    };
    return /*#__PURE__*/ $cozmU.createElement("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $hekY6.default)([
            $6317c3ad9e8d2304$var$styles.linkWrapper,
            inheritDimensions && $6317c3ad9e8d2304$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $6317c3ad9e8d2304$var$styles.linkWrapperSelected,
            showBackgroundAlways && $6317c3ad9e8d2304$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $6317c3ad9e8d2304$var$styles.linkWrapperInteractiveNotHidden,
            (0, $aFr4e.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        }
    }, renderHeader(), renderContent());
};
module.exports["ExpandedFrame"] = $6317c3ad9e8d2304$export$7b360cd785b6c366;

});

parcelRegister("ehQDZ", function(module, exports) {

let $a66b7d358b50bb91$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a66b7d358b50bb91$var$load("RBIOk").then(()=>parcelRequire('hUPNm'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("JMHgK", function(module, exports) {

let $0899fa458f021cf8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0899fa458f021cf8$var$load("7CLTD").then(()=>parcelRequire('11TEZ'));

});

parcelRegister("1DOok", function(module, exports) {

let $132085a1c6c96408$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $132085a1c6c96408$var$load("6bjSp").then(()=>parcelRequire('hR3gu'));

});

parcelRegister("6lKz8", function(module, exports) {

var $fxqZn = parcelRequire("fxqZn");


var $6YXrY = parcelRequire("6YXrY");


var $lRiBt = parcelRequire("lRiBt");

const $6e64e4af8f086740$export$5fc1066e677788d4 = (0, $6YXrY.createFeatureFlaggedComponent)((0, $lRiBt.BitbucketIcon), (0, $fxqZn.BitbucketIcon));
module.exports["BitbucketIcon"] = $6e64e4af8f086740$export$5fc1066e677788d4;

});

parcelRegister("kkpJg", function(module, exports) {
/* IconSlot.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $ced805262a47c5cf$var$iconSlotDivStyles = null;
const $ced805262a47c5cf$var$IconSlot = ({ icon: icon, x: x, y: y, w: w, h: h })=>{
    if (!icon) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("foreignObject", {
        x: x,
        y: y,
        width: w,
        height: h
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: (0, $hekY6.default)([
            "_0bjKvDKxmn _4bt5LAnQyn _2WAcuGnQyn _39xV02N91d _0jFU0VN91d _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT"
        ])
    }, icon));
};
var $ced805262a47c5cf$export$2e2bcd8739ae039 = $ced805262a47c5cf$var$IconSlot;
module.exports["default"] = $ced805262a47c5cf$export$2e2bcd8739ae039;

});

parcelRegister("QXwxo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kHija = parcelRequire("kHija");


var $gBjHb = parcelRequire("gBjHb");


var $iDrrr = parcelRequire("iDrrr");


var $6GOAK = parcelRequire("6GOAK");


var $4abK1 = parcelRequire("4abK1");





var $9EOlJ = parcelRequire("9EOlJ");


var $1384B = parcelRequire("1384B");

const $66563430cdef2c51$var$CardErrorBoundary = ({ children: children, ...props })=>{
    // TODO: NAVX-4682: Add feature parity to CardWithURLRenderer
    const ErrorFallbackComponent = props.fallbackComponent;
    const errorBoundaryFallbackComponent = ()=>{
        if (ErrorFallbackComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ErrorFallbackComponent, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1384B.LoadingCardLink), props);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9EOlJ.ErrorBoundary), {
        FallbackComponent: errorBoundaryFallbackComponent
    }, children);
};
var $66563430cdef2c51$export$2e2bcd8739ae039 = $66563430cdef2c51$var$CardErrorBoundary;



var $59u5K = parcelRequire("59u5K");

const $dcc248a77e12baf7$export$7b5e1b7f9a325b6 = (props)=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $cozmU.useState)(()=>props.id ?? (0, (/*@__PURE__*/$parcel$interopDefault($kHija)))());
    // FlexibleCards always need full ORS data regardless of appearance prop,
    // because they render custom blocks (TitleBlock etc.) requiring a complete response.
    // Override appearance to 'block' for FlexibleCards when FG is enabled.
    const effectiveAppearance = (0, $4abK1.isFlexibleUiCard)(props.children, props.ui) && (0, $iDrrr.fg)('platform_smartlink_inline_resolve_optimization') ? 'block' : props.appearance;
    const propsWithId = {
        ...props,
        id: id,
        appearance: effectiveAppearance
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gBjHb.default), {
        data: (0, $6GOAK.context)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $66563430cdef2c51$export$2e2bcd8739ae039), propsWithId, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $59u5K.CardWithUrl), propsWithId)));
};
module.exports["CardSSR"] = $dcc248a77e12baf7$export$7b5e1b7f9a325b6;

});

parcelRegister("1Zwrg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $rECdA = parcelRequire("rECdA");


var $jLxvy = parcelRequire("jLxvy");


var $JiXpY = parcelRequire("JiXpY");


var $5HpbM = parcelRequire("5HpbM");


var $bZ9jR = parcelRequire("bZ9jR");














var $ieeJu = parcelRequire("ieeJu");


var $aflIU = parcelRequire("aflIU");


var $2Q7sv = parcelRequire("2Q7sv");


var $9H66G = parcelRequire("9H66G");


var $8QLAc = parcelRequire("8QLAc");

const $dc67e572c7f8359a$var$ELIGIBLE_EXTENSION_KEYS = new Set([
    'slack-object-provider',
    'google-object-provider',
    'onedrive-object-provider',
    'github-object-provider',
    'ms-teams-object-provider',
    'gitlab-object-provider',
    'salesforce-object-provider'
]);
const $dc67e572c7f8359a$var$NOT_ENABLED_RESULT = {
    isEnabled: false
};
/**
 * Returns whether the platform_sl_3p_auth_inline_tailored_cta experiment
 * is enabled for the current user and link context.
 *
 * All eligibility criteria are consolidated here:
 * 1. Rovo chat must be enabled for the tenant.
 * 2. The consumer must have opted in via actionOptions.rovoChatAction.optIn.
 * 3. The link must support the RovoActions feature.
 * 4. The extension key must be one of the supported options.
 * 5. The experiment value must be true (via tmp-editor-statsig).
 *
 * The extension key is derived from the card store via the resolved URL,
 * so callers don't need to thread it as a prop.
 */ const $dc67e572c7f8359a$var$useInlineTailoredActionExperiment = (url, showHoverPreview, actionOptions)=>{
    const { rovoOptions: rovoConfig } = (0, $8QLAc.default)();
    const isRovoChatEnabled = (0, $aflIU.getIsRovoChatEnabled)(rovoConfig);
    const cardState = (0, $9H66G.useSmartCardState)(url ?? '');
    const extensionKey = (0, $2Q7sv.getExtensionKey)(cardState.details);
    const isRovoChatActionOptedIn = actionOptions?.rovoChatAction?.optIn ?? false;
    return (0, $cozmU.useMemo)(()=>{
        if (!isRovoChatEnabled || !showHoverPreview || !url || !isRovoChatActionOptedIn) return $dc67e572c7f8359a$var$NOT_ENABLED_RESULT;
        if (!extensionKey || !$dc67e572c7f8359a$var$ELIGIBLE_EXTENSION_KEYS.has(extensionKey)) return $dc67e572c7f8359a$var$NOT_ENABLED_RESULT;
        const isEnabled = (0, $iDrrr.fg)('platform_sl_3p_auth_inline_tailored_cta_killswitch') && (0, $ieeJu.expValEquals)('platform_sl_3p_auth_inline_tailored_cta', 'isEnabled', true);
        return {
            isEnabled: isEnabled
        };
    }, [
        isRovoChatEnabled,
        extensionKey,
        showHoverPreview,
        url,
        isRovoChatActionOptedIn
    ]);
};
var $dc67e572c7f8359a$export$2e2bcd8739ae039 = $dc67e572c7f8359a$var$useInlineTailoredActionExperiment;





/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 



var $kSwu1 = parcelRequire("kSwu1");


var $hHrlI = parcelRequire("hHrlI");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $irGZZ = parcelRequire("irGZZ");





var $kfxZm = parcelRequire("kfxZm");


var $4ZDKy = parcelRequire("4ZDKy");








var $edVsK = parcelRequire("edVsK");


var $b78WJ = parcelRequire("b78WJ");

const $210989b8c3d24ec4$var$styles = {
    text: "_2Zuz6QgVvo _3iDTPbccYA _0hPCNLDIqT _1RrJLit2nV _313842Ll21"
};
const $210989b8c3d24ec4$export$47ac6a4b603479b6 = ({ testId: testId, url: url, actionOptions: actionOptions })=>{
    const { sendPromptMessage: sendPromptMessage, isRovoChatEnabled: isRovoChatEnabled } = (0, $4ZDKy.default)();
    const intl = (0, $kSwu1.useIntl)();
    const cardState = (0, $9H66G.useSmartCardState)(url ?? '');
    const extensionKey = (0, $2Q7sv.getExtensionKey)(cardState.details);
    const rovoConfig = (0, $8QLAc.default)();
    const rovoChatAction = (0, $cozmU.useMemo)(()=>{
        return cardState.details && (0, $irGZZ.default)({
            response: cardState.details,
            actionOptions: actionOptions,
            rovoConfig: rovoConfig
        });
    }, [
        cardState.details,
        rovoConfig,
        actionOptions
    ]);
    const provider = (0, $cozmU.useMemo)(()=>{
        return cardState.details && (0, $hHrlI.extractSmartLinkProvider)(cardState.details);
    }, [
        cardState.details
    ]);
    const invoke = (0, $kfxZm.default)({});
    const promptKey = (0, $cozmU.useMemo)(()=>{
        if (extensionKey === 'google-object-provider' && cardState.details?.data?.['@type']?.includes('schema:SpreadsheetDigitalDocument')) return;
        switch(extensionKey){
            case 'google-object-provider':
                if (cardState.details?.data?.['@type']?.includes('schema:PresentationDigitalDocument')) return (0, $edVsK.RovoChatPromptKey).SUMMARIZE_PRESENTATION;
                return (0, $edVsK.RovoChatPromptKey).SUMMARIZE_DOCUMENT;
            case 'onedrive-object-provider':
                return (0, $edVsK.RovoChatPromptKey).SUMMARIZE_DOCUMENT;
            case 'github-object-provider':
            case 'gitlab-object-provider':
                return (0, $edVsK.RovoChatPromptKey).EXPLAIN_CODE;
            case 'slack-object-provider':
            case 'ms-teams-object-provider':
                return (0, $edVsK.RovoChatPromptKey).CATCH_UP;
            case 'salesforce-object-provider':
                return (0, $edVsK.RovoChatPromptKey).SALESFORCE_PREP;
        }
    }, [
        extensionKey,
        cardState
    ]);
    const { data: promptData, content: content, icon: icon } = promptKey ? (0, $edVsK.getPromptAction)({
        promptKey: promptKey,
        intl: intl,
        url: url,
        iconSize: 'small',
        provider: provider?.text
    }) || {} : {};
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (isRovoChatEnabled && promptData && rovoChatAction?.invokeAction) invoke({
            ...rovoChatAction?.invokeAction,
            actionFn: async ()=>sendPromptMessage(promptData),
            prompt: promptKey
        });
    }, [
        sendPromptMessage,
        isRovoChatEnabled,
        promptData,
        rovoChatAction,
        promptKey,
        invoke
    ]);
    return promptData && content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b78WJ.ActionButton), {
        onClick: handleClick,
        testId: testId
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $210989b8c3d24ec4$var$styles.text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small"
    }, content))) : null;
};

















const $dfdb1966c3a31649$var$LOZENGE_TEST_ID = 'inline-card-resolved-view-lozenge';
function $dfdb1966c3a31649$export$69cf9880ad713b0e(lozenge) {
    if (!lozenge || !lozenge?.text) return null;
    if ((0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const stateMetricMatch = lozenge.text.match(/^(.+?)\s+-\s+(\d+(?:\.\d+)?)$/);
        if (stateMetricMatch) {
            const [, label, metric] = stateMetricMatch;
            const appearance = lozenge.appearance || 'neutral';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JiXpY.default), {
                testId: $dfdb1966c3a31649$var$LOZENGE_TEST_ID,
                appearance: appearance,
                style: {
                    backgroundColor: lozenge?.style?.backgroundColor,
                    color: lozenge?.style?.color
                },
                trailingMetric: metric
            }, label);
        }
    }
    const appearance = lozenge.appearance || 'default';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JiXpY.default), {
        testId: $dfdb1966c3a31649$var$LOZENGE_TEST_ID,
        appearance: appearance,
        style: {
            backgroundColor: lozenge?.style?.backgroundColor,
            color: lozenge?.style?.color
        },
        isBold: lozenge.isBold !== false
    }, lozenge.text);
}


function $3ad9caaf785d398d$export$a75b7a22e5b9b36({ id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton, lozenge: lozenge }) {
    const frame = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
        testId: testId,
        link: link,
        isSelected: isSelected,
        isHovered: isHovered,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconAndTitleLayout), {
        emoji: titlePrefix,
        icon: icon,
        title: title,
        titleTextColor: titleTextColor,
        type: type,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    }), (0, $dfdb1966c3a31649$export$69cf9880ad713b0e)(lozenge));
    if (!showHoverPreview || !link) return frame;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), {
        id: id,
        url: link,
        actionOptions: actionOptions,
        hoverPreviewOptions: hoverPreviewOptions
    }, frame);
}
function $3ad9caaf785d398d$export$9fc2dee105372861({ id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton, lozenge: lozenge }) {
    const { isEnabled: isInlineTailoredRovoActionEnabled } = (0, $dc67e572c7f8359a$export$2e2bcd8739ae039)(link, showHoverPreview, actionOptions);
    // TODO https://hello.jira.atlassian.cloud/browse/NAVX-4436: fire analytics with cohort
    const frame = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
        testId: testId,
        link: link,
        isSelected: isSelected,
        isHovered: isHovered,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconAndTitleLayout), {
        emoji: titlePrefix,
        icon: icon,
        title: title,
        titleTextColor: titleTextColor,
        type: type,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    }), (0, $dfdb1966c3a31649$export$69cf9880ad713b0e)(lozenge), isInlineTailoredRovoActionEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $210989b8c3d24ec4$export$47ac6a4b603479b6), {
        testId: `${testId}-rovo-actions-cta`,
        url: link,
        actionOptions: actionOptions
    }));
    if (!showHoverPreview || !link) return frame;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), {
        id: id,
        url: link,
        actionOptions: actionOptions,
        hoverPreviewOptions: hoverPreviewOptions
    }, frame);
}
const $3ad9caaf785d398d$export$4dcde1a6b9223e2e = (0, $rECdA.componentWithFG)('platform_sl_3p_auth_inline_tailored_cta_killswitch', $3ad9caaf785d398d$export$9fc2dee105372861, $3ad9caaf785d398d$export$a75b7a22e5b9b36);


class $bcd0f021ef78debd$var$InlineCardResolvedViewClass extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Component {
    renderLozenge() {
        const { lozenge: lozenge } = this.props;
        if (!lozenge || !lozenge?.text) return null;
        if ((0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
            const stateMetricMatch = lozenge.text.match(/^(.+?)\s+-\s+(\d+(?:\.\d+)?)$/);
            if (stateMetricMatch) {
                const [, label, metric] = stateMetricMatch;
                const appearance = lozenge.appearance || 'neutral';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JiXpY.default), {
                    testId: "inline-card-resolved-view-lozenge",
                    appearance: appearance,
                    style: {
                        backgroundColor: lozenge?.style?.backgroundColor,
                        color: lozenge?.style?.color
                    },
                    trailingMetric: metric
                }, label);
            }
        }
        const appearance = lozenge.appearance || 'default';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JiXpY.default), {
            testId: "inline-card-resolved-view-lozenge",
            appearance: appearance,
            style: {
                backgroundColor: lozenge?.style?.backgroundColor,
                color: lozenge?.style?.color
            },
            isBold: lozenge.isBold !== false
        }, lozenge.text);
    }
    render() {
        const { id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton } = this.props;
        const inlineCardResolvedView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
            testId: testId,
            link: link,
            isSelected: isSelected,
            isHovered: isHovered,
            onClick: onClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            truncateInline: truncateInline
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconAndTitleLayout), {
            emoji: titlePrefix,
            icon: icon,
            title: title,
            titleTextColor: titleTextColor,
            type: type,
            hideIconLoadingSkeleton: hideIconLoadingSkeleton
        }), this.renderLozenge());
        if (showHoverPreview && link) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), {
            id: id,
            url: link,
            actionOptions: actionOptions,
            hoverPreviewOptions: hoverPreviewOptions
        }, inlineCardResolvedView);
        return inlineCardResolvedView;
    }
}
const $bcd0f021ef78debd$export$6d5912cb4b56390e = (0, $rECdA.componentWithFG)('smart-card-inline-resolved-view-refactor', (0, $3ad9caaf785d398d$export$4dcde1a6b9223e2e), $bcd0f021ef78debd$var$InlineCardResolvedViewClass);
module.exports["InlineCardResolvedView"] = $bcd0f021ef78debd$export$6d5912cb4b56390e;

});

parcelRegister("aw4sA", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $24dy7 = parcelRequire("24dy7");


var $dM7c5 = parcelRequire("dM7c5");


var $jLxvy = parcelRequire("jLxvy");


var $b78WJ = parcelRequire("b78WJ");


var $5HpbM = parcelRequire("5HpbM");


var $bZ9jR = parcelRequire("bZ9jR");

const $204654a0fc91ba1d$var$fallbackIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        testId: "errored-view-default-icon"
    });
};
const $204654a0fc91ba1d$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        return onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b78WJ.ActionButton), {
            onClick: handleRetry
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).try_again));
    }, [
        handleRetry,
        onRetry
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconAndTitleLayout), {
        icon: icon || $204654a0fc91ba1d$var$fallbackIcon(),
        link: hashAction ? url : undefined,
        title: url,
        onClick: hashAction ? onClick : undefined,
        rightSide: message
    }), renderActionButton());
    if (showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), {
        url: url
    }, content);
    return content;
};
module.exports["InlineCardErroredView"] = $204654a0fc91ba1d$export$8ae570c871cdb179;

});

parcelRegister("a1w5z", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4efpo = parcelRequire("4efpo");


var $hBYtq = parcelRequire("hBYtq");


var $dM7c5 = parcelRequire("dM7c5");


var $jLxvy = parcelRequire("jLxvy");


var $b78WJ = parcelRequire("b78WJ");


var $JiXpY = parcelRequire("JiXpY");


var $5HpbM = parcelRequire("5HpbM");


var $bZ9jR = parcelRequire("bZ9jR");

const $92b1538e1391e576$var$styles = {
    actionButtonLozengeStyle: "_0bjKvDcjp5 _0KLXru66of _0Of8r2Pgdg _1ZnuxbPgdg _1wydGWPgdg _2Zuz6QPgdg _1EqgXlN91d"
};
const $92b1538e1391e576$var$fallbackForbiddenIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: "forbidden-view-fallback-icon"
    });
};
const $92b1538e1391e576$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(!!requestAccessContext?.callToActionMessageKey);
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else requestAccessContext?.action?.promise();
    }, [
        onAuthorise,
        requestAccessContext?.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if (requestAccessContext?.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                ...(0, $dM7c5.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).invalid_permissions, (formattedMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, formattedMessage));
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        const accessType = requestAccessContext?.accessType;
        if (hasRequestAccessContextMessage) {
            const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b78WJ.ActionButton), {
                isDisabled: isDisabled,
                onClick: handleRetry,
                testId: "button-connect-other-account"
            }, renderForbiddenAccessMessage());
        }
        if (onAuthorise) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $92b1538e1391e576$var$styles.actionButtonLozengeStyle,
            onClick: handleRetry,
            style: {
                font: `inherit`
            },
            testId: "button-connect-other-account"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $JiXpY.default), {
            appearance: "moved",
            isBold: true
        }, renderForbiddenAccessMessage()));
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext?.accessType
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconAndTitleLayout), {
        icon: icon ? icon : $92b1538e1391e576$var$fallbackForbiddenIcon(),
        link: url,
        title: url,
        onClick: onClick,
        titleColor: "var(--ds-text-subtle, #505258)"
    }), renderActionButton());
    if (showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), {
        url: url
    }, content);
    return content;
};
module.exports["InlineCardForbiddenView"] = $92b1538e1391e576$export$ebd227d2573ed3d8;

});

parcelRegister("4uUBn", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $lfoFx = parcelRequire("lfoFx");


var $5HpbM = parcelRequire("5HpbM");


var $bZ9jR = parcelRequire("bZ9jR");

/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ 



var $hekY6 = parcelRequire("hekY6");

const $fc7046c3fca81f77$export$91b164375b8037b5 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2XsHFMFQfX _1mT5xdRAKS _3iDTPbvbI6",
            __cmplp.className
        ])
    });
});


const $a634cc4b6380e4aa$var$styles = {
    spinnerWrapper: "_2sNsIg7NXe _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _0jFU0Vey7F _39xV02ey7F"
};
const $a634cc4b6380e4aa$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $a634cc4b6380e4aa$var$styles.spinnerWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
            size: 14,
            interactionName: "smart-card-inline-card-spinner"
        })), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconTitleWrapper), null, url, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fc7046c3fca81f77$export$91b164375b8037b5), null, renderSpinner())));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconAndTitleLayout), {
        icon: renderSpinner(),
        title: resolvingPlaceholder ?? url,
        titleTextColor: titleTextColor
    }));
};
module.exports["InlineCardResolvingView"] = $a634cc4b6380e4aa$export$98531adac42f053e;

});

parcelRegister("bAr6P", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $6cFsl = parcelRequire("6cFsl");


var $w6R6I = parcelRequire("w6R6I");


var $4efpo = parcelRequire("4efpo");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");


var $ieeJu = parcelRequire("ieeJu");


var $6Vsq4 = parcelRequire("6Vsq4");


var $dM7c5 = parcelRequire("dM7c5");


var $8Mlyd = parcelRequire("8Mlyd");


var $jLxvy = parcelRequire("jLxvy");


var $b78WJ = parcelRequire("b78WJ");


var $5HpbM = parcelRequire("5HpbM");


var $bZ9jR = parcelRequire("bZ9jR");

const $33f2ea2010a25b29$var$fallbackUnauthorizedIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4efpo))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error"
    });
}; /**
    * When persisted personalization adoption from {@link getCachedProviderPctMapAndRefresh} is strictly below this value,
    * the pill uses exploratory "previewing" copy instead of a percentage headline.
    */ 
const $33f2ea2010a25b29$var$SOCIAL_PROOF_TEAM_PREVIEW_THRESHOLD = 30;
const $33f2ea2010a25b29$var$SOCIAL_PROOF_TRAIT_NAME = 'sl_3p_connected_providers_site_pct';
const $33f2ea2010a25b29$var$socialProofPillStyles = {
    strong: "_1kk5Tkmb2E",
    root: "_0bjKvDKxmn _3iDTPbS8kF _0hPCNLDIqT _24h04i2Njc _1EqgXlN91d _0KLXruo126 _1UtDYzZpcK _2fwxA5yL8i _4ya3eETekT _1RrJLiHZdu _0Of8r2FQfX _1wydGWFQfX _1ZnuxbgVvo _2Zuz6QgVvo _0adFHs1Y8M _1eOmH6KcZT _3gzVzLnpTK",
    label: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7",
    wrappingLabel: "_4bt5LAYvD1 _2WAcuGYvD1 _39HuIboWuR _1ANEUSJfqQ _3W2Oc84hR5",
    button: "_0KLXrujOvk _1ZnuxbPgdg _2Zuz6QPgdg _0Of8r2Pgdg _1wydGWPgdg",
    pressableContents: "_3iDTPbcK7c",
    inlineGroup: "_3iDTPbS8kF"
};
/**
 * Renders the social-proof pill and Connect button using persisted percentages only ({@link getCachedProviderPctMapAndRefresh}) — no
 * loading skeleton; either the cached percentage is shown or the legacy long connect label is used.
 *
 * Only mounted when the parent has passed the killswitch and
 * `platform_sl_3p_preauth_social_proof_inline_cta`. See platform docs: `rules-of-hooks.md` "Should §1".
 */ const $33f2ea2010a25b29$var$UnauthorisedConnectWithSocialProof = ({ context: context, extensionKey: extensionKey, testId: testId, onConnectClick: onConnectClick, isPreviewCTATreatment: isPreviewCTATreatment })=>{
    (0, $6cFsl.di)((0, $8Mlyd.getCachedProviderPctMapAndRefresh));
    const providerPctMap = (0, $8Mlyd.getCachedProviderPctMapAndRefresh)($33f2ea2010a25b29$var$SOCIAL_PROOF_TRAIT_NAME); // Will be false if this is the first render, when we fetch traits and store to local storage,
    // or if there wasn't our trait for it.
    const isProviderPctMapLoaded = providerPctMap !== null; // Percent of current user team (same tenant users) who are connected to this extension.
    const connectedPct = extensionKey && isProviderPctMapLoaded ? providerPctMap[extensionKey] : undefined;
    const trimmedProviderDisplayName = context?.trim() ?? '';
    const hasProviderDisplayName = trimmedProviderDisplayName.length > 0;
    const isSocialProofUsageHighEnough = connectedPct !== undefined && connectedPct >= $33f2ea2010a25b29$var$SOCIAL_PROOF_TEAM_PREVIEW_THRESHOLD; /**
                                                                                                                           * As long as trait is loaded we show the pill/lozange.
                                                                                                                           */ 
    const showSocialProofPill = providerPctMap !== null && (0, $ieeJu.expValEquals)('platform_sl_3p_preauth_social_proof_inline_cta', 'isEnabled', true);
    const bold = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "strong",
            xcss: $33f2ea2010a25b29$var$socialProofPillStyles.strong
        }, chunks); // As long as pill is shown it will be one of four messages depending on percent and provider presence:
    // - 45% of your team sees Figma previews
    // - 45% of your team sees richer previews
    // - Your team sees richer Figma previews
    // - Your team sees richer previews
    const socialProofPillContent = isSocialProofUsageHighEnough ? hasProviderDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).social_proof_inline_cta_tag_high_with_context,
        values: {
            connectedPct: connectedPct,
            context: trimmedProviderDisplayName,
            b: bold
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).social_proof_inline_cta_tag_high_no_context,
        values: {
            connectedPct: connectedPct,
            b: bold
        }
    }) : hasProviderDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).social_proof_inline_cta_tag_low_with_context,
        values: {
            context: trimmedProviderDisplayName
        }
    }) : // Unlikely case, but possible from TS standpoint.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).social_proof_inline_cta_tag_low_no_context);
    const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, showSocialProofPill ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $33f2ea2010a25b29$var$socialProofPillStyles.root,
        testId: `${testId}-social-proof-tag`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: (0, $w6R6I.cx)($33f2ea2010a25b29$var$socialProofPillStyles.label, (0, $iDrrr.fg)('platform_lp_social_proof_inline_overflow_bug') && $33f2ea2010a25b29$var$socialProofPillStyles.wrappingLabel)
    }, socialProofPillContent)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b78WJ.ActionButton), {
        onClick: onConnectClick,
        viewType: "unauthorised",
        testId: "button-connect-account",
        isSlimDesign: showSocialProofPill
    }, isPreviewCTATreatment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).connect_link_account_preview) : showSocialProofPill ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).connect_inline_social_proof) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...(0, $dM7c5.messages).connect_link_account_card_name,
        values: {
            context: context
        }
    })));
    return showSocialProofPill ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        onClick: onConnectClick,
        style: {
            font: `inherit`
        },
        xcss: (0, $w6R6I.cx)($33f2ea2010a25b29$var$socialProofPillStyles.button, (0, $iDrrr.fg)('platform_lp_social_proof_inline_overflow_bug') && $33f2ea2010a25b29$var$socialProofPillStyles.pressableContents)
    }, (0, $iDrrr.fg)('platform_lp_social_proof_inline_overflow_bug') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $33f2ea2010a25b29$var$socialProofPillStyles.inlineGroup
    }, buttonContent) : buttonContent) : buttonContent;
};
const $33f2ea2010a25b29$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context, extensionKey: extensionKey })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(null);
    const { fireEvent: fireEvent } = (0, $6Vsq4.useAnalyticsEvents)();
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        const isPreviewCTATreatment = (0, $iDrrr.fg)('rovogrowth-635-pre-auth-cta-preview-fg') && (0, $ieeJu.expValEquals)('rovogrowth-635-pre-auth-cta-preview-exp', 'isEnabled', true);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b78WJ.ActionButton), {
            onClick: handleConnectAccount,
            viewType: 'unauthorised',
            testId: "button-connect-account"
        }, isPreviewCTATreatment ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), (0, $dM7c5.messages).connect_link_account_preview) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...(0, $dM7c5.messages).connect_link_account_card_name,
            values: {
                context: context
            }
        }));
    }, [
        handleConnectAccount,
        context
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5HpbM.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        viewType: "unauthorised"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bZ9jR.IconAndTitleLayout), {
        icon: icon ? icon : $33f2ea2010a25b29$var$fallbackUnauthorizedIcon(),
        title: url,
        link: url,
        onClick: onClick,
        titleColor: "var(--ds-text-subtle, #505258)"
    }), onAuthorise && ((0, $iDrrr.fg)('platform_sl_3p_preauth_soc_proof_inline_killswitch') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($33f2ea2010a25b29$var$UnauthorisedConnectWithSocialProof, {
        context: context,
        extensionKey: extensionKey,
        testId: testId,
        onConnectClick: handleConnectAccount,
        isPreviewCTATreatment: (0, $iDrrr.fg)('rovogrowth-635-pre-auth-cta-preview-fg') && (0, $ieeJu.expValEquals)('rovogrowth-635-pre-auth-cta-preview-exp', 'isEnabled', true)
    }) : renderActionButton()));
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jLxvy.HoverCard), {
        url: url,
        id: id
    }, inlineCardUnauthenticatedView);
    return inlineCardUnauthenticatedView;
};
module.exports["InlineCardUnauthorizedView"] = $33f2ea2010a25b29$export$ece47728c0503997;

});

parcelRegister("ghw3R", function(module, exports) {
const $d65ac04b6e155b42$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};
module.exports["handleClickCommon"] = $d65ac04b6e155b42$export$9759a67e215c4598;

});

parcelRegister("aFr4e", function(module, exports) {
/* styled.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");

const $5b9fd94d0fcc59ac$export$2913c0c0b5623090 = 'media-card-frame';
const $5b9fd94d0fcc59ac$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles
const $5b9fd94d0fcc59ac$export$3e431a229df88919 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $9aYkv.default)($5b9fd94d0fcc59ac$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _4bt5LAnQyn _2WAcuGnQyn _39xV02TA3o _0jFU0VTA3o",
            __cmplp.className
        ])
    });
});
const $5b9fd94d0fcc59ac$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $cozmU.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $9aYkv.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDzXzM _39xV02pJKa _0jFU0VpJKa _33tBfP0dzo _3138421Y8M _0adFHsdnbC _1DCdHi8HPE _2XsHFM8HPE _0KLXruGsB2 _3OqcjTiObl _3CkH9o4749",
            __cmplp.className
        ])
    });
});
module.exports["className"] = $5b9fd94d0fcc59ac$export$2913c0c0b5623090;
module.exports["Image"] = $5b9fd94d0fcc59ac$export$3e431a229df88919;

});

parcelRegister("b78WJ", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");

var $hBYtq = parcelRequire("hBYtq");

const $d0b3107199ef42eb$var$styles = {
    button: "_3iDTPbcK7c",
    innerContainer: "_3iDTPbS8kF _07XDTD4rZt _2NnhnEXpc7 _1kk5Tkf7mX _2Zuz6QgVvo _0Of8r2FQfX _1wydGWFQfX _1ZnuxbgVvo _2fwxA5yL8i _1ANEUSJfqQ _3W2Oc84hR5",
    innerContainerSocialProofConnect: "_0bjKvDKxmn _1UtDYze5R3 _0wOv4Q7zJH _0KLXrukLmD _0adFHsFQfX _3iDTPbS8kF _0hPCNLDIqT _4ya3eETekT _07XDTD4rZt _2NnhnEXpc7 _2Zuz6QgVvo _0Of8r2FQfX _1wydGWFQfX _1ZnuxbgVvo _2fwxA5yL8i _1RrJLiHZdu _1ANEUSJfqQ _3W2Oc84hR5 _1eOmH6XLOx _3gzVzLPSfI",
    innerContainerNoWrap: "_1ANEUSLRg7 _3W2Oc8zUZr",
    enabled: "_1UtDYzy7kJ _0wOv4Q7zJH _0KLXruDMqu _1eOmH6KcZT _3gzVzLnpTK",
    disabled: "_1UtDYzot27 _0wOv4Qsyl5 _0KLXruVrZW",
    unauthorised: "_1UtDYze5R3 _0wOv4Q7zJH _0KLXrukLmD _1Lz9locjp5 _3XDz3Bcjp5 _2C2kUQcjp5 _1v9SsVcjp5 _0Of8r2HZdu _1wydGWHZdu _0adFHsHZdu _1kk5Tku7m9 _1eOmH6XLOx _3gzVzLPSfI"
}; /* eslint-enable @compiled/shorthand-property-sorting */ 
const $d0b3107199ef42eb$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ children: children, isDisabled: isDisabled, viewType: viewType = 'default', isSlimDesign: isSlimDesign = false, ...props }, ref)=>{
    const shouldUseUnauthorisedSlimStyle = viewType === 'unauthorised' && isSlimDesign && (0, $iDrrr.fg)('platform_sl_3p_preauth_soc_proof_inline_killswitch');
    if (shouldUseUnauthorisedSlimStyle && !isDisabled) {
        const { onClick: onClick, ...boxProps } = props;
        return /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            ...boxProps,
            ref: ref,
            style: {
                font: `inherit`
            },
            xcss: $d0b3107199ef42eb$var$styles.button
        }, /*#__PURE__*/ $cozmU.createElement("span", {
            className: (0, $hekY6.default)([
                $d0b3107199ef42eb$var$styles.innerContainerSocialProofConnect,
                (0, $iDrrr.fg)('platform_lp_social_proof_inline_overflow_bug') && ""
            ])
        }, children));
    }
    return /*#__PURE__*/ $cozmU.createElement((0, $hBYtq.Pressable), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $d0b3107199ef42eb$var$styles.button
    }, /*#__PURE__*/ $cozmU.createElement("span", {
        tabIndex: isDisabled ? undefined : 0,
        className: (0, $hekY6.default)([
            $d0b3107199ef42eb$var$styles.innerContainer,
            isDisabled ? $d0b3107199ef42eb$var$styles.disabled : viewType === 'unauthorised' ? $d0b3107199ef42eb$var$styles.unauthorised : $d0b3107199ef42eb$var$styles.enabled
        ])
    }, children));
});
module.exports["ActionButton"] = $d0b3107199ef42eb$export$cfc7921d29ef7b80;

});

parcelRegister("bZ9jR", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $6cFsl = parcelRequire("6cFsl");


var $6Eovk = parcelRequire("6Eovk");


var $kTb7m = parcelRequire("kTb7m");


var $iDrrr = parcelRequire("iDrrr");


var $iMnC5 = parcelRequire("iMnC5");


var $16kNn = parcelRequire("16kNn");


var $hXuY9 = parcelRequire("hXuY9");

const $2309ddd74f282083$var$iconWrapperStyle = null;
const $2309ddd74f282083$var$iconImageStyle = null;
const $2309ddd74f282083$var$styles = {
    iconEmptyStyle: "_39xV02ey7F _0jFU0VN91d _3iDTPbvbI6 _1YKVNsdnbC",
    iconOuterWrapperStyle: "_3iDTPbvbI6 _0adFHs1Y8M _1mT5xdRAKS",
    iconTitleWrapperStyle: "_1ANEUSlpBW _3W2Oc84hR5 _2NnhnEXpc7 _0Of8r2FQfX _1Znuxb1Y8M _1wydGWFQfX _2Zuz6Q1Y8M",
    linkStyle: "_0bjKvDcjp5",
    noLinkAppearanceStyle: "_1UtDYzKGUX _2XsHFM1Y8M",
    roundImageStyle: "_0bjKvDS5Zs"
};
const $2309ddd74f282083$var$LinkAppearance = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_1UtDYzM7Tp _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8",
            __cmplp.className
        ])
    });
});
const $2309ddd74f282083$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title', type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $cozmU.useState)(false);
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback(()=>{
        if ((0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon') || Array.isArray(icon) && (0, $iDrrr.fg)('platform_navx_jira_issue_type_icon_label_a11y')) {
            if (emoji) return emoji;
            if (!icon || typeof icon === 'string' || Array.isArray(icon)) return null;
            return icon;
        } else {
            if (emoji) return emoji;
            if (!icon || typeof icon === 'string') return null;
            return icon;
        }
    }, [
        emoji,
        icon
    ]);
    const profileType = (0, $16kNn.isProfileType)(type);
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((errored, testId)=>{
        (0, $6cFsl.di)((0, $6Eovk.default));
        if ((0, $iDrrr.fg)('platform_lp_use_entity_icon_url_for_icon') || Array.isArray(icon) && (0, $iDrrr.fg)('platform_navx_jira_issue_type_icon_label_a11y')) {
            if (!icon) return null;
            let iconUrl;
            let iconLabel = '';
            if (Array.isArray(icon)) {
                const [tupleIconUrl, tupleIconLabel] = icon;
                if (typeof tupleIconUrl !== 'string') return null;
                iconUrl = tupleIconUrl;
                iconLabel = typeof tupleIconLabel === 'string' ? tupleIconLabel : '';
            } else if (typeof icon === 'string') iconUrl = icon;
            else return null;
            if (hideIconLoadingSkeleton) {
                if (hasImageErrored) return errored;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                    src: iconUrl,
                    "data-testid": `${testId}-image`,
                    alt: iconLabel,
                    onError: ()=>setHasImageErrored(true),
                    className: (0, $hekY6.default)([
                        "_0NUa3rey7F _1EqgXley7F _39xV02N91d",
                        profileType && $2309ddd74f282083$var$styles.roundImageStyle
                    ])
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Eovk.default), {
                src: iconUrl,
                loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                    src: iconUrl,
                    "data-testid": `${testId}-image`,
                    alt: iconLabel,
                    className: (0, $hekY6.default)([
                        "_0NUa3rey7F _1EqgXley7F _39xV02N91d",
                        profileType && $2309ddd74f282083$var$styles.roundImageStyle
                    ])
                }),
                errored: errored,
                loading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXuY9.Shimmer), {
                    testId: `${testId}-loading`
                })
            });
        } else {
            if (!icon || typeof icon !== 'string') return null;
            if (hideIconLoadingSkeleton) {
                if (hasImageErrored) return errored;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                    src: icon,
                    "data-testid": `${testId}-image`,
                    alt: "",
                    onError: ()=>setHasImageErrored(true),
                    className: (0, $hekY6.default)([
                        "_0NUa3rey7F _1EqgXley7F _39xV02N91d",
                        profileType && $2309ddd74f282083$var$styles.roundImageStyle
                    ])
                });
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Eovk.default), {
                src: icon,
                loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
                    src: icon,
                    "data-testid": `${testId}-image`,
                    alt: "",
                    className: (0, $hekY6.default)([
                        "_0NUa3rey7F _1EqgXley7F _39xV02N91d",
                        profileType && $2309ddd74f282083$var$styles.roundImageStyle
                    ])
                }),
                errored: errored,
                loading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXuY9.Shimmer), {
                    testId: `${testId}-loading`
                })
            });
        }
    }, [
        icon,
        profileType,
        hideIconLoadingSkeleton,
        hasImageErrored
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((testId)=>{
        return defaultIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: "link",
            testId: `${testId}-default`,
            color: "currentColor"
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]); // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        // We cannot set the fix font because inline is taking the parent container font size into account.
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        style: {
            lineHeight: `1`
        },
        xcss: $2309ddd74f282083$var$styles.iconOuterWrapperStyle,
        testId: "icon-position-wrapper"
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $2309ddd74f282083$var$styles.iconEmptyStyle,
        testId: "icon-empty-wrapper"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "data-testid": "icon-wrapper",
        className: (0, $hekY6.default)([
            "_2sNsIg7NXe _0bjKvDcjp5 _3iDTPbccYA _1mT5xdWVPG _0adFHs1Y8M _0jFU0Vey7F _39xV02ey7F _2IhTon715P _3OE6xY715P _1VJPcaiDnZ _20VacPYbGa"
        ])
    }, renderIcon(testId)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        style: {
            color: titleTextColor
        }
    }, title));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2309ddd74f282083$export$c73a53738ef9e3f, {
        style: {
            color: titleColor
        },
        testId: testId
    }, link ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2309ddd74f282083$var$LinkAppearance, {
        href: link,
        onClick: handleClick,
        onKeyPress: handleKeyPress,
        className: (0, $hekY6.default)([
            $2309ddd74f282083$var$styles.linkStyle
        ])
    }, titlePart) : titlePart, rightSide ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $2309ddd74f282083$var$styles.noLinkAppearanceStyle
    }, rightSide) : null));
};
const $2309ddd74f282083$export$c73a53738ef9e3f = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $2309ddd74f282083$var$styles.iconTitleWrapperStyle,
        ...props
    });
};
module.exports["IconAndTitleLayout"] = $2309ddd74f282083$export$d34be4d513116847;
module.exports["IconTitleWrapper"] = $2309ddd74f282083$export$c73a53738ef9e3f;

});

parcelRegister("JiXpY", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $9KSWX = parcelRequire("9KSWX");


var $iDrrr = parcelRequire("iDrrr");

const $7d8c99d2ebeab5e4$var$wrapperStylesOld = null;
const $7d8c99d2ebeab5e4$var$wrapperStylesNew = null;
const $7d8c99d2ebeab5e4$var$wrapperStylesNewLozenge = null;
const $7d8c99d2ebeab5e4$var$InlineLozenge = (props)=>{
    if ((0, $iDrrr.fg)('jfp-magma-platform-lozenge-jump-fix')) return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-inline-card-lozenge": true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _2IhTonA17z _1mT5xdRAKS _313842dnbC _0adFHs1Y8M _1DCdHidnbC _2XsHFMFQfX _1EqgXlN91d",
            (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_0adFHsHZdu"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), props));
    return /*#__PURE__*/ $cozmU.createElement("span", {
        "data-inline-card-lozenge": true,
        className: (0, $hekY6.default)([
            "_3iDTPbvbI6 _1RrJLiHZdu _313842dnbC _0adFHs1Y8M _1DCdHidnbC _2XsHFMFQfX _1EqgXlN91d",
            (0, $iDrrr.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_0adFHsHZdu"
        ])
    }, /*#__PURE__*/ $cozmU.createElement((0, $9KSWX.default), props));
};
var $7d8c99d2ebeab5e4$export$2e2bcd8739ae039 = $7d8c99d2ebeab5e4$var$InlineLozenge;
module.exports["default"] = $7d8c99d2ebeab5e4$export$2e2bcd8739ae039;

});

parcelRegister("8Mlyd", function(module, exports) {

var $6YrB3 = parcelRequire("6YrB3");


var $fLtAn = parcelRequire("fLtAn");

const $5f908bf6fdd7b4c6$var$BASE_URL = '/gateway/api/tap-delivery/api/v3/personalization';
const $5f908bf6fdd7b4c6$export$2f936a88fd429e8c = 'smart-card-social-proof';
const $5f908bf6fdd7b4c6$export$93b4593f39ac22dc = 'pct-map:v1:';
const $5f908bf6fdd7b4c6$export$d8f80dc0b98f1c37 = 86400000;
const $5f908bf6fdd7b4c6$export$eb1c7e303b49fcc6 = 'sl_3p_connected_providers_site_pct';
const $5f908bf6fdd7b4c6$var$smartCardStorage = new (0, $6YrB3.default)($5f908bf6fdd7b4c6$export$2f936a88fd429e8c);
/** Keys written by this service in localStorage when using {@link smartCardStorage}. */ const $5f908bf6fdd7b4c6$var$LOCAL_STORAGE_ROW_KEY_PREFIX = `${$5f908bf6fdd7b4c6$export$2f936a88fd429e8c}_${$5f908bf6fdd7b4c6$export$93b4593f39ac22dc}`;
function $5f908bf6fdd7b4c6$var$scopedCacheKey(cloudId, traitName) {
    return `${cloudId}:${traitName}`;
}
function $5f908bf6fdd7b4c6$var$pctMapStorageItemKey(cloudId, traitName) {
    return `${$5f908bf6fdd7b4c6$export$93b4593f39ac22dc}${encodeURIComponent(cloudId)}:${encodeURIComponent(traitName)}`;
}
async function $5f908bf6fdd7b4c6$var$fetchSiteTraits(cloudId) {
    const response = await fetch(`${$5f908bf6fdd7b4c6$var$BASE_URL}/site/${cloudId}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) return [];
    const data = await response.json();
    return data?.attributes ?? [];
}
class $5f908bf6fdd7b4c6$export$d653d8abac1e12ce {
    /** Pure synchronous read for an explicit cloud id / trait pair. */ getProviderPctMapSync(cloudId, traitName) {
        if (!cloudId) return null;
        return this.readStoredProviderPctMap(cloudId, traitName);
    }
    async getProviderPctMap(cloudId, traitName) {
        if (!cloudId) return undefined;
        const cacheKey = $5f908bf6fdd7b4c6$var$scopedCacheKey(cloudId, traitName);
        const cachedPromise = this.cache.get(cacheKey);
        if (cachedPromise) return cachedPromise;
        const promise = (async ()=>{
            try {
                const traits = await $5f908bf6fdd7b4c6$var$fetchSiteTraits(cloudId);
                const trait = traits.find((t)=>t.name === traitName);
                const mapped = this.parseTraitValue(trait?.value);
                if (mapped !== undefined) this.writeStoredProviderPctMap(cloudId, traitName, mapped);
                return mapped;
            } catch  {
                return undefined;
            }
        })();
        const retryablePromise = promise.finally(()=>{
            this.cache.delete(cacheKey);
        });
        this.cache.set(cacheKey, retryablePromise);
        return retryablePromise;
    }
    readStoredProviderPctMap(cloudId, traitName) {
        try {
            const stored = $5f908bf6fdd7b4c6$var$smartCardStorage.getItem($5f908bf6fdd7b4c6$var$pctMapStorageItemKey(cloudId, traitName));
            if (stored === undefined || stored === null) return null;
            return this.normalizeProviderPctMap(stored);
        } catch  {
            return null;
        }
    }
    writeStoredProviderPctMap(cloudId, traitName, map) {
        try {
            $5f908bf6fdd7b4c6$var$smartCardStorage.setItemWithExpiry($5f908bf6fdd7b4c6$var$pctMapStorageItemKey(cloudId, traitName), map, $5f908bf6fdd7b4c6$export$d8f80dc0b98f1c37);
        } catch  {
        // Quota, private-mode, etc.
        }
    }
    normalizeProviderPctMap(value) {
        if (typeof value !== 'object' || value === null || Array.isArray(value)) return null;
        const map = {};
        const entries = Object.entries(value);
        for (const [providerKey, percentageRaw] of entries){
            if (typeof percentageRaw !== 'number' || !Number.isFinite(percentageRaw)) return null;
            map[providerKey] = percentageRaw;
        }
        return map;
    }
    parseTraitValue(raw) {
        if (typeof raw !== 'string') return undefined;
        try {
            const parsed = JSON.parse(raw);
            const normalized = this.normalizeProviderPctMap(parsed);
            return normalized === null ? undefined : normalized;
        } catch  {
            return undefined;
        }
    }
    clearCache() {
        this.cache.clear();
        this.clearStoredProviderPctMaps();
    }
    clearStoredProviderPctMaps() {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        if (typeof globalThis.localStorage === 'undefined' || globalThis.localStorage === null) return;
        const keysToRemove = [];
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        for(let index = 0; index < globalThis.localStorage.length; index += 1){
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const key = globalThis.localStorage.key(index);
            if (key !== null && key.startsWith($5f908bf6fdd7b4c6$var$LOCAL_STORAGE_ROW_KEY_PREFIX)) keysToRemove.push(key);
        }
        for (const key of keysToRemove)try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            globalThis.localStorage.removeItem(key);
        } catch  {
        /* ignore */ }
    }
    constructor(){
        this.cache = new Map();
    }
}
const $5f908bf6fdd7b4c6$export$356056318a4fd636 = new $5f908bf6fdd7b4c6$export$d653d8abac1e12ce();
const $5f908bf6fdd7b4c6$export$fed0d3ced5218947 = (cloudId, traitName)=>$5f908bf6fdd7b4c6$export$356056318a4fd636.getProviderPctMap(cloudId, traitName);
function $5f908bf6fdd7b4c6$export$70435023d0d90129(cloudId, traitName) {
    return $5f908bf6fdd7b4c6$export$356056318a4fd636.getProviderPctMapSync(cloudId, traitName);
}
function $5f908bf6fdd7b4c6$export$63f5703c889fdfe6(traitName) {
    const cloudId = (0, $fLtAn.getCurrentSiteCloudIdSync)();
    const providerPctMap = $5f908bf6fdd7b4c6$export$70435023d0d90129(cloudId, traitName);
    (0, $fLtAn.getCurrentSiteCloudId)().then((resolvedCloudId)=>{
        $5f908bf6fdd7b4c6$export$fed0d3ced5218947(resolvedCloudId, traitName);
    });
    return providerPctMap;
}
module.exports["SOCIAL_PROOF_TRAIT_NAME"] = $5f908bf6fdd7b4c6$export$eb1c7e303b49fcc6;
module.exports["getProviderPctMap"] = $5f908bf6fdd7b4c6$export$fed0d3ced5218947;
module.exports["getProviderPctMapSync"] = $5f908bf6fdd7b4c6$export$70435023d0d90129;
module.exports["getCachedProviderPctMapAndRefresh"] = $5f908bf6fdd7b4c6$export$63f5703c889fdfe6;

});

parcelRegister("hXuY9", function(module, exports) {
/* Icon.tsx generated by @compiled/babel-plugin v2.0.0 */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ 
var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $hyOTw = parcelRequire("hyOTw");

const $cac0f68f685429e5$export$f04a61298a47a40f = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_0bjKvDcjp5 _0jFU0Vey7F _39xV02ey7F _0adFHs1Y8M _20VacPYbGa _1mT5xdWVPG _2IhTon715P _3OE6xY715P _1VJPcaiDnZ",
            __cmplp.className
        ])
    });
});
const $cac0f68f685429e5$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hyOTw.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        testId: testId,
        style: skeletonCustomStyles
    });
};
module.exports["Shimmer"] = $cac0f68f685429e5$export$809644b82cfe94b1;

});


$parcel$global.rlb("3oAU3")
//# sourceMappingURL=component-lazy.d63dfea2.js.map
